window.slate = window.slate || {};
window.theme = window.theme || {};
/*================ String ================*/
/**
 *
 * @param {str} str
 * str is like "Color.Juste Le Rayé Gris,Taille.140x190|
 * Color.Juste Le Rayé Gris,Taille.200x200|
 * Color.Juste Le Rayé Gris,Taille.50x70"
 * @returns
 * [
 *  {
 *    color: 'Juste Le Rayé Gris',
 *    taille: '140x190'
 *  }
 * ]
 */
String.prototype.ToArrayObjects = function() {
  if(!this.includes('|') && !this.includes(',') && !this.includes('.')) return [];
  try {
    const obj = {};
    let output = [];
    let strArray = this.split('|');
    for(let i = 0; i < strArray.length; i++){
      let tempProps = strArray[i].split(',');
      for(let k = 0;k < tempProps.length; k++){
        let key = tempProps[k].split('.')[0];
        let value = tempProps[k].split('.')[1];
        obj[key.toLocaleLowerCase()] = value;
      }
      output.push(obj)
    }
    return output;
  } catch (error) {
    return [];
  }
}

/*================ Array ================*/
/**
 * Array helpers and prototypes for the Shopify Cart and others
 */

/**
 * Find a given word on an given reference array in a 2 dimensions array matching all the elements
 * and indexes
 */
Array.prototype.twoDeepExists =  function(find){
  const arrayLength = this.length;
  let findedItems = 0;
	for(let i = 0; i < arrayLength; i++){
		for(let k = 0; k < this[i].length; k++){
      const array_text = this[i][k].toLowerCase()
    	if(array_text === find.toLowerCase()){
        findedItems++;
      }
  	}
  }
  return findedItems === arrayLength ? true : false;
}

Array.prototype.twoDeepColorExistsWithExceptions = function(find, exceptions){
  let exception = {};
  let findedItems = 0;
  let colorFound = false;
  let exceptionFound = false;
  for(let pos = 0; pos < exceptions?.length; pos++){
    for(const [key,value] of Object.entries(exceptions[pos])){
      if(key == 'secondaryColor' && value == find){
        exception = exceptions[pos];
        exceptionFound = true;
        break;
      }
    }
    if(exceptionFound) break;
  }
  const arrayLength = this.length;
  let reviewed = false;
  for(let i = 0 ; i < arrayLength; i++){
    for(let k = 0; k < this[i].length ; k++){
      if(this[i][k] == find){
        colorFound = true;
        break;
      } else if(reviewed && this[i][k] == exception.primaryColor){
        colorFound = true;
        break;
      }
    }
    if(!colorFound && exceptionFound && !reviewed){
      i--;
      reviewed = true
    }else if(!colorFound) {
      colorFound = false;
      break;
    }
  }
  return colorFound;
}

Array.prototype.twoDeepColorExists =  function(find){
  const arrayLength = this.length;
  let findedItems = 0;
	for(let i = 0; i < arrayLength; i++){
		for(let k = 0; k < this[i].length; k++){
    	if(this[i][k].color === find && this[i][k].available){
        findedItems++;
      }
  	}
  }
  return findedItems === arrayLength ? true : false;
};

Array.prototype.validateAvailableItems =  function(find){
  const arrayLength = this.length;
  let findedItems = true;
	for(let i = 0; i < arrayLength; i++){
    let allowDrawInFront = false;
		for(let k = 0; k < this[i].length; k++){
    	if(this[i][k].color === find && this[i][k].available){
        allowDrawInFront = true;
        break;
      }
  	}
    if(!allowDrawInFront){
      findedItems = false;
      break;
    }
  }
  return findedItems;
};
/*================ Shop ================*/
/**
 * create shop have the purpose to ease the get variants and update url, unavailable items ....
 */

class Shop{
  constructor(){
    this.variants = new Map();
  }

  addVariant(variant){
    this.variants.set(variant.name, variant);
  }
  cleanVariants(){
    this.variants.clear();
  }
  toArray(){
    const output = [];
    this.variants.forEach(value => {
      output.push(value);
    })
    return output;
  }
}

const shop = new Shop();
/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function ($element) {
    var focusClass = "js-focus-hidden";

    $element
      .first()
      .attr("tabIndex", "-1")
      .focus()
      .addClass(focusClass)
      .one("blur", callback);

    function callback() {
      $element.first().removeClass(focusClass).removeAttr("tabindex");
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function () {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function () {
    $("a[href*=#]").on(
      "click",
      function (evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function (options) {
    var eventName = options.namespace
      ? "focusin." + options.namespace
      : "focusin";

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr("tabindex", "-1");
    options.$elementToFocus.focus();

    $(document).on(eventName, function (evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function (options) {
    var eventName = options.namespace
      ? "focusin." + options.namespace
      : "focusin";

    if (options.$container && options.$container.length) {
      options.$container.removeAttr("tabindex");
    }

    $(document).off(eventName);
  },
};

/**
 *
 */
(function (){
  document.addEventListener('DOMContentLoaded', function(){
    const slider = document.querySelector('[data-product-slider]');
    if(!slider) return;
    slider.style.backgroundColor = "white";
  })
})();


/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function () {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = "testcookie";
      cookieEnabled = document.cookie.indexOf("testcookie") !== -1;
    }
    return cookieEnabled;
  },
};

async function getCountry() {
  try {
    let response = await fetch('https://pro.ip-api.com/json/?key=mCnyl25bWVyU1q6&fields=status,message,country,countryCode3,query');

    if (!response.ok) {
      throw new Error('Error response country');
    }

    let countryData = await response.json();

    if (!countryData.countryCode3) {
      throw new Error('No countrycode found.');
    }

    return countryData.countryCode3;
  } catch (err) {
    console.log(err);
    return err;
  }
}

function setBannerData(element, data) {
  if (!element) return;

  element.querySelector('.redirection-banner-message').innerHTML = data.message;
  element.querySelector('.redirection-banner-button-desktop-message').innerHTML = data.buttonDesktopMessage;
  element.querySelector('.redirection-banner-button-mobile-message').innerHTML = data.buttonMobileMessage;
  element.querySelector('.suggest-flag-redirection').src = data.flagUrl;
  element.querySelector('.redirection-banner-url').href = data.homePageUrl;

  element.classList.remove('hide');
  element.classList.add('redirection-banner');
}

function getRedirectionBannerData(element, prefix) {
  let outData = {};
  let flagPrefix = '';

  if (prefix == 'nl') {
    flagPrefix = prefix;
  } else {
    flagPrefix = 'be';
  }

  outData.message = element.getAttribute('data-' + prefix + '-message');
  outData.buttonDesktopMessage = element.getAttribute('data-' + prefix + '-desktop-button');
  outData.buttonMobileMessage = element.getAttribute('data-' + prefix + '-mobile-button');
  outData.homePageUrl = element.getAttribute('data-' + prefix + '-home-page');
  outData.flagUrl = element.getAttribute('data-' + flagPrefix + '-flag');

  return outData;
}

function setWhiteHeader(element) {
  element.classList.remove('header--transparent');
  element.classList.add('header--normal');
}

function isBENL(countryOrigin, browserLanguage) {
  return countryOrigin == 'BEL' && (browserLanguage === 'nl' || browserLanguage === 'nl-BE');
}

function isBEFR(countryOrigin, browserLanguage) {
  return countryOrigin == 'BEL' && !(browserLanguage === 'nl' || browserLanguage === 'nl-BE');
}

function isNL(countryOrigin) {
  return countryOrigin == 'NLD';
}

(async function () {
  const browserLanguage = window.navigator.language || navigator.browserLanguage;
  const countriesRedirection = ['BEL', 'NLD'];
  const redirectionClosed = sessionStorage.getItem('redirection-closed');
  let countryOrigin = sessionStorage.getItem('country_origin');

  if (countryOrigin && redirectionClosed) return;

  //get the country origin
  if (!countryOrigin) {
    countryOrigin = await getCountry();
    sessionStorage.setItem('country_origin', countryOrigin);
  }

  if (!countriesRedirection.includes(countryOrigin)) return;

  const header = document.querySelector('header');
  const redirectionBannerElement = document.querySelector('[data-redirection-banner]');
  const closeRedirectionBanner = redirectionBannerElement.querySelector('.redirection-banner-close');

  closeRedirectionBanner.addEventListener('click', function () {
    sessionStorage.setItem('redirection-closed', '1');

    redirectionBannerElement.classList.remove('redirection-banner');
    redirectionBannerElement.classList.add('hide');
  });

  //suggest NL
  if (isNL(countryOrigin)) {
    setBannerData(
      redirectionBannerElement,
      getRedirectionBannerData(redirectionBannerElement, 'nl')
    );

    setWhiteHeader(header);
  }

  //suggest BENL
  if (isBENL(countryOrigin, browserLanguage)) {
    setBannerData(
      redirectionBannerElement,
      getRedirectionBannerData(redirectionBannerElement, 'benl')
    );

    setWhiteHeader(header);
  }

  //suggest BEFR
  if (isBEFR(countryOrigin, browserLanguage)) {
    setBannerData(
      redirectionBannerElement,
      getRedirectionBannerData(redirectionBannerElement, 'befr')
    );

    setWhiteHeader(header);
  }

})();


var selectors = {
  totalPrice: "[data-cart-total-price]",
  acceptText: "[data-accept-text]",
};

$("[data-checkout-button]").click(function (e) {
  // console.log($('[data-accept]').is(':checked'));
  if ($("[data-accept]").is(":checked") == false) {
    e.preventDefault();
    $(selectors.acceptText).css("opacity", 1);
  }
});

$(function () {
  if (window.Shopify && Shopify.StorefrontExpressButtons) {
    Shopify.StorefrontExpressButtons.initialize();
  }
});

$("[data-accept]").change(function () {
  if ($(this).is(":checked")) {
    $("[data-checkout-button]").removeClass("button--disabled");
    $(selectors.acceptText).css("opacity", 0);
  } else {
    $("[data-checkout-button]").addClass("button--disabled");
    $(selectors.acceptText).css("opacity", 1);
  }
});
$("[data-cart-remove-index]").click(function () {
  var index = $(this).attr("data-cart-remove-index");
  CartJS.removeItem(index, 0);
  setTimeout(function () {
    window.location.reload();
  }, 500);
});

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function (array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function (array, key, value) {
    var i = array.length;
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function (array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function (value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  },
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function (options) {
    var tableWrapperClass =
      typeof options.tableWrapperClass === "undefined"
        ? ""
        : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function (options) {
    var iframeWrapperClass =
      typeof options.iframeWrapperClass === "undefined"
        ? ""
        : options.iframeWrapperClass;

    options.$iframes.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  },
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on("shopify:section:load", this._onSectionLoad.bind(this))
    .on("shopify:section:unload", this._onSectionUnload.bind(this))
    .on("shopify:section:select", this._onSelect.bind(this))
    .on("shopify:section:deselect", this._onDeselect.bind(this))
    .on("shopify:section:reorder", this._onReorder.bind(this))
    .on("shopify:block:select", this._onBlockSelect.bind(this))
    .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var $container = $(container);
    var id = $container.attr("data-section-id");
    var type = $container.attr("data-section-type");

    constructor = constructor || this.constructors[type];
    if (typeof constructor === "undefined") {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = $("[data-section-id]", evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === "function") {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );
  },

  _onSelect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onSelect === "function") {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onDeselect === "function") {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onReorder === "function") {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onBlockSelect === "function") {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onBlockDeselect === "function") {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    $("[data-section-type=" + type + "]").each(
      function (index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = "${{amount}}";

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ",");
      decimal = slate.utils.defaultTo(decimal, ".");

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney,
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function () {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === "string") {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    if (src != undefined)
      var match = src.match(
        /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
      );

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === "master") {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + "_" + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, "");
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol,
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on(
      "change",
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = $.extend({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function () {
      var currentOptions = $.map(
        $(this.singleOptionSelector, this.$container),
        function (element) {
          var $element = $(element);
          var type = $element.attr("type");
          var currentOption = {};

          if (type === "radio" || type === "checkbox") {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data("index");

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data("index");

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function (variant) {
        var satisfied = true;

        selectedValues.forEach(function (option) {
          if (satisfied) {
            satisfied = option.value === variant[option.index];
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function () {
      //console.log('Select change');
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: "variantChange",
        variant: variant,
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function (variant) {
      if (!variant.featured_image || variant.option1 === this.currentVariant.option1 || !this.product.options.includes("Color")) {
        return;
      }
      //console.log('Variant image change');
      this.$container.trigger({
        type: "variantImageChange",
        variant: variant,
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant) {
      // if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
      //   return;
      // }
      //console.log('Update price');

      this.$container.trigger({
        type: "variantPriceChange",
        variant: variant,
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function (variant) {
      const urlParams = new URLSearchParams(window.location.search);
      let urlModalParam = '';

      if (urlParams.get('modal') && !window.isAbTest) {
        window.isAbTest = true;
      }

      if(urlParams.get("type")){
        window.hasTypeAbTest = true;
      }

      if(window.isAbTest) {
        urlModalParam = '&modal=cross';
      }

      if(window.hasTypeAbTest) {
        urlModalParam += '&type=color';
      }

      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?variant=" +
        variant.id +
        urlModalParam;
      window.history.replaceState({ path: newurl }, "", newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    },
  });

  return Variants;
})();

/*================ General ================*/
(function () {
  "use strict";

  var doT = {
    name: "doT",
    version: "1.1.1",
    templateSettings: {
      evaluate: /\{\$([\s\S]+?(\}?)+)\}\}/g,
      interpolate: /\{\$=([\s\S]+?)\}\}/g,
      encode: /\{\$!([\s\S]+?)\}\}/g,
      use: /\{\$#([\s\S]+?)\}\}/g,
      useParams:
        /(^|[^\w$])def(?:\.|\[[\'\"])([\w$\.]+)(?:[\'\"]\])?\s*\:\s*([\w$\.]+|\"[^\"]+\"|\'[^\']+\'|\{[^\}]+\})/g,
      define: /\{\$##\s*([\w\.$]+)\s*(\:|=)([\s\S]+?)#\}\}/g,
      defineParams: /^\s*([\w$]+):([\s\S]+)/,
      conditional: /\{\$\?(\?)?\s*([\s\S]*?)\s*\}\}/g,
      iterate:
        /\{\$~\s*(?:\}\}|([\s\S]+?)\s*\:\s*([\w$]+)\s*(?:\:\s*([\w$]+))?\s*\}\})/g,
      varname: "zerance",
      strip: true,
      append: true,
      selfcontained: false,
      doNotSkipEncoded: false,
    },
    template: undefined, //fn, compile template
    compile: undefined, //fn, for express
    log: true,
  },
    _globals;

  doT.encodeHTMLSource = function (doNotSkipEncoded) {
    var encodeHTMLRules = {
      "&": "&#38;",
      "<": "&#60;",
      ">": "&#62;",
      '"': "&#34;",
      "'": "&#39;",
      "/": "&#47;",
    },
      matchHTML = doNotSkipEncoded ? /[&<>"'\/]/g : /&(?!#?\w+;)|<|>|"|'|\//g;
    return function (code) {
      return code
        ? code.toString().replace(matchHTML, function (m) {
          return encodeHTMLRules[m] || m;
        })
        : "";
    };
  };

  _globals = (function () {
    return this || (0, eval)("this");
  })();

  /* istanbul ignore else */
  if (typeof module !== "undefined" && module.exports) {
    module.exports = doT;
  } else if (typeof define === "function" && define.amd) {
    define(function () {
      return doT;
    });
  } else {
    _globals.doT = doT;
  }

  var startend = {
    append: { start: "'+(", end: ")+'", startencode: "'+encodeHTML(" },
    split: {
      start: "';out+=(",
      end: ");out+='",
      startencode: "';out+=encodeHTML(",
    },
  },
    skip = /$^/;

  function resolveDefs(c, block, def) {
    return (typeof block === "string" ? block : block.toString())
      .replace(c.define || skip, function (m, code, assign, value) {
        if (code.indexOf("def.") === 0) {
          code = code.substring(4);
        }
        if (!(code in def)) {
          if (assign === ":") {
            if (c.defineParams)
              value.replace(c.defineParams, function (m, param, v) {
                def[code] = { arg: param, text: v };
              });
            if (!(code in def)) def[code] = value;
          } else {
            new Function("def", "def['" + code + "']=" + value)(def);
          }
        }
        return "";
      })
      .replace(c.use || skip, function (m, code) {
        if (c.useParams)
          code = code.replace(c.useParams, function (m, s, d, param) {
            if (def[d] && def[d].arg && param) {
              var rw = (d + ":" + param).replace(/'|\\/g, "_");
              def.__exp = def.__exp || {};
              def.__exp[rw] = def[d].text.replace(
                new RegExp("(^|[^\\w$])" + def[d].arg + "([^\\w$])", "g"),
                "$1" + param + "$2"
              );
              return s + "def.__exp['" + rw + "']";
            }
          });
        var v = new Function("def", "return " + code)(def);
        return v ? resolveDefs(c, v, def) : v;
      });
  }

  function unescape(code) {
    return code.replace(/\\('|\\)/g, "$1").replace(/[\r\t\n]/g, " ");
  }

  doT.template = function (tmpl, c, def) {
    c = c || doT.templateSettings;
    var cse = c.append ? startend.append : startend.split,
      needhtmlencode,
      sid = 0,
      indv,
      str = c.use || c.define ? resolveDefs(c, tmpl, def || {}) : tmpl;

    str = (
      "var out='" +
      (c.strip
        ? str
          .replace(/(^|\r|\n)\t* +| +\t*(\r|\n|$)/g, " ")
          .replace(/\r|\n|\t|\/\*[\s\S]*?\*\//g, "")
        : str
      )
        .replace(/'|\\/g, "\\$&")
        .replace(c.interpolate || skip, function (m, code) {
          return cse.start + unescape(code) + cse.end;
        })
        .replace(c.encode || skip, function (m, code) {
          needhtmlencode = true;
          return cse.startencode + unescape(code) + cse.end;
        })
        .replace(c.conditional || skip, function (m, elsecase, code) {
          return elsecase
            ? code
              ? "';}else if(" + unescape(code) + "){out+='"
              : "';}else{out+='"
            : code
              ? "';if(" + unescape(code) + "){out+='"
              : "';}out+='";
        })
        .replace(c.iterate || skip, function (m, iterate, vname, iname) {
          if (!iterate) return "';} } out+='";
          sid += 1;
          indv = iname || "i" + sid;
          iterate = unescape(iterate);
          return (
            "';var arr" +
            sid +
            "=" +
            iterate +
            ";if(arr" +
            sid +
            "){var " +
            vname +
            "," +
            indv +
            "=-1,l" +
            sid +
            "=arr" +
            sid +
            ".length-1;while(" +
            indv +
            "<l" +
            sid +
            "){" +
            vname +
            "=arr" +
            sid +
            "[" +
            indv +
            "+=1];out+='"
          );
        })
        .replace(c.evaluate || skip, function (m, code) {
          return "';" + unescape(code) + "out+='";
        }) +
      "';return out;"
    )
      .replace(/\n/g, "\\n")
      .replace(/\t/g, "\\t")
      .replace(/\r/g, "\\r")
      .replace(/(\s|;|\}|^|\{)out\+='';/g, "$1")
      .replace(/\+''/g, "");
    //.replace(/(\s|;|\}|^|\{)out\+=''\+/g,'$1out+=');

    if (needhtmlencode) {
      if (!c.selfcontained && _globals && !_globals._encodeHTML)
        _globals._encodeHTML = doT.encodeHTMLSource(c.doNotSkipEncoded);
      str =
        "var encodeHTML = typeof _encodeHTML !== 'undefined' ? _encodeHTML : (" +
        doT.encodeHTMLSource.toString() +
        "(" +
        (c.doNotSkipEncoded || "") +
        "));" +
        str;
    }
    try {
      return new Function(c.varname, str);
    } catch (e) {
      /* istanbul ignore else */
      if (typeof console !== "undefined")
        console.log("Could not create a template function: " + str);
      throw e;
    }
  };

  doT.compile = function (tmpl, def) {
    return doT.template(tmpl, null, def);
  };
})();

/*================ Sections ================*/
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
(function (factory) {
  var registeredInModuleLoader;
  if (typeof define === "function" && define.amd) {
    define(factory);
    registeredInModuleLoader = true;
  }
  if (typeof exports === "object") {
    module.exports = factory();
    registeredInModuleLoader = true;
  }
  if (!registeredInModuleLoader) {
    var OldCookies = window.Cookies;
    var api = (window.Cookies = factory());
    api.noConflict = function () {
      window.Cookies = OldCookies;
      return api;
    };
  }
})(function () {
  function extend() {
    var i = 0;
    var result = {};
    for (; i < arguments.length; i++) {
      var attributes = arguments[i];
      for (var key in attributes) {
        result[key] = attributes[key];
      }
    }
    return result;
  }

  function decode(s) {
    return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
  }

  function init(converter) {
    function api() { }

    function set(key, value, attributes) {
      if (typeof document === "undefined") {
        return;
      }

      attributes = extend(
        {
          path: "/",
        },
        api.defaults,
        attributes
      );

      if (typeof attributes.expires === "number") {
        attributes.expires = new Date(
          new Date() * 1 + attributes.expires * 864e5
        );
      }

      // We're using "expires" because "max-age" is not supported by IE
      attributes.expires = attributes.expires
        ? attributes.expires.toUTCString()
        : "";

      try {
        var result = JSON.stringify(value);
        if (/^[\{\[]/.test(result)) {
          value = result;
        }
      } catch (e) { }

      value = converter.write
        ? converter.write(value, key)
        : encodeURIComponent(String(value)).replace(
          /%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
          decodeURIComponent
        );

      key = encodeURIComponent(String(key))
        .replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
        .replace(/[\(\)]/g, escape);

      var stringifiedAttributes = "";
      for (var attributeName in attributes) {
        if (!attributes[attributeName]) {
          continue;
        }
        stringifiedAttributes += "; " + attributeName;
        if (attributes[attributeName] === true) {
          continue;
        }

        // Considers RFC 6265 section 5.2:
        // ...
        // 3.  If the remaining unparsed-attributes contains a %x3B (";")
        //     character:
        // Consume the characters of the unparsed-attributes up to,
        // not including, the first %x3B (";") character.
        // ...
        stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
      }

      return (document.cookie = key + "=" + value + stringifiedAttributes);
    }

    function get(key, json) {
      if (typeof document === "undefined") {
        return;
      }

      var jar = {};
      // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all.
      var cookies = document.cookie ? document.cookie.split("; ") : [];
      var i = 0;

      for (; i < cookies.length; i++) {
        var parts = cookies[i].split("=");
        var cookie = parts.slice(1).join("=");

        if (!json && cookie.charAt(0) === '"') {
          cookie = cookie.slice(1, -1);
        }

        try {
          var name = decode(parts[0]);
          cookie =
            (converter.read || converter)(cookie, name) || decode(cookie);

          if (json) {
            try {
              cookie = JSON.parse(cookie);
            } catch (e) { }
          }

          jar[name] = cookie;

          if (key === name) {
            break;
          }
        } catch (e) { }
      }

      return key ? jar[key] : jar;
    }

    api.set = set;
    api.get = function (key) {
      return get(key, false /* read as raw */);
    };
    api.getJSON = function (key) {
      return get(key, true /* read as json */);
    };
    api.remove = function (key, attributes) {
      set(
        key,
        "",
        extend(attributes, {
          expires: -1,
        })
      );
    };

    api.defaults = {};

    api.withConverter = init;

    return api;
  }

  return init(function () { });
});
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function () {
  var selectors = {
    guideToggle: "[data-toggle-guide]",
    productSlider: "[data-product-slider]",
    productThumbnail: "[data-product-thumbnail]",
    addToCart: "[data-add-to-cart]",
    addToCartText: "[data-add-to-cart-text]",
    comparePrice: "[data-compare-price]",
    comparePriceText: "[data-compare-text]",
    originalSelectorId: "[data-product-select]",
    priceWrapper: "[data-price-wrapper]",
    productFeaturedImage: "[data-product-featured-image]",
    productJson: "[data-product-json]",
    productPrice: "[data-product-price]",
    singleOptionSelector: "[data-single-option-selector]",
    singleOptionTrigger: "[data-single-option-trigger]",
    showPopupSlider: "[data-show-image-popup]",
    showVideoSlider: "[data-show-video-popup]",
    hideImagePopup: "[data-hide-image-popup]",
    popupSlider: "[data-popup-slider]",
    popupThumbnail: "[data-popup-thumbnail]",

    cardOption: "[data-option-value]",
    optionContainer: "[data-option-container]",
    cardOptionTrigger: "[data-card-option-trigger]",

    variantUnavailable: "[data-variant-unavailable]",
    variantText: "[data-variant-text]",
    productQuantity: "[data-product-quantity]",
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);
    var self = this;

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr("data-section-id");
    this.productSingleObject = JSON.parse(
      $(selectors.productJson, this.$container).html()
    );
    this.imagesObject = product_images;

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data("enable-history-state") || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject,
    };

    this.settings = {};
    this.namespace = ".product";
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);
    this.settings.imageSize = slate.Image.imageSize(
      this.$featuredImage.attr("src")
    );
    slate.Image.preload(
      this.productSingleObject.images,
      this.settings.imageSize
    );
    this.$container.on(
      "variantChange" + this.namespace,
      this.updateAddToCartState.bind(this)
    );
    this.$container.on(
      "variantPriceChange" + this.namespace,
      this.updateProductPrices.bind(this)
    );

    this.$container.on(
      "variantImageChange" + this.namespace,
      this.updateProductImage.bind(this)
    );

    var self = this;

    this.initVariantsTrigger();
    this.initImageSlider();
    this.initPopupSlider();
    this.setDeliveryDate();
    this.updateStocksDisplay();
    $(selectors.showPopupSlider).click(this.showPopupSlider.bind(this));
    $(selectors.showVideoSlider).click(this.showVideoSlider.bind(this));
    $(selectors.hideImagePopup).click(this.hidePopupSlider.bind(this));
    $(selectors.productQuantity).change(function () {
      $(selectors.singleOptionSelector).trigger("change");
    });
    $(selectors.singleOptionSelector).trigger("change");
    $("[data-special-color]").each(function () {
      if ($(this).children().length <= 0) $(this).prev().hide();
    });
  }

  Product.prototype = $.extend({}, Product.prototype, {
    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */

    updateAddToCartState: function (evt) {
      var variant = evt.variant;
      var self = this;

      if (variant) {
        $(selectors.variantUnavailable).hide();
        $(selectors.priceWrapper, this.$container).removeClass("hide");
      } else {
        $(selectors.variantUnavailable).show();
        $(selectors.addToCart, this.$container).prop("disabled", true);
        $(selectors.addToCart, this.$container).addClass("button--reverse");
        $(selectors.addToCart, this.$container).addClass("button--disabled");
        $(selectors.addToCartText, this.$container).html(
          theme.strings.unavailable
        );
        $(selectors.priceWrapper, this.$container).addClass("hide");
        return;
      }

      if (variant.available) {
        $(selectors.variantUnavailable).hide();
        $(selectors.addToCart, this.$container).prop("disabled", false);
        $(selectors.addToCart, this.$container).removeClass("button--reverse");
        $(selectors.addToCart, this.$container).removeClass("button--disabled");
        $(selectors.addToCartText, this.$container).html(
          theme.strings.addToCart
        );
      } else {
        $(selectors.variantUnavailable).show();
        $(selectors.addToCart, this.$container).prop("disabled", true);
        $(selectors.addToCart, this.$container).addClass("button--reverse");
        $(selectors.addToCart, this.$container).addClass("button--disabled");
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
      //console.log('Variant : ', variant);
      this.updateStocksDisplay(variant);
    },

    // Gére les affichages concernant les stocks. Impossible si + de 2 options
    updateStocksDisplay: function (variant) {
      var self = this;
      if (!variant) return;
      $(selectors.singleOptionTrigger).each(function () {
        if (
          $(this).attr("data-option-value") == variant.option1 ||
          $(this).attr("data-option-value") == variant.option2
        ) {
          $(this).addClass("selected");
        } else {
          $(this).removeClass("selected");
        }
      });
      if (self.productSingleObject.options.length == 2 ||
          (self.productSingleObject.options.length == 1 &&
            self.productSingleObject.options[0] == "Color")) {
        $(selectors.optionContainer).each(function () {
          $(this)
            .find(selectors.cardOptionTrigger)
            .each(function () {
              if ($(this).hasClass("selected")) {
                // Gère l'affichage des stocks
                var selectedOption = $(this).attr("data-option-value");
                // Modifier le nom de la variante couleur
                if ($(this).attr("data-option") == "Color") {
                  var color = selectedOption;
                  if (variant && variant.option1) color = variant.option1;
                  $(selectors.variantText).html(" : " + color);
                  // if($(this).parent().get(0).hasAttribute('data-special-color')){
                  // 	$(selectors.variantText).hide();
                  // 	$('[data-special-color]').prev().find(selectors.variantText).show();
                  // }else{
                  $(selectors.variantText).show();
                  // 	$('[data-special-color]').prev().find(selectors.variantText).hide();
                  // }
                }

                const isBundleEnsemble = Boolean(document.querySelector('[bundle-ensemble]'));
                if(!isBundleEnsemble){
                  $(selectors.cardOption).each(function () {
                    var option = $(this).attr("data-option-value");
                    for (
                      var i = 0;
                      i < self.productSingleObject.variants.length;
                      i++
                    ) {
                      var variant = self.productSingleObject.variants[i];
                      if (
                        (variant.option1 == selectedOption &&
                          variant.option2 == option) ||
                        (variant.option2 == selectedOption &&
                          variant.option1 == option)
                      ) {
                        if (variant.available) {
                          $(this).removeClass("unavailable");
                        } else {
                          $(this).addClass("unavailable");
                        }
                      }
                    }
                  });
                }
              }
            });
        });
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function (evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(
        selectors.comparePriceText,
        this.$container
      );

      var totalPrice = variant.price * $(selectors.productQuantity).val();
      //console.log('New total Price', totalPrice);
      $(selectors.productPrice, this.$container).each(function () {
        $(this).html(slate.Currency.formatMoney(totalPrice, theme.moneyFormat));
      });

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(
          slate.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          )
        );
        $compareEls.removeClass("hide");
      } else {
        $comparePrice.html("");
        $compareEls.addClass("hide");
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function (evt) {
      // console.log('Update product image');
      // console.log(evt);
      var variant = evt.variant;

      this.destroyImageSlider();
      this.destroyPopupSlider();
      this.buildImageSlider(variant);
      this.buildPopupSlider(variant);
      var sizedImgUrl = slate.Image.getSizedImageUrl(
        variant.featured_image.src,
        this.settings.imageSize
      );
    },

    destroyImageSlider: function () {
      $(selectors.productSlider).css("opacity", 0);
      $(selectors.productThumbnail).css("opacity", 0);

      if (this.$productSlider.flickity) {
        this.$productSlider.flickity("destroy");
      }
      this.$productSlider.html("");
      if (this.$productThumbnail.flickity) {
        this.$productThumbnail.flickity("destroy");
      }
      this.$productThumbnail.html("");
    },

    buildImageSlider: function (variant) {
      const parseHtmlEnteties = (str) => {
        return str.replace(/&#([0-9]{1,3});/gi, function(match, numStr) {
            var num = parseInt(numStr, 10); // read num as normal number
            return String.fromCharCode(num);
        });
      }
      var image,
        sliderHtml = "",
        thumbnailHtml = "";
      for (var i = 0; i < this.imagesObject.length; i++) {
        image = this.imagesObject[i];
        if (parseHtmlEnteties(image.alt) === variant.option1) {
          sliderHtml +=
            '<div class="carousel-cell full-width"><img class="product__slider-image" data-show-image-popup src="' +
            image.src +
            '" alt="' +
            image.alt +
            '"></div>';
          thumbnailHtml +=
            '<div class="carousel-cell"><div class="thumbnail thumbnail--circled" style="background-image:url(' +
            image.src +
            ')"></div></div>';
        }
      }
      // if(product_video_url && product_video_image){
      //   sliderHtml += '<div class="carousel-cell full-width"><img data-show-image-popup class="product__slider-image" src="' + product_video_image + '" alt="{{ image.alt | escape }}"></div>';
      //   thumbnailHtml += '<div class="carousel-cell"><div class="thumbnail thumbnail--circled" style="background-image:url(\'' + product_video_image + '\')"></div></div>';
      // }
      this.$productSlider.html(sliderHtml);
      this.$productThumbnail.html(thumbnailHtml);
      this.initImageSlider();
    },

    initImageSlider: function () {
      var self = this;

      this.$productSlider = $(selectors.productSlider).flickity({
        wrapAround: true,
        imagesLoaded: true,
        pageDots: true,
        groupCells: 1,
        contain: true,
        cellAlign: "left",
        arrowShape: { x0: 30, x1: 60, y1: 25, x2: 65, y2: 25, x3: 35 },
      });

      this.$productSlider.on("ready.flickity", function () {
        self.$productSlider.resize();
        $(selectors.productSlider).css("opacity", 1);
        $(selectors.productThumbnail).css("opacity", 1);
        setTimeout(function () { }, 100);
      });

      this.$productThumbnail = $(selectors.productThumbnail).flickity({
        asNavFor: ".product__slider",
        prevNextButtons: false,
        pageDots: false,
        groupCells: true,
      });
      $(selectors.showPopupSlider).click(this.showPopupSlider.bind(this));
      $(selectors.hideImagePopup).click(this.hidePopupSlider.bind(this));
    },

    initVariantsTrigger: function () {
      $(selectors.singleOptionTrigger).click(function () {
        $(this).prev().click();
        $(this)
          .parents(".selector-wrapper")
          .find(selectors.singleOptionTrigger)
          .each(function () {
            $(this).removeClass("selected");
          });
        $(this).addClass("selected");
      });
    },
    destroyPopupSlider: function () {
      $(selectors.popupSlider).css("opacity", 0);
      $(selectors.popupThumbnail).css("opacity", 0);

      if (this.$popupSlider.flickity) {
        this.$popupSlider.flickity("destroy");
      }
      this.$popupSlider.html("");
      if (this.$popupThumbnail.flickity) {
        this.$popupThumbnail.flickity("destroy");
      }
      this.$popupThumbnail.html("");
    },
    hidePopupSlider: function () {
      $(".product__popup-container").removeClass(
        "product__popup-container--activated"
      );
    },
    showPopupSlider: function () {
      //console.log('Show popup slider');
      $(".product__popup-container").addClass(
        "product__popup-container--activated"
      );
    },
    showVideoSlider: function () {
      //console.log('Show popup slider');
      var length = $("[data-product-thumbnail] .carousel-cell").length;
      this.$popupSlider.flickity("select", length - 1);
      $(".product__popup-container").addClass(
        "product__popup-container--activated"
      );
    },
    buildPopupSlider: function (variant) {
      var image,
        sliderHtml = "",
        thumbnailHtml = "";
      for (var i = 0; i < this.imagesObject.length; i++) {
        image = this.imagesObject[i];
        if (image.alt === variant.option1) {
          sliderHtml +=
            '<div class="carousel-cell full-width"><img class="product__slider-image" src="' +
            image.src +
            '" alt="' +
            image.alt +
            '"></div>';
          thumbnailHtml +=
            '<div class="carousel-cell"><div class="thumbnail thumbnail--circled" style="background-image:url(' +
            image.src +
            ')"></div></div>';
        }
      }
      // if(product_video_url && product_video_image){
      //   sliderHtml += '<div class="carousel-cell full-width"><video class="product__video" autoplay loop controls><source src="' + product_video_url + '" type="video/mp4"><p>Votre navigateur ne prend pas en charge les vidéos HTML5.</video></div>';
      //   thumbnailHtml += '<div class="carousel-cell"><div class="thumbnail thumbnail--circled" style="background-image:url(\'' + product_video_image + '\')"></div></div>';
      // }
      this.$popupSlider.html(sliderHtml);
      this.$popupThumbnail.html(thumbnailHtml);
      this.initPopupSlider();
    },

    initPopupSlider: function () {
      var self = this;

      this.$popupSlider = $(selectors.popupSlider).flickity({
        sync: ".product__slider",
        wrapAround: true,
        imagesLoaded: true,
        pageDots: true,
        groupCells: 1,
        contain: true,
        cellAlign: "left",
        arrowShape: { x0: 30, x1: 60, y1: 25, x2: 65, y2: 25, x3: 35 },
      });

      this.$popupSlider.on("ready.flickity", function () {
        self.$popupSlider.resize();
        $(selectors.popupSlider).css("opacity", 1);
        $(selectors.popupThumbnail).css("opacity", 1);
      });

      this.$popupThumbnail = $(selectors.popupThumbnail).flickity({
        asNavFor: ".product__slider--popup",
        prevNextButtons: false,
        pageDots: false,
        groupCells: true,
      });
      $(".product__popup").click(function (event) {
        event.stopPropagation();
      });
    },
    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function () {
      this.$container.off(this.namespace);
    },
    /**
     * Function for set estimated delivery date in products pages
     * @author rgranados
     * @returns {HTMLElement} data delivery date HTML
     */
    setDeliveryDate: function () {
      const date = new Date();
      const weekDay = date.getDay();
      const hours = date.getHours();
      const isWeekend = weekDay % 6 == 0;
      /**Validation for end year shipping estimation (2022) */
      const specialDeliveriesData = document.querySelector('#special-deliveries-data');
      const isEnabled = Boolean(specialDeliveriesData.getAttribute('special-deliveries-enable'));
      const start = new Date(specialDeliveriesData.getAttribute('special-deliveries-starting-date'));
      const end = new Date(specialDeliveriesData.getAttribute('special-deliveries-final-date'));
      const shippingDays = Number(specialDeliveriesData.getAttribute('special-deliveries-shipping-days'));

      let nextDay = new Date(date);

      if (isEnabled === true && date >= start && date <= end) {
        let count = 0;
        while(count < shippingDays){
          endDate = new Date(date.setDate(date.getDate() + 1));
          if(endDate.getDay() != 0 && endDate.getDay() != 6){
            count++;
          } else {
            endDate.setDate(endDate.getDate() + shippingDays);
          }
        }
        let newDateString = endDate.toLocaleString("fr", {
          weekday: "long",
          day: "numeric",
          month: "long",
        });
        $("[data-delivery-date]").html(newDateString);
      } else {
        if (isWeekend || hours > 12) {
          nextDay.setDate(date.getDate() + 1);
          this.setNextDate(nextDay);
        } else {
          $("[data-delivery-date]").html("aujourd'hui");
        }
      }
    },
    /**
     * Function for set next monday
     * @author rgranados
     * @param {Date} nextDay next date obj
     * @returns {HTMLElement}
     */
    setNextDate: function(nextDay) {
      const nextDayString = nextDay.toLocaleString("fr", { weekday: "long" });
      const nextDateString = nextDay.toLocaleString("fr", {
        weekday: "long",
        day: "numeric",
        month: "long",
      });
      if (
        nextDayString == "vendredi" ||
        nextDayString == "samedi" ||
        nextDayString == "dimanche"
      ) {
        const nextMonday = new Date();
        nextMonday.setDate(
          nextMonday.getDate() + ((1 + 7 - nextMonday.getDay()) % 7)
        );
        const nextMondayString = nextMonday.toLocaleString("fr", {
          weekday: "long",
          day: "numeric",
          month: "long",
        });
        $("[data-delivery-date]").html(nextMondayString);
      } else {
        $("[data-delivery-date]").html(nextDateString);
      }
    },
  });

  return Product;
})();

/**
 * Bundle Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace bundleß
 */

theme.Bundle = (function () {
  var selectors = {
    priceWrapper: "[data-price-wrapper]",
    productJson: "[data-product-json]",
    cardJson: "[data-card-json]",
    card: "[data-card]",
    cardPlus: "[data-card-plus]",
    cardMinus: "[data-card-minus]",
    cardToggle: "[data-card-toggle]",
    productFeaturedImage: "[data-product-featured-image]",

    cardOptionValue: "[data-card-option-value]",
    cardOptionTrigger: "[data-card-option-trigger]",
    optionContainer: "[data-option-container]",
    cardOption: "[data-option]",

    bundlePrice: "[data-bundle-price]",
    productSlider: "[data-product-slider]",
    productThumbnail: "[data-product-thumbnail]",
    variantUnavailable: "[data-variant-unavailable]",
    variantText: "[data-variant-text]",

    productSelect: "[data-product-select]",
    productPrice: "[data-product-price]",
    cardPoint: "[data-card-point]",
    showPopupSlider: "[data-show-image-popup]",
    hideImagePopup: "[data-hide-image-popup]",
    popupSlider: "[data-popup-slider]",
    popupThumbnail: "[data-popup-thumbnail]",

    checkoutAdd: "[data-checkout-addtocart]",
    checkoutDisabled: "[data-checkout-disabled]",
    checkoutButton: "[data-add-to-cart]",
    checkoutInfo: "[data-info]",
    lineItemsWrapper: "[data-line-items-wrapper]",
    lineItem: "[data-line-item]",
    productQuantity: "[data-product-quantity]",
  };

  var WORDING = {
    unavailable: "n'est plus disponible dans cette taille",
  };
  /**
   * Bundle section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Bundle(container) {
    this.$container = $(container);

    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr("data-section-id");
    this.productSingleObject = JSON.parse(
      $(selectors.productJson, this.$container).html()
    );
    this.imagesObject = product_images;

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data("enable-history-state") || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject,
    };

    this.cards = [];
    this.productPriceArray = [];
    this.settings = {};
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);
    this.settings.imageSize = slate.Image.imageSize(
      this.$featuredImage.attr("src")
    );
    slate.Image.preload(
      this.productSingleObject.images,
      this.settings.imageSize
    );

    const isMaxiCoussin = Boolean(document.querySelector('[bundle-maxi-coussin]'));
    if (isMaxiCoussin) return;

    this.namespace = ".product-bundle";
    this.setDeliveryDate();
    this.initCards();
    this.initHandlers();
    this.initImages();
    this.parseUrl();

    $("[data-special-color]").each(function () {
      if ($(this).children().length <= 0) $(this).prev().hide();
    });
  }

  Bundle.prototype = $.extend({}, Bundle.prototype, {
    initHandlers: function () {
      $(selectors.checkoutButton).attr("data-disabled", true);
      var self = this;
      // $(selectors.cardPlus).click(function(){
      // 	$(selectors.card).each(function(){
      // 		self.closeCard($(this));
      // 	})
      // 	self.openCard($(this).parents(selectors.card));
      // });
      // $(selectors.cardMinus).click(function(){
      // 	self.closeCard($(this).parents(selectors.card));
      // });
      $(selectors.cardToggle).click(function () {
        // console.log('Toggle card');
        if ($(this).parents("[data-card]").hasClass("card--open")) {
          // console.log('Close card');
          self.closeCard($(this).parents(selectors.card));
        } else {
          // console.log('Open card');
          $(selectors.card).each(function () {
            self.closeCard($(this));
          });
          self.openCard($(this).parents(selectors.card));
        }
      });

      $(selectors.cardOptionTrigger).click(function () {
        $(this)
          .parents(selectors.optionContainer)
          .find(selectors.cardOptionTrigger)
          .each(function () {
            $(this).removeClass("selected");
          });
        $(this).addClass("selected");
        self.updateCardState(
          $(this).parents(selectors.card).attr("data-card-index")
        );
      });
      $(selectors.productQuantity).change(function () {
        self.updateGeneralState();
      });
      $(selectors.checkoutButton).click(function (e) {
        e.preventDefault();
        if (
          $(this).attr("data-disabled") == "true" ||
          $(this).attr("data-disabled") == true
        ) {
          $(selectors.checkoutInfo).show();
        } else {
          $(this).parents("form").submit();
        }
      });

      const swatchColors = $("[data-product-name]");
      for(swatch of swatchColors){
        swatch.addEventListener("click", (e) => {
          if(e.target.classList.contains("swatch-color__icon")){
            for(swatchSelected of swatchColors){
              if(swatchSelected.classList.contains("selected")){
                swatchSelected.classList.remove("selected");
              }
            }
            self.destroyImageSlider();
            self.destroyPopupSlider();
            self.buildImageSlider(e.target.parentNode.getAttribute("data-product-name"));
            self.buildPopupSlider(e.target.parentNode.getAttribute("data-product-name"));
            e.target.parentNode.classList.add("selected");
            $("[data-variant-text]").text(e.target.parentNode.getAttribute("data-product-name"));
          }
        })
      }

    },
    // About card state
    initCards: function () {
      var self = this;
      var index = 0;
      $(selectors.cardJson).each(function () {
        var cardJson = JSON.parse($(this, this.$container).html());
        self.cards.push({
          product: cardJson,
          variant: null,
          isValid: false,
          index: index,
          selector: '[data-card-product="' + cardJson.id + '"]',
        });
        index++;
      });
    },
    updateCardState: function (index) {
      var card = this.cards[index];
      //console.log('Card : ', card);
      // Récupère les variantes de la card
      var variantObject = {};
      $(card.selector)
        .find(selectors.optionContainer)
        .each(function () {
          var optionName = $(this).attr("data-option-container");
          variantObject[optionName] = null;
          $(this)
            .find(selectors.cardOption)
            .each(function () {
              if ($(this).hasClass("selected")) {
                variantObject[optionName] = $(this).attr("data-option");
                if (optionName == "Color") {
                  // console.log("Swatch color")
                  $(card.selector + " " + selectors.variantText).html(
                    " : " + variantObject[optionName]
                  );
                  // if($(this).parent().get(0).hasAttribute('data-special-color')){
                  // 	console.log('test')
                  // 	$(card.selector + ' ' + selectors.variantText).hide();
                  // 	$('[data-special-color]').prev().find(selectors.variantText).show();
                  // }else{
                  // console.log('test2')
                  $(card.selector + " " + selectors.variantText).show();
                  // $('[data-special-color]').prev().find(selectors.variantText).hide();
                  // }
                }
              }
            });
        });

      // Modifie l'objet card
      for (var i = 0; i < card.product.variants.length; i++) {
        var variant = card.product.variants[i];
        if (
          (variant.options[0] == variantObject[card.product.options[0]] &&
            variant.options[1] == variantObject[card.product.options[1]]) ||
          (variant.options[0] == variantObject[card.product.options[1]] &&
            variant.options[0] == variantObject[card.product.options[1]])
        ) {
          card.variant = variant;
          if (variant.available == true) {
            card.isValid = true;
            $(card.selector + " " + selectors.variantUnavailable).hide();
          } else {
            $(card.selector + " " + selectors.variantUnavailable).show();
            card.isValid = false;
          }
        }
      }
      // Change variables in header
      $(card.selector)
        .find(selectors.cardOptionValue)
        .each(function () {
          var option_name = $(this).attr("data-card-option");
          if (option_name == "Color") {
            if (variantObject[option_name]) {
              var background_image = $(
                '[data-option="' +
                variantObject[option_name] +
                '"] .swatch-color__icon'
              ).css("background-image");
              //	background_image = background_image.replace(/.*\s?url\([\'\"]?/, '').replace(/[\'\"]?\).*/, '');
              //console.log('Background-image : ', background_image);
              if (background_image)
                $(this)
                  .find(".swatch-color__icon")
                  .css("background-image", background_image);
              else
                $(this)
                  .find(".swatch-color__icon")
                  .css("background-color", "transparent");
            } else {
              $(this)
                .find(".swatch-color__icon")
                .css("background-color", "transparent");
            }
          } else {
            if (variantObject[option_name]) {
              $(this).html(variantObject[option_name]);
            } else {
              $(this).html("");
            }
          }
        });
      // Gére les affichages concernant les stocks. Impossible si + de 2 options
      if (card.product.options.length == 2) {

        var count = 0;
        $(card.selector + " " + selectors.optionContainer).each(function () {
          $(this)
            .find(selectors.cardOptionTrigger)
            .each(function () {
              if ($(this).hasClass("selected")) {
                var selectedOption = $(this).attr("data-option");
                $(card.selector + " " + selectors.cardOption).each(function () {
                  var option = $(this).attr("data-option");
                  for (var i = 0; i < card.product.variants.length; i++) {
                    var variant = card.product.variants[i];
                    if (
                      (variant.option1 == selectedOption &&
                        variant.option2 == option) ||
                      (variant.option2 == selectedOption &&
                        variant.option1 == option)
                    ) {
                      if (variant.available) {
                        $(this).removeClass("unavailable");
                      } else {
                        $(this).addClass("unavailable");
                      }
                    }
                  }
                });
              }
            });
        });
      }
      // Open next
      if (card.isValid) {
        var next = 0;
        var next = parseInt(index) + 1;
        //$('[data-card-index="' + next + '"] [data-card-toggle]').click();
        $(card.selector)
          .parents(".card__wrapper")
          .find(selectors.cardPoint)
          .addClass("card__point--validated");
      } else {
        $(card.selector)
          .parent()
          .find(selectors.cardPoint)
          .removeClass("card__point--validated");
      }
      // console.log('Variant object : ', variantObject);
      // console.log('Card after : ', card);

      // Update product image
      if (variantObject["Color"]) {
        this.destroyImageSlider();
        this.destroyPopupSlider();
        this.buildImageSlider(variantObject["Color"]);
        this.buildPopupSlider(variantObject["Color"]);
      }

      // Update general state
      this.updateGeneralState();
      // TODO : si la carte est validée, cocher le rond comme validé et ouvrir la suivante.
    },
    openCard: function (card) {
      var self = this;
      if (!card.hasClass("card--open")) {
        card.addClass("card--open");
        //console.log('Open card ', card);
        card
          .find('[data-option-container="Color"] [data-card-option-trigger]')
          .each(function () {
            if ($(this).hasClass("selected")) {
              self.destroyImageSlider();
              self.destroyPopupSlider();
              self.buildImageSlider($(this).attr("data-option"));
              self.buildPopupSlider($(this).attr("data-option"));
            }
          });
      }
    },
    closeCard: function (card) {
      if (card.hasClass("card--open")) {
        card.removeClass("card--open");
      }
    },

    getBundlePrice:function(){
      const bundle = this.getBundle();
      const optionsSelected = this.getOptionsSelected();
      const getVariantBundle = this.getBundleVariant(bundle,optionsSelected);
      return getVariantBundle.price;
    },

    getBundle:function(){
      const bundleContainer$ = this.getElements(selectors.productJson)[0];
      return this.toJson(bundleContainer$);
    },
    getCurrentBundle: function() {
      const bundle = this.getBundle();
      const optionsSelected = this.getOptionsSelected();
      const getVariantBundle = this.getBundleVariant(bundle,optionsSelected);
      return getVariantBundle;
    },
    getElements: function(selector){
      return $(selector);
    },
    toJson: function(script){
      return JSON.parse(script.outerText);
    },
    getOptionsSelected: function() {
      return this.getObjectOptions();
    },
    getObjectOptions: function(){
      const parentsElements$ = this.getElements(selectors.optionContainer);
      return this.getOptionsFromElement(parentsElements$);

    },
    getOptionsFromElement: function(parentsElements$){
      let options = {};
      const self = this;
      parentsElements$.each(function(index , parent){
        options = Object.assign(options, self.getObjectOption(parent,index));
      });
      return options;
    },
    getObjectOption:function(parent, index){
      const output = {};
      output[
        $(parent)
          .attr(
            selectors.optionContainer
              .replace("[","")
              .replace("]","")
          ) + "-" + index
      ] = this.getOption(parent);
      return output;
    },
    getOption: function(parent){
      return $(parent).find(".selected").attr("data-option");
    },
    getBundleVariant: function(bundle, optionsSelected){
      return this.getVariant(bundle, optionsSelected);
    },
    getVariant: function(bundle,optionsSelected){
      const str = this.generateQueryString(optionsSelected);
      return bundle.variants.find( variant => variant.title === str );
    },
    generateQueryString: function(optionsSelected, option="Taille"){
      let str = "";
      for(const [key, value] of Object.entries(optionsSelected)){
        if(key.indexOf(option) > -1){
          str = str + value + " / ";
        }
      }
      return this.transformString(str);
    },
    transformString: function(str){
      return str.replace(/[/] $/g,"").trim();
    },
    // About general state
    updateGeneralState: function () {
      // Activate button and update price
      var self = this;
      var areValid = true;
      var totalPrice = 0;
      var calculPrice = true;
      var quantity = $(selectors.productQuantity).val();
      const pyjamaCommon$ = $('[data-pyjama-common]');
      for (var i = 0; i < this.cards.length; i++) {
        var card = this.cards[i];
        if (!card.isValid) areValid = false;
        if (card.variant) totalPrice += parseInt(card.variant.price);
        else calculPrice = false;
      }
      // 8% discount for pijamas, 10% for every other bundle
      if (card.product.tags.includes("__matiere:Pyjama")) {
        var productPrice = Math.ceil(0.92 * (totalPrice / 100));
      } else {
        var productPrice = Math.ceil(0.9 * (totalPrice / 100));
      }
      productPrice *= 100;
      // Update line item
      var foundLineItem = false;
      // console.log('Card : ', card.variant);
      if(!pyjamaCommon$.length){
        $('[data-product-price="' + productPrice + '"]').each(function () {
          foundLineItem = true;
        });
      }
      if(pyjamaCommon$.length) {
        foundLineItem = true
      }
      if (!foundLineItem)
        console.log(
          "Problem : didn't find line item. Verify the setup from the backoffice"
        );

      // Update add to cart button and price
      if (areValid && foundLineItem) {
        $(selectors.checkoutAdd).show();
        $(selectors.checkoutDisabled).hide();
        // $(selectors.checkoutButton).removeClass('button--reverse');
        $(selectors.checkoutButton).attr("data-disabled", false);
        $(selectors.checkoutInfo).hide();
      } else {
        $(selectors.checkoutAdd).hide();
        $(selectors.checkoutDisabled).show();
        // $(selectors.checkoutButton).addClass('button--reverse');
        $(selectors.checkoutButton).attr("data-disabled", true);
      }
      var bundlePrice = productPrice * quantity;
      if(pyjamaCommon$.length) {
        bundlePrice =  Number(this.getBundlePrice()) * quantity;
        calculPrice = true;
      }
      // console.log('Quantity : ', quantity);
      // console.log('Price : ', bundlePrice);
      if (calculPrice){
        $(selectors.bundlePrice).html(bundlePrice / 100 + ",00€");
        $(".product__price-span").html(bundlePrice / 100 + ",00€");
      }
      else
        $(selectors.bundlePrice).html(
          $(selectors.priceWrapper).attr("data-ref-price")
        );
      const isBundlePyjama = $('[bundle-pyjama]')
      if(!isBundlePyjama?.length > 0){
        // Update URL
        this.updateUrl();
      }

      $(selectors.lineItemsWrapper).html("");
      // Update line item
      if (areValid) {
        // En premier et pour prévenir de toute erreur humaine dans le backoffice, on force à trouver un prix.
        var condensateVariantsName = "";
        for (var i = 0; i < self.cards.length; i++) {
          var card = self.cards[i];
          condensateVariantsName += card.variant.option2;
          if (i != self.cards.length - 1) condensateVariantsName += " / ";
        }
        // console.log('Condensate variant name ' + condensateVariantsName);
        var validItem = false;
        $(selectors.productPrice).each(function () {
          if ($(this).attr("data-product-price") == productPrice ) {
            // console.log('Same price');
            $(this).prop("selected", true);
            validItem = true;
            // console.log('First  :', $(this).html().trim(), 'Second :', condensateVariantsName.trim());
            if ($(this).html().trim() == condensateVariantsName.trim()) {
              // console.log("this is the good value ");
              return false;
            }
          }
        });
        if (!validItem && !pyjamaCommon$.length) {
          $("[data-add-to-cart]").html("Erreur").addClass("button--disabled");
        }
        // Puis, on ajoute les noms des produits, les options et les SKUS en line item
        for (var l = 0; l < self.cards.length; l++) {
          var card = self.cards[l];
          //console.log('Line Item Card : ', card);
          $(selectors.lineItemsWrapper).append(
            '<input data-line-item type="hidden" name="properties[' +
            card.product.title +
            ']" value="' +
            card.variant.title +
            '" >'
          );
          $(selectors.lineItemsWrapper).append(
            '<input data-line-item type="hidden" name="properties[_handle:' +
            card.product.title +
            ']" value="' +
            card.product.handle +
            '">'
          );
          $(selectors.lineItemsWrapper).append(
            '<input data-line-item type="hidden" name="properties[_SKU ' +
            card.product.title +
            ']" value="' +
            card.variant.sku +
            '">'
          );
        }
      }
    },
    updateUrl: function () {
      var newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname;
      var firstChar = "?";
      for (var i = 0; i < this.cards.length; i++) {
        var card = this.cards[i];
        if (card.variant) {
          newurl += firstChar + "option" + i + "=" + card.variant.id;
          firstChar = "&";
        }
      }

      const urlParams = new URLSearchParams(window.location.search);
      let urlModalParam = '';

      if (urlParams.get('modal') && !window.isAbTest) {
        window.isAbTest = true;
      }

      if(urlParams.get("type")){
        window.hasTypeAbTest = true;
      }

      if(window.isAbTest) {

        urlModalParam = '&modal=cross';
      }
      if(window.hasTypeAbTest) {
        urlModalParam = + '&type=color';
      }

      newurl = newurl + urlModalParam;
      window.history.replaceState({ path: newurl }, "", newurl);
    },
    getValuesOption: function(defaultValues, name="Color"){
      const output = [];
      defaultValues
        .split("|")
        .forEach( item => {
          item
            .split(',')
            .forEach(options =>{
              const option = options.split('.')[0];
              if(option === name) output.push(options.split('.')[1]);
            })
        })
      return output;
    },
    parseUrl: function () {
      var params = this.getAllUrlParams();
      var urlOptionName = "option";
      if (params.color) {
        var color = decodeURI(params.color);
        const $defaultVariantsContainer = $('[data-default-variants-metafield]')[0];
        let variantsDefault = "";
        let optionsArr = [];
        if($defaultVariantsContainer){
          variantsDefault = JSON.parse($defaultVariantsContainer.textContent);
          optionsArr = this.getValuesOption(variantsDefault);
        }
        // console.log("color: ", color)
        $(`[data-card-index="2"] [data-option-container="Color"]`).each(function(){
            let colorExists = false;
            let colorSelected;
            $(this).find(`[data-option]`).each(function(){
            if($(this).attr("data-option").toLowerCase() === color){
              colorExists = true;
              colorSelected = $(this);
            }
          });
          if(colorExists){
            colorSelected.click();
          }else {
            if(optionsArr[2]){
              $(this).find(`[data-option="${optionsArr[2]}"]`).each(function(){$(this).click()});
            }else{
              $(this).find(`[data-option]`)[0].click();
            }
          }
        });
        $(`[data-card-index="1"] [data-option-container="Color"]`).each(function(){
          let colorExists = false;
          let colorSelected;
          $(this).find(`[data-option]`).each(function(){
          if($(this).attr("data-option").toLowerCase() === color){
            colorExists = true;
            colorSelected = $(this);
          }
        });
        if(colorExists){
          colorSelected.click();
        }else {
          if(optionsArr[1]){
            $(this).find(`[data-option="${optionsArr[1]}"]`).each(function(){$(this).click()});
          }else{
            $(this).find(`[data-option]`)[0].click();
          }
        }
      });
        $(`[data-card-index="0"] [data-option-container="Color"]`).each(function(){
          let colorExists = false;
          let colorSelected;
          $(this).find(`[data-option]`).each(function(){
          if($(this).attr("data-option").toLowerCase() === color){
            colorExists = true;
            colorSelected = $(this);
          }
        });
        if(colorExists){
          colorSelected.click();
        }else {
          if(optionsArr[0]){
          $(this).find(`[data-option="${optionsArr[0]}"]`).each(function(){$(this).click()});
          }else{
            $(this).find(`[data-option]`)[0].click();
          }
        }
      });
        $(".variants-container-parure").find("[data-option]").each(function(){
          if ($(this).attr("data-option").toLowerCase() == color)
            $(this).click();
        });
      }
      let numberOptions = 0;
      for(const [key, value] of Object.entries(params)){
        if(key.indexOf("option") > -1){
          numberOptions++;
        }
      }
      if(!$("[data-global-container]").length > 0){
        for (var i = 0; i < numberOptions; i++) {
          if (params[urlOptionName + i]) {
            var option_id = params[urlOptionName + i];
            var card = this.cards[i];
            var variants = card.product.variants;
            var product = card.product;
            for (var j = 0; j < variants.length; j++) {
              var variant = variants[j];
              if (variant.id == option_id) {
                var isFounded = false;
                for (var k = 0; k < variant.options.length; k++) {
                  var optionName = product.options[k];
                  if (
                    $(
                      card.selector +
                      ' [data-option-container="' +
                      optionName +
                      '"]'
                    ).find('[data-option="' + variant.options[k] + '"]').length
                  ) {
                    $(
                      card.selector +
                      ' [data-option-container="' +
                      optionName +
                      '"]'
                    )
                      .find('[data-option="' + variant.options[k] + '"]')
                      .click();
                    isFounded = true;
                  }
                }
                if (!isFounded) continue;
                // Click on
                var next = i + 1;
                if (!params[optionName + next]) {
                  $('[data-card-index="' + i + '"] [data-card-toggle]').click();
                  if (variant.available)
                    $(
                      '[data-card-index="' + next + '"] [data-card-toggle]'
                    ).click();
                }
              }
            }
          }
        }
      } else if($("[data-global-container]").length > 0) {
        const sizeContainers = [];
        const elementIds = [];
        let colorSelected = null;
        for(let i = 0; i < this.cards.length ; i++){
          let elementId = $('[id*="' + this.cards[i].product.title + '"]').attr("id");
          // if(!elementIds.includes(elementId)){
            elementIds.push(elementId);
            let element = $('[id*="' + this.cards[i].product.title + '"]');
            sizeContainers.push({options: this.cards[i].product.options ,variants: this.cards[i].product.variants,tag:element});
          // }
        }
        const hasColorsSwatch = document.getElementsByClassName('variants-container-parure')
        let exceptions;
        if(hasColorsSwatch.length > 0){
          exceptions = JSON.parse(
            document.getElementsByClassName('variants-container-parure')[0]
            .getAttribute("products-exception")
          );
        }
        let colorPosition
        sizeContainers.map( element => {
          for (let i = 0; i < numberOptions; i++) {
            if (params[urlOptionName + i]){
              let optionId= params[urlOptionName + i];
              for(let j = 0; j < element.variants.length ; j++){
                if(element.variants[j].id == optionId){
                  if (element.variants[j].option1 !== "4 saisons"
                  && element.variants[j].option1 !== "Moelleux"
                  && element.variants[j].option1 !== "Mi-ferme"
                  && !colorSelected){
                    let foundOptionColor = false;
                    colorPosition = -1;
                    element.options.forEach( (o, index) => {
                      if(o === 'Color') {
                        colorPosition = index;
                        foundOptionColor = true;
                      } else{
                        return;
                      }
                    } );
                    if(exceptions?.length > 0){
                      let colorInException = false;
                      exceptions.forEach(exception => {
                        if(element.variants[j].name.indexOf(exception.productName) === -1
                           && exception.secondaryColor == element.variants[j].options[colorPosition] ){
                            colorSelected = element.variants[j].options[colorPosition];
                            colorInException = true;
                        }
                      });
                      if(!colorInException && i == numberOptions -1 ) colorSelected = element.variants[j].options[colorPosition];
                    }else if(foundOptionColor){
                      colorSelected = element.variants[j].options[colorPosition];
                    }
                    if(colorSelected){
                      $('.variants-container-parure').find('[data-name="'+ colorSelected + '"]').children()[0].click();
                      $('[data-global-container]').attr('data-color-selected',colorSelected);
                    }
                  }
                  element.options.forEach( (o, index) => {
                    if(o === 'Color') {
                      colorPosition = index;
                    } else{
                      return;
                    }
                  } );
                  for(let dimOptions = 0; dimOptions < element.variants[j].options.length; dimOptions++){
                    let currentOption = element.variants[j].options[dimOptions];
                    if(element.variants[j].option1 == 'Mi-ferme' || element.variants[j].option1 == 'Moelleux'){
                      value = element.variants[j].option1 + " / " + element.variants[j].option2
                    }else {
                      value = element.variants[j].options[dimOptions];
                    }
                    if(dimOptions != colorPosition){
                      let objt = $(element.tag).find('[data-option="' + value + '"]');
                      objt.click();
                    }
                  }
                }
              }
            }
          }
        });
      }
    },
    // About image and popup image
    initImages: function () {
      this.initImageSlider();
      this.initPopupSlider();
      $(selectors.showPopupSlider).click(this.showPopupSlider.bind(this));
      $(selectors.hideImagePopup).click(this.hidePopupSlider.bind(this));
    },
    initImageSlider: function () {
      var self = this;

      this.$productSlider = $(selectors.productSlider).flickity({
        wrapAround: true,
        imagesLoaded: true,
        pageDots: true,
        groupCells: 1,
        contain: true,
        cellAlign: "left",
        arrowShape: { x0: 30, x1: 60, y1: 25, x2: 65, y2: 25, x3: 35 },
      });

      this.$productSlider.on("ready.flickity", function () {
        self.$productSlider.resize();
        $(selectors.productSlider).css("opacity", 1);
        $(selectors.productThumbnail).css("opacity", 1);
        setTimeout(function () { }, 100);
      });

      this.$productThumbnail = $(selectors.productThumbnail).flickity({
        asNavFor: ".product__slider",
        prevNextButtons: false,
        pageDots: false,
        groupCells: true,
      });
      $(selectors.showPopupSlider).click(this.showPopupSlider.bind(this));
      $(selectors.hideImagePopup).click(this.hidePopupSlider.bind(this));
    },
    destroyImageSlider: function () {
      $(selectors.productSlider).css("opacity", 0);
      $(selectors.productThumbnail).css("opacity", 0);
      if (this.$productSlider.flickity) {
        this.$productSlider.flickity("destroy");
      }
      this.$productSlider.html("");
      if (this.$productThumbnail.flickity) {
        this.$productThumbnail.flickity("destroy");
      }
      this.$productThumbnail.html("");
    },
    buildImageSlider: function (color) {
      const parseHtmlEnteties = (str) => {
        return str.replace(/&#([0-9]{1,3});/gi, function(match, numStr) {
            var num = parseInt(numStr, 10); // read num as normal number
            return String.fromCharCode(num);
        });
      }
      this.imagesObject = product_images;
      var image,
        sliderHtml = "",
        thumbnailHtml = "";
      for (var i = 0; i < this.imagesObject.length; i++) {
        image = this.imagesObject[i];
        if (parseHtmlEnteties(image.alt) === color) {
          sliderHtml +=
            '<div class="carousel-cell full-width"><img class="product__slider-image" data-show-image-popup src="' +
            image.src +
            '" alt="' +
            image.alt +
            '"></div>';
          thumbnailHtml +=
            '<div class="carousel-cell"><div class="thumbnail thumbnail--circled" style="background-image:url(' +
            image.src +
            ')"></div></div>';
        }
      }
      this.$productSlider.html(sliderHtml);
      this.$productThumbnail.html(thumbnailHtml);
      this.initImageSlider();
    },

    initPopupSlider: function () {
      var self = this;

      this.$popupSlider = $(selectors.popupSlider).flickity({
        sync: ".product__slider",
        wrapAround: true,
        imagesLoaded: true,
        pageDots: true,
        groupCells: 1,
        contain: true,
        cellAlign: "left",
        arrowShape: { x0: 30, x1: 60, y1: 25, x2: 65, y2: 25, x3: 35 },
      });

      this.$popupSlider.on("ready.flickity", function () {
        self.$popupSlider.resize();
        $(selectors.popupSlider).css("opacity", 1);
        $(selectors.popupThumbnail).css("opacity", 1);
      });

      this.$popupThumbnail = $(selectors.popupThumbnail).flickity({
        asNavFor: ".product__slider--popup",
        prevNextButtons: false,
        pageDots: false,
        groupCells: true,
      });
      $(".product__popup").click(function (event) {
        event.stopPropagation();
      });
    },
    buildPopupSlider: function (color) {
      var image,
        sliderHtml = "",
        thumbnailHtml = "";
      for (var i = 0; i < this.imagesObject.length; i++) {
        image = this.imagesObject[i];
        if (image.alt === color) {
          sliderHtml +=
            '<div class="carousel-cell full-width"><img class="product__slider-image" src="' +
            image.src +
            '" alt="' +
            image.alt +
            '"></div>';
          thumbnailHtml +=
            '<div class="carousel-cell"><div class="thumbnail thumbnail--circled" style="background-image:url(' +
            image.src +
            ')"></div></div>';
        }
      }
      this.$popupSlider.html(sliderHtml);
      this.$popupThumbnail.html(thumbnailHtml);
      this.initPopupSlider();
    },
    destroyPopupSlider: function () {
      $(selectors.popupSlider).css("opacity", 0);
      $(selectors.popupThumbnail).css("opacity", 0);

      if (this.$popupSlider.flickity) {
        this.$popupSlider.flickity("destroy");
      }
      this.$popupSlider.html("");
      if (this.$popupThumbnail.flickity) {
        this.$popupThumbnail.flickity("destroy");
      }
      this.$popupThumbnail.html("");
    },
    hidePopupSlider: function () {
      $(".product__popup-container").removeClass(
        "product__popup-container--activated"
      );
    },
    showPopupSlider: function () {
      //console.log('Show popup slider', this.$productSlider.selectedIndex);
      this.$popupSlider.flickity(
        "selectCell",
        this.$productSlider.selectedIndex
      );

      $(".product__popup-container").addClass(
        "product__popup-container--activated"
      );
    },

    // Tools
    getAllUrlParams: function (url) {
      // get query string from url (optional) or window
      var queryString = url
        ? url.split("?")[1]
        : window.location.search.slice(1);
      // we'll store the parameters here
      var obj = {};
      // if query string exists
      if (queryString) {
        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split("#")[0];
        // split our query string into its component parts
        var arr = queryString.split("&");
        for (var i = 0; i < arr.length; i++) {
          // separate the keys and the values
          var a = arr[i].split("=");
          // set parameter name and value (use 'true' if empty)
          var paramName = a[0];
          var paramValue = typeof a[1] === "undefined" ? true : a[1];
          // (optional) keep case consistent
          paramName = paramName.toLowerCase();
          if (typeof paramValue === "string")
            paramValue = paramValue.toLowerCase();
          // if the paramName ends with square brackets, e.g. colors[] or colors[2]
          if (paramName.match(/\[(\d+)?\]$/)) {
            // create key if it doesn't exist
            var key = paramName.replace(/\[(\d+)?\]/, "");
            if (!obj[key]) obj[key] = [];
            // if it's an indexed array e.g. colors[2]
            if (paramName.match(/\[\d+\]$/)) {
              // get the index value and add the entry at the appropriate position
              var index = /\[(\d+)\]/.exec(paramName)[1];
              obj[key][index] = paramValue;
            } else {
              // otherwise add the value to the end of the array
              obj[key].push(paramValue);
            }
          } else {
            // we're dealing with a string
            if (!obj[paramName]) {
              // if it doesn't exist, create property
              obj[paramName] = paramValue;
            } else if (obj[paramName] && typeof obj[paramName] === "string") {
              // if property does exist and it's a string, convert it to an array
              obj[paramName] = [obj[paramName]];
              obj[paramName].push(paramValue);
            } else {
              // otherwise add the property
              obj[paramName].push(paramValue);
            }
          }
        }
      }
      return obj;
    },
    /**
     * Function for set estimated delivery date in products pages
     * @author rgranados
     * @returns {HTMLElement} data delivery date HTML
     */
    setDeliveryDate: function () {
      const date = new Date();
      const weekDay = date.getDay();
      const hours = date.getHours();
      const isWeekend = weekDay % 6 == 0;
      /**Validation for end year shipping estimation (2022) */
      const specialDeliveriesData = document.querySelector('#special-deliveries-data');
      const isEnabled = Boolean(specialDeliveriesData.getAttribute('special-deliveries-enable'));
      const start = new Date(specialDeliveriesData.getAttribute('special-deliveries-starting-date'));
      const end = new Date(specialDeliveriesData.getAttribute('special-deliveries-final-date'));
      const shippingDays = Number(specialDeliveriesData.getAttribute('special-deliveries-shipping-days'));

      let nextDay = new Date(date);

      if (isEnabled === true && date >= start && date <= end) {
        let count = 0;
        while(count < shippingDays){
          endDate = new Date(date.setDate(date.getDate() + 1));
          if(endDate.getDay() != 0 && endDate.getDay() != 6){
            count++;
          } else {
            endDate.setDate(endDate.getDate() + shippingDays);
          }
        }
        let newDateString = endDate.toLocaleString("fr", {
          weekday: "long",
          day: "numeric",
          month: "long",
        });
        $("[data-delivery-date]").html(newDateString);
      } else {
        if (isWeekend || hours > 12) {
          nextDay.setDate(date.getDate() + 1);
          this.setNextDate(nextDay);
        } else {
          $("[data-delivery-date]").html("aujourd'hui");
        }
      }
    },
    /**
     * Function for set next monday
     * @author rgranados
     * @param {Date} nextDay next date obj
     * @returns {HTMLElement}
     */
    setNextDate: function(nextDay) {
      const nextDayString = nextDay.toLocaleString("fr", { weekday: "long" });
      const nextDateString = nextDay.toLocaleString("fr", {
        weekday: "long",
        day: "numeric",
        month: "long",
      });
      if (
        nextDayString == "samedi" ||
        nextDayString == "dimanche"
      ) {
        const nextMonday = new Date();
        nextMonday.setDate(
          nextMonday.getDate() + ((1 + 7 - nextMonday.getDay()) % 7)
        );
        const nextMondayString = nextMonday.toLocaleString("fr", {
          weekday: "long",
          day: "numeric",
          month: "long",
        });
        $("[data-delivery-date]").html(nextMondayString);
      } else {
        $("[data-delivery-date]").html(nextDateString);
      }
    },
  });

  return Bundle;
})();

/** instagram feed **/

theme.instagramFeed = new (function () {
  var settings = {};

  function instagramFeed(userSettings) {
    var defaultSettings = {
      get: "user",
      userId: null,
      limit: 9,
      resolution: "standard_resolution",
      accessToken: null,
      template:
        '\
			<div class="instafeed__block-image grid__cell 1/3--lap-and-up 1/2--portable">\
				<a target="_blank" href="{{link}}">\
					<img class="instagram-image" src="{{image}}" />\
				</a>\
			</div>',
    };
    settings = $.extend({}, defaultSettings, userSettings);
  }

  instagramFeed.prototype.init = function () {
    var userFeed = new Instafeed(settings);
    return userFeed;
  };

  instagramFeed.prototype.run = function (userFeed) {
    userFeed.run();
  };

  return instagramFeed;
})();

var instagramFeedSettings = {
  userId: $(".instagram__container").data("user-id"),
  accessToken: $(".instagram__container").data("access-token"),
};

// if instafeed exist, init construcor
if ($(".instagram__container").length) {
  var instaFeed = new theme.instagramFeed(instagramFeedSettings);
  var userFeed = instaFeed.init();
  instaFeed.run(userFeed);
}
$(function () {
  var speed = $(".concept__image-block").attr("data-slide-speed");
  var nextImg = null;
  var currentImg = null;
  var changeSlide = function () {
    currentImg = $(".concept__image.concept__image--activated");
    nextImg = currentImg.next(".concept__image");
    if (nextImg.length == 0) {
      nextImg = $(".concept__image-block").children().first();
    }
    nextImg.addClass("concept__image--activated");
    currentImg.removeClass("concept__image--activated");
    $(".keyword_text b span").html(nextImg.attr("data-keyword"));
  };
  $(".keyword_text b").append("<span></span>");
  changeSlide();
  setInterval(changeSlide, speed);
});

$(function () {
  var speed = $(".banner-concept__image-block").attr("data-slide-speed");
  var nextImg = null;
  var currentImg = null;

  var changeSlide = function () {
    currentImg = $(".banner-concept__image.banner-concept__image--activated");
    nextImg = currentImg.next(".banner-concept__image");
    if (nextImg.length == 0) {
      nextImg = $(".banner-concept__image-block").children().first();
    }

    currentImg.removeClass("banner-concept__image--activated");
    nextImg.addClass("banner-concept__image--activated");

    $(".keyword_text b span").html(nextImg.attr("data-keyword"));
  };
  $(".keyword_text b").append("<span></span>");
  changeSlide();
  setInterval(changeSlide, speed);
});

var $conceptMenu = $(".anchor-menu");

var topbarVisibility = Cookies.get("topbarVisibility");
if ($(window).scrollTop() == 0 && !topbarVisibility) {
  $("[data-promo-banner]").removeClass("hide");
}

if ($(".anchor-menu").length) {
  $(".header__submobile").css("display", "flex");
}
$(".anchor-menu__link").each(function () {
  $(this)
    .clone()
    .addClass("header__submobile--link")
    .appendTo(".header__submobile");
  //$(this).hide();
});
$("[data-anchor-slideto]").click(function () {
  $conceptMenu.children("a").each(function () {
    $(this).removeClass("anchor-menu__selected");
  });
  $(this).addClass("anchor-menu__selected");
  var $targetElement = $(
    '[data-anchor-id="' + $(this).attr("data-anchor-slideto") + '"]'
  );
  if ($targetElement.length > 1) {
    $targetElement.each(function () {
      if ($(this).is(":visible")) {
        $targetElement = $(this);
        return false;
      }
    });
  }
  var heightSum =
    $(".header").height() +
    $conceptMenu.parent().height() +
    $(".header__submobile").height();
  if ($(window).width() > 800) heightSum += 50;
  else heightSum -= 40;
  if ($targetElement && $targetElement.offset())
    $("html, body").animate(
      { scrollTop: $targetElement.offset().top - heightSum },
      1500
    );
});
$(function () {
  var $selectedElement, $nextElement, $nextTop, $prevElement, $prevTop;
  $("#shopify-section-header").on("headerChange", function () {
    $(".anchor-section").css("top", $(".header").height() + "px");
    setTimeout(function () {
      $(".anchor-section").css("top", $(".header").height() + "px");
    }, 50);
    setTimeout(function () {
      $(".anchor-section").css("top", $(".header").height() + "px");
    }, 100);
    setTimeout(function () {
      $(".anchor-section").css("top", $(".header").height() + "px");
    }, 150);
    if ($(".anchor-section").hasClass("anchor-menu__sticky")) {
      $(".anchor-section").removeClass("anchor-menu__sticky");
    } else {
      $(".anchor-section").addClass("anchor-menu__sticky");
      if ($("[data-promo-banner]").is(":visible"))
        $("[data-promo-banner]").addClass("hide");
      else if (!Cookies.get("topbarVisibility")) {
        $("[data-promo-banner]").removeClass("hide");
      }
    }
  });
  $(window).on("scroll", function () {
    $(".anchor-section").css("top", $(".header").height() + "px");
    var top = $(window).scrollTop();
    var $selectedElement = $(".anchor-menu .anchor-menu__selected").first();
    if (!$selectedElement.length)
      $selectedElement = $(".anchor-menu__link").first();
    var $selectedTop = $selectedElement.scrollTop();
    var $nextElement = $selectedElement.next(".anchor-menu__link");
    if (!$nextElement.is(":visible")) {
      $nextElement = $nextElement.next(".anchor-menu__link");
    }
    if ($nextElement.length) {
      if (
        !$(
          '[data-anchor-id="' + $nextElement.attr("data-anchor-slideto") + '"]'
        ).offset()
      )
        return;
      var $nextTop = $(
        '[data-anchor-id="' + $nextElement.attr("data-anchor-slideto") + '"]'
      ).offset().top;
      if ($nextTop - 300 < top) {
        $selectedElement.removeClass("anchor-menu__selected");
        $nextElement.addClass("anchor-menu__selected");
      }
    }
    var prevElement = $selectedElement.prev(".anchor-menu__link");
    if (!prevElement.is(":visible"))
      prevElement = prevElement.next(".anchor-menu__link");
    if (prevElement.length) {
      var prevTop = $(
        '[data-anchor-id="' + prevElement.attr("data-anchor-slideto") + '"]'
      ).offset().top;
      if (prevTop > top) {
        $selectedElement.removeClass("anchor-menu__selected");
        prevElement.addClass("anchor-menu__selected");
      }
    }
  });
});

// =require sections/anchor-menu.js
// =require sections/reviews.js
$(function () {
  $("[data-swatch-change]").click(function () {
    var color = $(this).attr("data-color");
    var $new_color_elt = $(this)
      .parents(".product-card")
      .find('[data-image-color="' + color + '"]');
    // console.log('Color : ', color);
    $(this)
      .parents(".product-card")
      .find("[data-image-color]")
      .each(function () {
        $(this).removeClass("selected");
      });
    $new_color_elt.addClass("selected");
    $(this)
      .parents(".product-card")
      .find("[data-swatch-change]")
      .each(function () {
        $(this).removeClass("selected");
      });
    // console.log($new_color_elt.attr('data-link-value'));
    $(this)
      .parents(".product-card")
      .find("[data-product-link]")
      .attr("href", $new_color_elt.attr("data-link-value"));
    $(this).addClass("selected");
  });

  if ($(window).width() > 787) {
    $("[data-swatch-change]")
      .mouseover(function () {
        var color = $(this).attr("data-color");
        $(this)
          .parents(".product-card")
          .find(".product-card__images-color.selected")
          .hide();
        $(this)
          .parents(".product-card")
          .find('[data-image-color="' + color + '"]')
          .show();
      })
      .mouseout(function () {
        var color = $(this).attr("data-color");
        $(this)
          .parents(".product-card")
          .find('[data-image-color="' + color + '"]')
          .hide();
        $(this)
          .parents(".product-card")
          .find(".product-card__images-color.selected")
          .show();
      });
  }
  $("[data-card-bundle] [data-swatch-change]").each(function () {
    if ($(this).hasClass("selected")) {
      $(this).click();
    }
  });
});

$(".details-card__button-toggle").on("click", function () {
  // console.log($(this).find('svg:first').css("transform"));
  if ($(window).width() < 787) {
    if ($(this).find("svg:first").css("transform") == "none") {
      $(this).find("svg:first").css("transform", "rotate(90deg)");
    } else {
      $(this).find("svg:first").css("transform", "none");
    }
    $(this).parent().parent().find(".details-card__toggle").slideToggle();
  }
});

$(function () {
  var currentKeywordPosition = 0;
  var speed = $(".banner-avis").attr("data-avis-speed");
  if ($(".banner-avis__title").attr("data-avis-keywords") != undefined) {
    var arrayKeywords = $(".banner-avis__title")
      .attr("data-avis-keywords")
      .split(",");
    if (arrayKeywords[0] != null && arrayKeywords[0] != undefined) {
      var arrayKeywordsLength = arrayKeywords.length;
      var changeKeyword = function () {
        $(".banner-avis__title b").html(
          arrayKeywords[arrayKeywordsLength - 1] +
          "<span>" +
          arrayKeywords[currentKeywordPosition] +
          "</span>"
        );
        if (currentKeywordPosition < arrayKeywordsLength - 1) {
          currentKeywordPosition++;
        } else {
          currentKeywordPosition = 0;
        }
      };
      changeKeyword();
      setInterval(changeKeyword, speed);
    }
  }
});
theme.accordion = (function () {
  "use strict";

  var selectors = {
    root: "[data-accordion]",
    trigger: "[data-accordion-trigger]",
    panel: "[data-accordion-panel]",
  };

  var features = {
    allow_multiple: "[data-allow-multiple]",
    allow_toggle: "[data-allow-toggle]",
  };

  var data = {
    target_id: "aria-controls",
  };

  var states = {
    expanded: {
      attr_name: "aria-expanded",
      attr_values: {
        yes: "true",
        no: "false",
      },
    },
    disabled: {
      attr_name: "aria-disabled",
      attr_values: {
        yes: "true",
        no: "false",
      },
    },
  };

  $(selectors.root).each(function () {
    var $accordion = $(this);
    init($accordion);
  });

  function init($accordion) {
    var allowsMultiple = $accordion.is(features.allow_multiple);
    var options = {
      allowsMultiple: allowsMultiple,
      allowToggle: allowsMultiple
        ? allowsMultiple
        : $accordion.is(features.allow_toggle),
    };

    $accordion.on("click", selectors.trigger, function (e) {
      e.preventDefault();
      trigger($(this), $accordion, options);
    });

    $accordion.on("keydown", function (e) {
      handleKeyboard(event, $(this), options);
    });

    if (!options.allowToggle) {
      // Get the first expanded/ active accordion
      var $expanded = $accordion.find('[aria-expanded="true"]').first();

      // If an expanded/ active accordion is found, disable
      if ($expanded.length) {
        $expanded.setAttribute(
          states.disabled.attr_name,
          states.disabled.attr_values.yes
        );
      }
    } else {
      // Get all unexpanded accordion panels
      var $unexpanded = $accordion.find('[aria-expanded="false"]');
      $unexpanded.each(function () {
        var panelId = $(this).attr("aria-controls");
        hidePanel($(panelId));
      });
    }
  }

  function trigger($trigger, $accordion, options) {
    var settings = {
      allowsMultiple: options.allowsMultiple,
      allowToggle: options.allowToggle,
    };

    var $targetPanel = $($trigger.attr(data.target_id));

    var isExpanded = $trigger.is(
      "[" +
      states.expanded.attr_name +
      "='" +
      states.expanded.attr_values.yes +
      "']"
    );
    var $accordionActiveTriggers = $accordion.find(
      "[" +
      states.expanded.attr_name +
      "='" +
      states.expanded.attr_values.yes +
      "']"
    );
    var $accordionActivePanels = $accordion.find(selectors.panel);

    if (!settings.allowsMultiple && $accordionActiveTriggers.length > 0) {
      // Set the expanded state on the triggering element
      $accordionActiveTriggers
        .not($trigger)
        .attr(states.expanded.attr_name, states.expanded.attr_values.no);
      // Hide the accordion sections, using aria-controls to specify the desired section
      hidePanel($accordionActivePanels.not($targetPanel));

      // When toggling is not allowed, clean up disabled state
      if (!settings.allowToggle) {
        $accordionActiveTriggers.removeAttr(states.disabled.attr_name);
      }
    }

    if (!isExpanded) {
      // Set the expanded state on the triggering element
      $trigger.attr(states.expanded.attr_name, states.expanded.attr_values.yes);
      // Hide the accordion sections, using aria-controls to specify the desired section
      reveilPanel($targetPanel);

      // If toggling is not allowed, set disabled state on trigger
      if (!settings.allowToggle) {
        $trigger.attr(
          states.disabled.attr_name,
          states.disabled.attr_values.yes
        );
      }
    } else if (settings.allowToggle && isExpanded) {
      // Set the expanded state on the triggering element
      $trigger.attr(states.expanded.attr_name, states.expanded.attr_values.no);
      // Hide the accordion sections, using aria-controls to specify the desired section
      hidePanel($targetPanel);
    }
  }

  function reveilPanel($panel) {
    $panel.slideDown(); // .removeClass('hide');
  }

  function hidePanel($panel) {
    $panel.slideUp(); //.addClass('hide');
  }

  function handleKeyboard(event, $accordion, options) { }
})();

$(function () {
  $("[data-anchor-id]").click(function () {
    $(this).toggleClass("faq-groupe__visible");
    var selectedTitle = "mobile-" + $(this).attr("data-anchor-id");
    if ($(window).width() > 800) return;
    $("[data-mobile-accordion]").each(function () {
      var childTitle = $(this).attr("data-mobile-accordion");
      if (selectedTitle == childTitle) {
        $(this).slideToggle();
      }
    });
  });
});
$(function () {
  if (
    Cookies.get("popupClose") == undefined ||
    Cookies.get("popupClose") == false
  ) {
    var speed = $(".popup").attr("data-popup-speed") * 1000;
    // console.log('Speed ' , speed);
    setTimeout(function () {
      $("[data-popup-background]").show();
    }, speed);
  }
  $("[data-popup-close]").click(function () {
    $("[data-popup-background]").hide();
    Cookies.set("popupClose", true);
  });

  $(".popup #Subscribe").click(function () {
    Cookies.set("popupClose", true);
    // console.log('SET');
    if (typeof ga !== "undefined") {
      ga("send", {
        hitType: "event",
        eventCategory: "Newsletter",
        eventAction: "AddMail",
        eventLabel: "AddMailPopup",
      });
    }
  });
  $("footer .newsletter__submit").click(function (e) {
    if (typeof ga !== "undefined") {
      ga("send", {
        hitType: "event",
        eventCategory: "Newsletter",
        eventAction: "AddMail",
        eventLabel: "AddMailFooter",
      });
    }
  });

  $("[data-popup-close-btn]").click(function () {
    Cookies.set("popupClose", true);
    $("[data-popup-background]").hide();
  });
});

var activateSideCart = window.deactivate_side_cart == true ? false : true;

function getFormData($form) {
  var unindexed_array = $form.serializeArray();
  var indexed_array = {};
  $.map(unindexed_array, function (n, i) {
    if (activateSideCart && n["name"].includes("properties")) {
      indexed_array[n["name"].split("[").pop().split("]")[0]] = n["value"];
    } else {
      indexed_array[n["name"]] = n["value"];
    }
  });

  return indexed_array;
}

/**
 * Add product to the cart via ajax adding leadsmonitor and opening sidecart
 * @param {Object} data JSON with the information of the product to add
 * @param {*} scrollTop
 */
function addProduct(data, scrollTop) {
  try {
    var _lm_vars = _lm_vars || {};
    _lm_vars["xid"] = ShopifyAnalytics.lib.user().traits().uniqToken;
    let script = document.createElement("script");
    let script2 = document.createElement("script");
    script.src = "https://bonsoirs-1.leadsmonitor.io/track_panier.js";
    script2.src = "https://bonsoirs-2.leadsmonitor.io/lm.js";
    document.head.appendChild(script);
    document.head.appendChild(script2);
    window._lmtag.registerHit('panier');
  } catch (error) {
    console.error(error);
  }

  // console.log("scrollTop", scrollTop);
  $("[data-cart-items-content]").addClass("hide");
  $("[data-cart-loading]").removeClass("hide");

  if (activateSideCart) {
    var clone = Object.assign({}, data);
    // console.log("Data:", data);
    // console.log("Clone.id1:",clone.id);
    // console.log("Data.id1:",data.id);

    delete clone.id;
    delete clone.quantity;
    if (clone.hasOwnProperty("properties")) {
      clone = Object.assign(clone, clone.properties);
    }
    // console.log(clone);
    for (const [key, value] of Object.entries(clone)) {
      if (key == "Color" || key == "Taille") {
        var propertyName = "_" + key;
        clone[propertyName] = value;
        delete clone[key];
      }
    }
    CartJS.addItem(data.id, data.quantity, clone, {
      success: function (data, textStatus, jqXHR) {
        notifyDomAvailableItemSelected()
        //open side cart
        $(window).trigger("closeSearch");
        if ($("body").hasClass("template-cart")) return;

        setTimeout(function () {
          $("body").addClass("non-scroll");
          $(".header").addClass("not-light");
          $("[data-cart-background-overlay]").addClass("active");
          $("[data-side-cart]").addClass("open");
          $("#gorgias-chat-container").addClass("hide-element");
        }, 950);

        if (scrollTop != undefined) {
          $("[data-side-cart]").animate({
            scrollTop: $("[data-side-cart]").offset().top,
          });
        }
      },
      error : function(jqXHR, textStatus, errorThrown) {
        const validateItemsBundle = document.querySelector('[is-bundle-validate-items]');
        const isParureMultiOptions = document.querySelector('[parure-multi-options]');
        const variantSelector = document.getElementsByClassName(`swatch-color selected`)[0];
        if((validateItemsBundle || isParureMultiOptions) && jqXHR.status === 422) {
          notifyDomUnavailableItemSelected();
          variantSelector.classList.add("unavailable")
        }
      }
    });
  } else {
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: data,
      success: function () {
        // console.log("Data: "+ JSON.stringify(data));
        location.href = "/cart";
      },
      error: function (err) {
        console.log("Erreur: " + err);
        // TODO: Regarder si le produit à une broderie + la supprimer
      },
    });
  }
}

function addGiftProduct(id, quantity) {
  if (quantity > 10) quantity = 10;
  CartJS.addItem(
    id,
    quantity,
    { _gift: "gift" },
    {
      success: function () {
        $("[data-cart-gift]").removeClass("side-cart-gift-open");
        $("#cart-gift-container").addClass("hide");
      },
    }
  );
}

if ($("[data-product-carousel]") != undefined) {
  var $carousel = $("[data-broderie-carousel]").flickity({
    pageDots: true,
    prevNextButtons: true,
    draggable: true,
    adaptiveHeight: false,
    arrowShape: { x0: 30, x1: 60, y1: 25, x2: 65, y2: 25, x3: 35 },
  });

  // Flickity instance
  var flkty = $carousel.data("flickity");

  // Fix for lazyload + flickity -- Mac retina
  $("[data-broderie-carousel-container]")
    .find("img")
    .each(function () {
      $(this).on("load", function () {
        $carousel.resize();
        $carousel
          .find(".flickity-viewport")
          .height($carousel.find(".carousel-cell").first().height() + "px");
      });
    });

  // elements
  var $cellButtonGroup = $("[data-broderie-group-cells]");
  var $cellButtons = $cellButtonGroup.find("[data-broderie-button]");

  // update selected cellButtons
  $carousel.on("select.flickity", function () {
    $cellButtons.filter(".is-selected").removeClass("is-selected");
    $cellButtons.eq(flkty.selectedIndex).addClass("is-selected");
  });

  // select cell on button click
  $cellButtonGroup.on("click", "[data-broderie-button]", function () {
    var index = $(this).index();
    $carousel.flickity("select", index);
  });
}

function addProductBroderie(id, variant, quantity, data) {
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: {
      id: variant,
      quantity: quantity,
      properties: {
        _ID: id,
      },
    },
    success: function (item) {
      var key = item.key;
      var handle = item.handle;
      var variant_id = item.variant_id;
      // data["properties"]["ID"] = id;
      data["properties"]["_Token"] = key;
      data["properties"]["_Ref"] = handle + "#" + variant_id;
      data["properties"]["_Price"] = item.price;
      addProduct(data);
    },
    error: function (err) {
      console.log("Erreur: " + err);
    },
  });
}

function addProductCrossSell(variant, quantity, data) {
  const cta = $('.cart-footer .cta');
  const loader = $('.cart-footer .lds-ellipsis');

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: {
      id: variant,
      quantity: quantity
    },
    beforeSend: function () {
      cta.addClass('hide');
      loader.removeClass('hidden');
    },
    success: function (item) {
      addProduct(data);
      closeSidePanel();
      cta.removeClass('hide');
      loader.addClass('hidden');
    },
    error: function (err) {
      cta.removeClass('hide');
      loader.addClass('hidden');
      console.log("Erreur: " + err);
    },
  });
}

function getCurrentPrice() {
  var currentPriceBroderie = $("[data-bundle-price]").html();
  var currentPrice = $("[data-price-wrapper] h2").html();
  if (currentPriceBroderie != undefined) {
    var currentPriceBroderie = currentPriceBroderie.split(",");
    var currentPriceBroderie = currentPriceBroderie[0];
    return currentPriceBroderie;
  } else if (currentPrice != undefined) {
    var currentPrice = currentPrice.split(",");
    var currentPrice = currentPrice[0];
    return currentPrice;
  }
  return 0;
}

function formatBroderiePrice(broderiePrice) {
  var price = broderiePrice.split(",");
  var price = price[0];
  return price;
}

// EMBROIDERY UTILITIES
$(function () {
  var broderieText;
  var broderieText2;
  var broderieColor;
  var productVariantId;
  var currentProductPrice = 0;

  // SHOW BUTTON BRODERIE
  if ($(".broderie__texts")[0]) {
    $("[data-open-broderie]").css("display", "inline-block");
    $("#broderie-color-1").attr("checked", true);
  }

  // SHOW BRODERIE
  $("[data-open-broderie]").on("click", function () {
      if (typeof ga !== "undefined") {

        ga("send", {
          hitType: "event",
          eventCategory: "Broderie",
          eventAction: "OpenPopup",
          eventLabel: "OpenBroderiePopup",
        });
      }
      var quantity = $("[data-product-quantity]").val();
      currentProductPrice = getCurrentPrice();
      $("[data-broderie-button-price],[data-broderie-product-price]").html(
        " - " + currentProductPrice + "€"
      );
      $("[data-broderie-product-price]").html(currentProductPrice + "€");
      $("[data-broderie-price]").html("0€");
      $("[data-broderie-quantity]").text(quantity);
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      $("body").css("overflow", "hidden");
      $(".header").css("position", "fixed !important");
      $("[data-broderie]").addClass("broderie-open");
      $("[data-valid-broderie]").prop("disabled", false);
      $(".header").css("position", "inherit");

  });

  // CLOSE BRODERIE
  $("[data-close-broderie]").on("click", function () {
    $("body").css("overflow", "unset");
    $("[data-broderie]").removeClass("broderie-open");
    $("[data-broderie-text1],[data-broderie-text2]").val("");
  });

  // CHANGE INPUT FONT AND CASE
  $("input[name='broderie-font']").click(function () {
    const t1 = $("[data-broderie-text1]");
    const t2 = $("[data-broderie-text2]");
    const wrapper = $(".broderie_fonts");
    wrapper.attr("data-text-transform", $(this).data("textTransform"));
    t1.css({
      fontFamily: $(this).data("fontFamily"),
      textTransform: $(this).data("textTransform"),
      fontSize: $(this).data("fontSize"),
    });
    t2.css({
      fontFamily: $(this).data("fontFamily"),
      textTransform: $(this).data("textTransform"),
      fontSize: $(this).data("fontSize"),
    });
    if (wrapper.attr("data-text-transform") == "uppercase") {
      t1.val(t1.val().toUpperCase());
      t2.val(t2.val().toUpperCase());
    } else {
      t1.val(t1.val().toLowerCase());
      t2.val(t2.val().toLowerCase());
    }
  });

  // FORCE TEXT TRANSFORM ON INPUT VALUE
  $(".broderie__inputsV2").on("keyup", "input.broderie__text-input", (e) => {
    const transform = $(".broderie_fonts").attr("data-text-transform");
    e.target.value =
      transform == "uppercase"
        ? e.target.value.toUpperCase()
        : e.target.value.toLowerCase();
  });

  // FORCE TEXT TRANSFORM ON INPUT VALUE FOR EMBROIDERY V1
  $(".broderie__inputs").on("keyup", "input.broderie__text-input", (e) => {
    e.target.value = e.target.value.toUpperCase()
  });

  // CHANGE CHECKED FONT TYPE
  const inputBroderiesFont = document.querySelectorAll("input[name='broderie-font']");
  inputBroderiesFont.forEach(e => {
    e.addEventListener("click", (a) => {
      const inputPrev = document.querySelector("input[name='broderie-font'][checked]");
      inputPrev.removeAttribute("checked")
      a.target.setAttribute("checked", true)
      const isBaton = a.target.value === "Bâton"
      if(!isBaton) {
        const input = document.getElementById("broderie-text1");
        const input2 = document.getElementById("broderie-text2");
        input.value = input.value.replace(/[@&*]/g, "");
        if(input2) {
          input2.value = input.value.replace(/[@&*]/g, "");
        }
      }
    })
  })

  // VALIDATE MAX LEGHT AND REMOVE SPECIAL CHARACTERS
  $(".input.broderie__text-input").on("keyup", (e) => {
    let input = document.querySelector("input[name='broderie-font'][checked]");
    let specialCharacters;
    if(input && input.value === "Bâton") {
      specialCharacters = /[@*]/g.test(e.target.value)
    } else {
      specialCharacters = /[@&*]/g.test(e.target.value)
    }
    const emojiRegex = /<:[^:\s]+:\d+>|<a:[^:\s]+:\d+>|(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff]|\ufe0f)/g
    if (specialCharacters){
      e.target.value = e.target.value.replace(/[@&*]/g, "");
    }else if (emojiRegex.test(e.target.value)){
      e.target.value = e.target.value.replace(emojiRegex,'')
    }

    const max = e.target.getAttribute("maxlength");
    if (max && e.target.value.length > max) {
      e.target.value = e.target.value.substring(0, max);
    }
  });

  // CHANGE INPUT FONT AND CASE ON LOAD
  (function () {
    const t1 = $("[data-broderie-text1]");
    const t2 = $("[data-broderie-text2]");
    const input = $("input[name='broderie-font'][checked]");
    $(".broderie_fonts").attr(
      "data-text-transform",
      input.data("textTransform")
    );
    t1.css({
      fontFamily: input.data("fontFamily"),
      textTransform: input.data("textTransform"),
      fontSize: input.data("fontSize"),
    });
    t2.css({
      fontFamily: input.data("fontFamily"),
      textTransform: input.data("textTransform"),
      fontSize: input.data("fontSize"),
    });
  })();

  // CHANGE SPAN COLOR VALUE + VAR FINAL COLOR
  $("input[name='broderie-color']").click(function () {
    broderieColor = this.value;
    $("[data-broderie-color] span").text(this.value);
  });

  // DELETE ONE BRODERIE
  $("[data-broderie-delete]").on("click", function () {
    $(this).parent().hide();

    if (
      $(".broderie__resume-first").is(":visible") ||
      $(".broderie__resume-second").is(":visible")
    ) {
      productVariantId = $("[data-broderie-variant1]").val();
      $("[data-product-broderie]").val($("[data-broderie-variant]").val());
    } else if (
      $(".broderie__resume-first").is(":hidden") &&
      $(".broderie__resume-second").is(":hidden")
    ) {
      $("[data-product-broderie]").val("");
      $(".borderie__resume").hide();
    }
  });

  // ON FIRST INPUT CHANGE
  $("[data-broderie-text1]").on("keyup", function () {
    var quantity = $("[data-product-quantity]").val();
    // this.value = this.value.toUpperCase();
    if (this.value != "" && this.value != undefined) {
      if (
        $("[data-broderie-text2]").val() == "" ||
        $("[data-broderie-text2]").val() == undefined
      ) {
        var broderiePrice = formatBroderiePrice(
          $("[data-broderie-price1]").data("broderiePrice1")
        );
        var price =
          parseInt(currentProductPrice) + parseInt(broderiePrice * quantity);
        $("[data-broderie-button-price]").html(" - " + price + "€");
        $("[data-broderie-price]").html(broderiePrice * quantity + "€");
      }
      $("[data-broderie-text2]").prop("disabled", false);
      $("[data-broderie-error]").hide();
    } else {
      $("[data-broderie-text2]").prop("disabled", true);
      $("[data-broderie-error]").show();
      $("[data-broderie-button-price]").html(" - " + currentProductPrice + "€");
      $("[data-broderie-price]").html("0€");
    }
  });

  $("[data-broderie-text2]").on("keyup", function () {
    var quantity = $("[data-product-quantity]").val();
    // this.value = this.value.toUpperCase();
    if (this.value == "" || this.value == undefined) {
      $(this).css("border-color", "#dedede");
    }
    if (this.value != "" && this.value != undefined) {
      var broderiePrice = formatBroderiePrice(
        $("[data-broderie-price2]").data("broderiePrice2")
      );
      var price =
        parseInt(currentProductPrice) + parseInt(broderiePrice * quantity);
      $("[data-broderie-button-price]").html(" - " + price + "€");
      $("[data-broderie-price]").html(broderiePrice * quantity + "€");
    } else if (
      $("[data-broderie-text1]").val() != "" &&
      $("[data-broderie-text1]").val() != undefined
    ) {
      var broderiePrice = formatBroderiePrice(
        $("[data-broderie-price1]").data("broderiePrice1")
      );
      var price =
        parseInt(currentProductPrice) + parseInt(broderiePrice * quantity);
      $("[data-broderie-button-price]").html(" - " + price + "€");
      $("[data-broderie-price]").html(broderiePrice * quantity + "€");
    }
  });

  $("[data-broderie-text2]").focus(function () {
    if (
      $("[data-broderie-text1]").val() != "" ||
      $("[data-broderie-text1]").val() != undefined
    ) {
      $(this).css("border-color", "black");
    }
  });

  // VALID BRODERIE
  $("body").on("click", "[data-valid-broderie]", function () {
    broderieText = $("input[name=broderie-text1]").val();
    broderieText2 = $("input[name=broderie-text2]").val();
    broderieColor = $("input[name=broderie-color]:checked").val();
    broderieFont = $("input[name=broderie-font]:checked").val();

    if (broderieText == "" || broderieText == undefined) {
      $("[data-broderie-error]").show();
    } else {
      $("[data-valid-broderie]").prop("disabled", true);
      if (
        broderieText != "" &&
        broderieText != undefined &&
        broderieText2 != "" &&
        broderieText2 != undefined
      ) {
        productVariantId = $("[data-broderie-variant2]").val();
      } else if (
        (broderieText != "" && broderieText != undefined) ||
        (broderieText2 != "" && broderieText2 != undefined)
      ) {
        productVariantId = $("[data-broderie-variant1]").val();
      }

      if (broderieColor != "" && broderieColor != undefined) {
        $("[data-valid-broderie]").prop("disabled", false);
        if (broderieText != "" && broderieText != undefined) {
          $("[data-broderie-resume1] span").text(broderieText);
          // $('.borderie__resume, .broderie__resume-first').show();
        } else {
          $(".broderie__resume-first").hide();
        }
        if (broderieText2 != "" && broderieText2 != undefined) {
          $("[data-broderie-resume3] span").text(broderieText2);
          // $('.borderie__resume, .broderie__resume-second').show();
        } else {
          $(".broderie__resume-second").hide();
        }
        if (
          (broderieText == "" || broderieText == undefined) &&
          (broderieText2 == "" || broderieText2 == undefined)
        ) {
          $("[data-product-broderie]").val("");
          // $('.borderie__resume').hide();
          $("#product-page-form").submit();
        } else {
          $("[data-product-broderie]").val(productVariantId);
          $("[data-broderie-resume2] span").text(broderieColor);
          $("#product-page-form").submit();
        }
      } else {
        alert("Erreur couleur");
      }
    }
  });

  function finishAddProcess(data, productVariantId, broderie, random) {
    var variant = productVariantId;
    var quantity = data["quantity"];
    const hasIdProperty = data.hasOwnProperty('id');
    if (broderie) {
      if (hasIdProperty){
        $("[data-broderie-text1],[data-broderie-text2]").val("");
        broderieText = "";
        broderieText2 = "";
        broderieColor = "";
        addProductBroderie(random, variant, quantity, data);
      }
    } else {
      addProduct(data);
    }

    $("body").css("overflow", "unset");
    $("[data-broderie]").removeClass("broderie-open");
    $("[data-broderie-text1],[data-broderie-text2]").val("");
  }

  function clearCrossSellSelection() {
    const variantSelects = document.querySelectorAll('.cross-sell-modal .variant');
    for (const select of variantSelects) {
      select.classList.remove('selected');
    }
  }

  // function searchOptionWithValues(){
  //   const options document.querySelector("[data-product-select]").value
  // };

  // ON SUBMIT FORM WITH BRODERIE
  $("#product-page-form").on("submit", function (event) {
     event.preventDefault();
    let product = JSON.parse($("[data-product-json]").html());
    if(product.handle == 'ensemble-nappe-et-serviettes') return;
    let variants = product.variants;
    let variantId = document.querySelector("[data-product-select]").value
    // console.log("Form.id1:",variantId);
    let broderieSKU = "";
    let selectedColor = '';
    let selectedSize = '';

    variants.forEach(function (item) {
      if (item.id == variantId && !window.hasTypeAbTest) {
        broderieSKU = item.sku;
        selectedColor = item.option1;
      }
    });
    if (typeof parure !== "undefined" && parure == true) {
      if(document.querySelector('[data-card] [data-card-option-value]')){
        selectedSize = document.querySelector('[data-card] [data-card-option-value]').innerHTML;
      }else{
        selectedSize = document.getElementsByClassName("size-select__select")[0].value;
      }
      var isParure = true;
    } else {
      var isParure = false;
    }
    var random = Math.floor(Math.random() * 100000000) + 1;
    var $form = $("#product-page-form");
    var data = getFormData($form);
    var broderie = false;

    let bundle = new theme.Bundle()
    let actualBundle = bundle.getCurrentBundle();
    let $pyjamaCommon = document.querySelector("[data-pyjama-common]")

    if ($pyjamaCommon) {
      data.id = actualBundle.id;
      broderieSKU = actualBundle.sku;
    }

    const isBundlePyjama = Boolean(document.querySelector('[bundle-pyjama]'));
    const isBundlePetitDejeuner = Boolean(document.querySelector('[bundle-petit-dejeuner]'));
    //If the product type current is parure-bundle-size template or pyjama gaze, just add the product to the broderie
    if(document.querySelector("[parure-bundle-size]") ||
      isBundlePyjama || isBundlePetitDejeuner){
      let productId = data.id;
      const parentContainer = document.querySelector(".variants-container-parure");
      const exceptions = JSON.parse(
        document.getElementsByClassName('variants-container-parure')[0]
        .getAttribute("products-exception")
      );
      const isCompletePack = document.getElementsByClassName("complete-pack").length;
      let productsItems = JSON.parse(parentContainer.getAttribute("products-items"));
      let selectedSizePlaceholder = !isBundlePyjama ?  "xxx / xxx / xxx" : "xxx / xxx";
      const isParureSize = parentContainer.getAttribute("parure-bain-size") || false;
      productsItems = productsItems.filter(el => el.length != 0);
      const selected = document.getElementsByClassName("swatch-color selected")[0];
      const selectedName = selected.getAttribute("data-product-name");
      const itemsLength = productsItems.length;
      let sizeSelects;
      if(isBundlePyjama){
        sizeSelects = document.getElementsByClassName("variant selected");
        Array.from(sizeSelects).forEach((item, index) => {
          let selectedValue = item.getAttribute("value");
          if(selectedValue != 'Pantalon (unisexe)'
            && selectedValue != 'Short (femme)'
          ){
            selectedSizePlaceholder = selectedSizePlaceholder.replace("xxx", selectedValue);
          }
        });
      }else {
        sizeSelects = document.getElementsByClassName("size-select__select");
        Array.from(sizeSelects).forEach((item, index) => {
          selectedSizePlaceholder = selectedSizePlaceholder.replace("xxx", item.getAttribute("value"));
        });
      }
      let optionBySizes = searchOptionWithValues(selectedSizePlaceholder);
      data = {
        id: isParureSize || isBundlePyjama ? optionBySizes.getAttribute("value") : productId,
        quantity: 1
      }
      variants.forEach(function (item) {
        if (item.id == data.id && !window.hasTypeAbTest) {
          broderieSKU = item.sku;
          selectedColor = selectedName;
        }
      });
      const exception = exceptions ? exceptions.filter(exc => exc.secondaryColor === selectedName) : [];
      for(let i = 0; i < itemsLength; i++){
        productsItems[i] = productsItems[i].filter((item) => {
          if(
            exception.length > 0
            && exception[0].primaryColor == item.color
            && exception[0].productName == item.product_name
            && exception[0].secondaryColor == selectedName
            ){
            return true;
          }else if (isCompletePack){
            if(item.color == "Mi-ferme" || item.color == "Moelleux" || item.color == "4 saisons"){
              return true;
            }
          }
          return item.color === selectedName
        });
      }
      const itemsFilteredLength = productsItems.length;
      if(exceptions){
        setPropertiesWithExceptions(data, productsItems, selectedName, exception);
      }else{
        setProperties(data, itemsFilteredLength, productsItems, isParureSize, selectedName);
      }
    }

    if (
      broderieColor != "" &&
      broderieColor != undefined &&
      broderieText != "" &&
      broderieText != undefined &&
      broderieText2 != "" &&
      broderieText2 != undefined
    ) {
      if (isParure) {
        data["properties"] = {
          _TEXTE1: broderieText,
          _TEXTE2: broderieText2,
          _COULEUR1: broderieColor,
          _COULEUR2: broderieColor,
          _FONT: broderieFont,
          Broderie:
            broderieText + " / " + broderieText2 + " / " + broderieColor,
        };
      } else {
        data["properties"] = {
          _TEXTE1: broderieText,
          _TEXTE2: broderieText2,
          _COULEUR1: broderieColor,
          _COULEUR2: broderieColor,
          _FONT: broderieFont,
          _SKU: broderieSKU,
          Broderie:
            broderieText + " / " + broderieText2 + " / " + broderieColor,
        };
      }
      broderie = true;
    } else if (
      broderieColor != "" &&
      broderieColor != undefined &&
      broderieText != "" &&
      broderieText != undefined
    ) {
      if (isParure) {
        data["properties"] = {
          _TEXTE1: broderieText,
          _COULEUR1: broderieColor,
          _FONT: broderieFont,
          Broderie: broderieText + " / " + broderieColor,
        };
      } else {
        data["properties"] = {
          _TEXTE1: broderieText,
          _COULEUR1: broderieColor,
          _FONT: broderieFont,
          _SKU: broderieSKU,
          Broderie: broderieText + " / " + broderieColor,
        };
      }
      broderie = true;
    } else if (
      broderieColor != "" &&
      broderieColor != undefined &&
      broderieText2 != "" &&
      broderieText2 != undefined
    ) {
      if (isParure) {
        data["properties"] = {
          _TEXTE1: broderieText2,
          _COULEUR1: broderieColor,
          _FONT: broderieFont,
          Broderie: broderieText2 + " / " + broderieColor,
        };
      } else {
        data["properties"] = {
          _TEXTE1: broderieText2,
          _COULEUR1: broderieColor,
          _FONT: broderieFont,
          _SKU: broderieSKU,
          Broderie: broderieText2 + " / " + broderieColor,
        };
      }
      broderie = true;
    }
    const upsellCrossTag = document.querySelector('[data-upsell-cross]');
    const upsellCross = upsellCrossTag?.getAttribute('data-upsell-cross');
    // if (document.querySelector(".cross-sell-modal") && window.isAbTest) {
      if (document.querySelector(".cross-sell-modal") && (upsellCross === 'true'|| window.isAbTest)) {
      if(!window.hasTypeAbTest){
        openSidePanelSize(selectedColor, selectedSize)
        .then(function() {
          var variant = productVariantId;
          var quantity = data["quantity"];

          if (broderie) {
            $("[data-broderie-text1],[data-broderie-text2]").val("");
            broderieText = "";
            broderieText2 = "";
            broderieColor = "";
            addProductBroderie(random, variant, quantity, data);
          } else {
            const crossSellVariantId = document.querySelector('[data-side-panel] .upsell-prod').dataset.variantId;
            addProductCrossSell(crossSellVariantId, 1, data);
            clearCrossSellSelection();
          }

          //$("body").css("overflow", "unset");
          $("[data-broderie]").removeClass("broderie-open");
          $("[data-broderie-text1],[data-broderie-text2]").val("");

        })
        .catch(function () {
          finishAddProcess(data, productVariantId, broderie, random);
        })
      }else{
        openSidePanelColor(selectedColor, selectedSize)
        .then(function() {
          var variant = productVariantId;
          var quantity = data["quantity"];

          if (broderie) {
            $("[data-broderie-text1],[data-broderie-text2]").val("");
            broderieText = "";
            broderieText2 = "";
            broderieColor = "";
            addProductBroderie(random, variant, quantity, data);
          } else {
            const crossSellVariantId = $('[data-side-panel] .upsell-prod')[0].getAttribute("data-variant-id")
            addProductCrossSell(crossSellVariantId, 1, data);
            clearCrossSellSelection();
          }

          //$("body").css("overflow", "unset");
          $("[data-broderie]").removeClass("broderie-open");
          $("[data-broderie-text1],[data-broderie-text2]").val("");

        })
        .catch(function() {
          finishAddProcess(data, productVariantId, broderie, random);
        })
      }
    } else {
      finishAddProcess(data, productVariantId, broderie, random);
    }


  });
});

theme.cart = new (function () {
  var settings = {};

  function cart(cartSettings) {
    // init default settings
    var defaultSettings = {
      bodySelector: "body",
      nonScrollClass: "non-scroll",
      toggleCartSelector: "[data-cart-toggle]",
      closeCartSelector: "[data-cart-close]",
      cartSelector: "[data-side-cart]",
      cartItemSelector: "[data-cart-item]",
      cartItemsSelector: "[data-cart-items]",
      cartItemRemoveSelector: "[data-cart-item-remove]",
      cartItemQuantity: ["data-cart-quantity"],
      cartTotalPriceSelector: "[data-cart-total-price]",
      cartFooterSelector: "[data-cart-footer]",
      updateCartSelector: "[data-add-to-cart]",
      backgroundSelector: "[data-cart-background-overlay]",
      openCartClass: "open",
      activeBackgroundClass: "active",
      headerSelector: ".header",
      headerNotLight: "not-light",
      cartCount: "#CartCount",
      cartFooterContent: "[data-cart-footer]",
      // Side cart
      sideCartEmpty: "[data-side-cart-empty]",
      // Progress bar
      progressPriceSelector: "[data-progress-price]",
      progressGoalAttr: "data-progress-goal",
      progressContainerSelector: "[data-progress-container]",
      progressBarContainerSelector: "[data-progress-bar-container]",
      progressBarSelector: "[data-progress-bar]",
      progressReachClass: "cart-progress__container--reached",
      deliveryContainer: "[data-side-cart-delivery]",
      deliveryFreeClass: "cart-footer_delivery--free",
      // Stock message
      stockMessageQuantity: "[data-stock-message-parure]",
      // Cross sell
      crossSellSlider: "[data-cross-sell-slider]",
      crossSellButton: "[data-add-to-cart-cross-sell]",
      crossSellContainer: "[data-container-cross-sell]",
      singleOptionSelector: "data-single-option-selector",
      singleOptionTrigger: "[data-single-option-trigger]",
      originalSelectorId: "data-product-select-cross-sell",
      productJson: "[data-product-json-cross-sell]",
      addToCartText: "[data-add-to-cart-text]",
      cartUpdateKey: "[data-cart-update-key]",
    };

    // merge settings
    settings = $.extend({}, defaultSettings, cartSettings);

    // init cart
    $(document).on("cart.ready", function (event, cart) {
      constructCart(cart);
    });

    $("body").on("change", settings.cartUpdateKey, function () {
      var key = $(this).attr("data-cart-update-key");
      var quantity = $(this).val();
      var item = { id: key, quantity: quantity };
        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          dataType: "json",
          data: item,
          success: function (cart) {
            var url = window.location.href;
            if (url.includes("/cart")) {
              location.reload();
            }
            constructCart(cart);
          },
          error: function (err) {
            console.log("Erreur: " + err);
          },
        });
    });

    // call classic function on click on trigger elemets
    $(settings.toggleCartSelector).on("click", function () {
      if (activateSideCart) {
        toggleCart();
      } else {
        location.href = "/cart";
      }
      return false;
    });

    $("body").on("click", settings.closeCartSelector, function () {
      closeCart();
      return false;
    });

    $(document).on("cart.requestComplete", function (event, cart) {
      event.preventDefault();
      constructCart(cart);
    });

    $("body").on("change", "[data-cart-change-href]", function () {
      var changeUrl = $(this).val();

      jQuery.ajax({
        dataType: "json",
        url: changeUrl,
        success: function (response) {
          constructCart(response);
        },
      });
    });

    $("body").on("click", "[data-cart-remove-href]", function (e) {
        var removeUrl = $(this).data("cart-remove-href");
        jQuery.ajax({
          dataType: "json",
          url: removeUrl,
          success: function (response) {
            constructCart(response);
          },
        });
    });
  }

  function getPrice(price, cart) {
    var price = Number(price / 100).toFixed(2);
    if (cart.currency == "EUR") return price + "€";
    else return price + "$";
  }

  function constructCart(cart) {
    // create elements
    let items = [];
    let c = null;
    let nbrCartItem = 0;

    for (let i = 0, l = cart.items.length; i < l; i++) {
      c = cart.items[i];
      // console.log("C: ", c.properties);
      let product_title = c.product_title;
      if (c.properties["_title"]) product_title = c.properties["_title"];

      let variant_title = c.variant_title;
      if (c.properties["_subtitle"]) variant_title = c.properties["_subtitle"];

      let context = {
        item_image: c.image,
        item_variant_title: variant_title,
        item_variant_id: c.variant_id,
        item_product_title: product_title,
        item_price: c.price,
        item_quantity: c.quantity,
        item_quantity_plus: c.quantity + 1,
        item_quantity_minus: c.quantity - 1,
        item_line_price: getPrice(c.line_price, cart).replace(".00", ""),
        item_url: c.url,
        item_product_type: c.product_type,
        item_properties: c.properties,
        item_sku: c.sku,
        item_handle: c.handle,
        item_key: c.key,
      };

      nbrCartItem += c.quantity;
      items.push(context);
    }

    if (nbrCartItem > 0) {
      $(settings.sideCartEmpty).addClass("hide");
      $(settings.cartFooterContent).removeClass("hide");
      $(settings.cartSelector + " form").removeClass("hide");
    } else if (nbrCartItem == 0) {
      $(settings.sideCartEmpty).removeClass("hide");
      $(settings.cartSelector + " form").addClass("hide");
      $(settings.cartFooterContent).addClass("hide");
    }

    if ($("#cart-items").length != 0 && $("#cart-items__result").length != 0) {
      updateCartItems(items, cart);
    }

    $(settings.cartTotalPriceSelector).html(getPrice(cart.total_price, cart));
    $(settings.cartCount + " span").html(nbrCartItem);

    // Change progress bar
    var price = cart.total_price;
    var progressGoal = $(settings.progressPriceSelector).attr(
      settings.progressGoalAttr
    );
    var relation = (price / progressGoal) * 100;
    var difference = ((progressGoal - price) / 100)
      .toString()
      .replace(".", ",");
    $(settings.progressPriceSelector).html(difference);
    if (relation >= 100) {
      $(settings.progressContainerSelector).addClass(
        settings.progressReachClass
      );
      $(settings.deliveryContainer).addClass(settings.deliveryFreeClass);
      $(settings.progressBarSelector).width("100%");
    } else {
      $(settings.progressContainerSelector).removeClass(
        settings.progressReachClass
      );
      $(settings.deliveryContainer).removeClass(settings.deliveryFreeClass);
      if (relation <= 0) relation = 0;
      $(settings.progressBarSelector).width(relation + "%");
    }

    // Cross sell
    var $container = $(settings.crossSellContainer);
    if ($container != undefined && $container.length > 0) {
      var productSingleObject = JSON.parse(
        $(settings.productJson, this.$container).html()
      );

      Object.entries(productSingleObject).forEach(([key, prop], i) => {
        var product = prop;

        var options = {
          $container: $container,
          enableHistoryState: $container.data("enable-history-state") || false,
          singleOptionSelector:
            "[" + settings.singleOptionSelector + "-" + i + "]",
          originalSelectorId: "[" + settings.originalSelectorId + "-" + i + "]",
          product: product,
        };

        this.variants = new slate.Variants(options);
      });

      $container.on("variantChange", updateAddToCartState.bind(this));

      $(settings.singleOptionTrigger).click(function () {
        $(this).prev().click();
        $(this)
          .parents(".selector-wrapper")
          .find(settings.singleOptionTrigger)
          .each(function () {
            $(this).removeClass("selected");
          });
        $(this).addClass("selected");
      });

      var $crossSellSlider = $(settings.crossSellSlider).flickity({
        wrapAround: true,
        imagesLoaded: true,
        pageDots: false,
        groupCells: 1,
        contain: true,
        adaptiveHeight: true,
        arrowShape: { x0: 50, x1: 50, y1: 0, x2: 50, y2: 0, x3: 50 },
      });

      $crossSellSlider.on("ready.flickity", function () {
        $crossSellSlider.resize();
        $(selectors.productSlider).css("opacity", 1);
        $(selectors.productThumbnail).css("opacity", 1);
      });
    }

    // UPDATE GIFT QTY
    $("[data-cart-gift-quantity]").on("change", function () {
      var qty = parseInt($(this).find(":selected").text());
      var price = $("[data-cart-gift-price]")[0];
      price = parseFloat($(price).attr("data-cart-gift-price"));
      price = parseFloat(price).toFixed(2);

      price = parseFloat(price * qty);

      $("[data-cart-gift-price]").html(price + "€");
    });

    // console.log("loading end");
    $("[data-cart-items-content]").removeClass("hide");
    $("[data-cart-loading]").addClass("hide");
  }

  function updateAddToCartState(evt) {
    var variant = evt.variant;
    var currentContainer = ".carousel-cell.is-selected";

    if (!variant) {
      $(currentContainer + " " + settings.crossSellButton).prop(
        "disabled",
        true
      );
      $(currentContainer + " " + settings.crossSellButton).addClass(
        "button--disabled"
      );
      $(currentContainer + " " + settings.crossSellButton).html(
        theme.strings.unavailable
      );
      return;
    } else {
      var variantImage = variant.featured_image.src;
      var price = parseFloat(variant.price / 100).toFixed(2);
      var currency = $(currentContainer + " [data-product-price]")
        .html()
        .slice(-1);
      if (currency != "€" && currency != "$") currency = "€";
      $(currentContainer + " [data-product-price]").html(price + currency);
      $(currentContainer + " [data-image-cross-sell]").attr(
        "src",
        variantImage
      );
    }

    if (variant.available) {
      $(currentContainer + " " + settings.crossSellButton).prop(
        "disabled",
        false
      );
      $(currentContainer + " " + settings.crossSellButton).removeClass(
        "button--disabled"
      );
      $(currentContainer + " " + settings.addToCartText).html(
        theme.strings.addToCart
      );
    } else {
      $(currentContainer + " " + settings.crossSellButton).prop(
        "disabled",
        true
      );
      $(currentContainer + " " + settings.crossSellButton).addClass(
        "button--disabled"
      );
      $(currentContainer + " " + settings.addToCartText).html(
        theme.strings.soldOut
      );
    }
  }

  function getProductNameFromProperties(properties){
    let names = [];
    for(let i = 0; i < properties.length; i++){
      if(
        !names.includes(properties[i][0]) &&
        properties[i][0].indexOf("_handle:") === -1 &&
        properties[i][0].indexOf("_quantity:") === -1 &&
        properties[i][0].indexOf("_SKU") === -1
      ){
        names.push(properties[i][0]);
      }
    }
    return names;
  }

  function searchPropertiesByName(props, name , text){
    const output = [];
    for(let i = 0; i < props.length; i++){
      if(props[i][0].indexOf(text) > -1 && props[i][0].indexOf(name) > -1) output.push(props[i])
    }
    return output;
  }

  function setPropertiesInCorrectOrder(props){
    let outputArray = [];
    const productsNames = getProductNameFromProperties(props);
    const numProducts = Math.floor(props.length / productsNames.length);
    productsNames.forEach( (productName, index) => {
      let namePropertie = [];
      namePropertie.push(props.find(propertie => propertie[0] === productName));
      const handleProperties = searchPropertiesByName(props, productName, '_handle:');
      const skuProperties = searchPropertiesByName(props, productName, '_SKU ');
      const quantityProperties = searchPropertiesByName(props, productName, '_quantity:');
      outputArray = outputArray.concat(namePropertie,handleProperties,skuProperties,quantityProperties);
    });

    return outputArray;
  }
  /**
   * Return all the related props to be handled by the cart-item-dot file.
   * @param {Object} props 2 deep level array with the options, SKU, handler and quantity of the product.
   * @param {String} sku sku of the bundle to add to cart.
   * @param {String} parureSku sku of the product to add to cart.
   * @returns {Array} array of objects with the related props, example ["Housse de couette Percale de coton", "Juste Le Vieux Rose / 200x200", "HC2020VIROPER", 2].
   */
  function getItemProps(props, sku, parureSku) {
    if (props.length > 0) {
      let imageOption;
      let name = props[0][0];
      let option = props[0][1];
      let handle = props[1][1];
      let parureSku = props[2][1];
      let quantity;
      props.length > 3 ? quantity = props[3][1] : quantity = "";
      if (typeof option == "string") {
        imageOption = option.toUpperCase();
      } else {
        imageOption = "Une erreur est survenue sur ce produit";
      }
      if (typeof handle === "string" && handle.includes("-")) {
        getBundleInfos(handle, sku, imageOption, parureSku);
      }

      return [name, option, parureSku, quantity];
    }
  }

  function getBundleInfos(handle, sku, imageOption, parureSku) {

    const inventoryQuery =
      `
        {
            productByHandle(handle: "` + handle + `") {
              id
              title
              variants(first: 100) {
                edges {
                  node {
                        availableForSale
                        quantityAvailable
                        id
                        title
                        sku
                        image {
                            src
                            altText
                        }
                        product {
                            productType
                            tags
                            title
                        }
                    }
					}
				}
            }
        }
        `;

    const params = {
      query: inventoryQuery,
    };

    const optionsQuery = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Shopify-Storefront-Access-Token": "2bd4994327f59bcd1ea4aeadf72c7034",
      },
      body: JSON.stringify(params),
    };

    const url_prod = 'https://www.bonsoirs.com';

    return fetch(`${url_prod}/api/2023-01/graphql`, optionsQuery)
      .then((res) => res.json())
      .then((response) => {
        let matiere, title, alt, src;
        let variantsArray = response.data.productByHandle.variants.edges;
        variantsArray.forEach((variant) => {
          const productTitle = variant.node.product.title;
          let variantTitle = variant.node.title.toUpperCase();
          if(variantTitle.indexOf('/') === -1 && imageOption.indexOf('/') > -1)
            if(imageOption.includes("/ ")
              && (productTitle ===  "Sets de table x2" || productTitle === "Serviettes de table x2")) {
              imageOption = imageOption.split('/ ')[1].trim();
            }else {
              imageOption = imageOption.split('/')[0].trim();
            }
          if (variantTitle == imageOption.toUpperCase() || variantTitle.indexOf(imageOption.toUpperCase()) > -1) {
            // STOCK: second validation is created because bundles can't use stock
            if (!parureSku && handle !== "maxi-coussin-en-lin-lave") {
              if (
                variant.node.quantityAvailable < 16 &&
                variant.node.quantityAvailable > 0
              ) {
                var newText = $(settings.stockMessageQuantity)
                  .text()
                  .replace(
                    "##stock##",
                    "<span>" + variant.node.quantityAvailable + "</span>"
                  );
                $("#stock-message-" + sku)
                  .html(newText)
                  .addClass("cart-stock-message--quantity")
                  .attr("data-quantity", variant.node.quantityAvailable);
                if (variant.node.quantityAvailable < 11) {
                  $("#product-quantity-" + sku + " > option").each(function () {
                    if (variant.node.quantityAvailable < this.value) {
                      $(this).attr("disabled", true);
                      $(this).hide();
                    }
                  });
                }
              }
            } else {
              src = variant.node.image.src;
              alt = variant.node.image.altText;
              if (
                variant.node.product.tags.find((a) => a.includes("__matiere"))
              ) {
                matiere = variant.node.product.tags
                  .find((a) => a.includes("__matiere"))
                  .split(":")[1];
                title = variant.node.product.title.replace(matiere, "");
                $(".bundle-title-" + parureSku).each(function () {
                  $(this).html(title).fadeTo("fast", 1);
                });
              }
              $(".bundle-image-" + parureSku).each(function () {
                $(this).attr("src", src);
              });
              $(".bundle-image-" + parureSku).each(function () {
                $(this).attr("alt", alt);
              });

              if (variant.node.product.productType.includes("couette")) {
                if (variant.node.quantityAvailable < 16) {
                  var newText = $(settings.stockMessageQuantity)
                    .text()
                    .replace(
                      "##stock##",
                      "<span>" + variant.node.quantityAvailable + "</span>"
                    );
                  $("#stock-message-" + sku)
                    .html(newText)
                    .addClass("cart-stock-message--quantity")
                    .attr("data-quantity", variant.node.quantityAvailable);
                  if (variant.node.quantityAvailable < 11) {
                    $("#product-quantity-" + sku + " > option").each(
                      function () {
                        if (variant.node.quantityAvailable < this.value) {
                          $(this).attr("disabled", true);
                          $(this).hide();
                        }
                      }
                    );
                  }
                }
              }
            }
          }
        });

        loopQuantityMessage();
      });
  }

  function loopQuantityMessage() {
    var minValue;
    var minItem;
    $("#stock-message-timer").addClass("cart-stock-message--hide");
    $(".cart-stock-message--quantity").each(function () {
      $(this).addClass("cart-stock-message--hide");
      var val = parseInt($(this).attr("data-quantity"), 10);
      if (val && (!minItem || val < minValue)) {
        minItem = this;
        minValue = val;
      }
    });

    if (minItem) {
      $(minItem).removeClass("cart-stock-message--hide");
    } else {
      $("#stock-message-timer").removeClass("cart-stock-message--hide");
    }
  }

  function arrangeOrderProductsCart(products, item){
    let newOrder = [];
    if(item.item_handle === "pack-lit-percale" ||
      item.item_handle === "pack-lit-satin" ||
      item.item_handle === "pack-lin-lave" ||
      item.item_handle === 'pack-literie-naturelle' ||
      item.item_handle === 'pack-literie-synthetique' ||
      item.item_handle === 'maxi-coussin-en-lin-lave'
    ){
      let correctOrder;
      // Order by Handle
      switch (item.item_handle) {
        case 'pack-lit-percale':
          correctOrder = "draps-housse-percale-de-coton,housses-de-couette-percale-de-coton,taies-doreiller-percale-de-coton,couette-naturelle,oreiller-naturel";
          break;
        case 'pack-lit-satin':
          correctOrder = "draps-housse-satin-de-coton,housses-de-couette-satin-de-coton,taies-doreiller-satin-de-coton,couette-naturelle,oreiller-naturel";
          break;
        case 'pack-lin-lave':
          correctOrder = "drap-housse-lin-lave,housse-de-couette-lin-lave,taies-doreiller-lin-lave,couette-naturelle,oreiller-naturel";
          break;
        case 'pack-literie-naturelle':
          correctOrder = "couette-naturelle,oreiller-naturel,le-protege-matelas,les-protege-oreillers";
          break;
        case 'pack-literie-synthetique':
          correctOrder = "la-couette-synthetique,loreiller-synthetique,le-protege-matelas,les-protege-oreillers";
          break;
        default:
          break;
      }
      if(correctOrder != "" && correctOrder != undefined){
        correctOrder = correctOrder.split(",");
        correctOrder.forEach(productHandle => {
          let productName = ""
          let tempNewOrder = [];
          // Get product name by Handle
          products.forEach(product => {
            if (product[1] === productHandle)
              productName = product[0].replace("_handle:", "").trim();
          })

          tempNewOrder = products.filter(item =>{
            if(item[0].indexOf(productName) > -1){
              return true;
            }
            return false;
          });
          newOrder = newOrder.concat(tempNewOrder);
        });
      }else {
        newOrder = products;
      }
    }else {
      newOrder = products;
    }
    return newOrder;
  }

  function updateCartItems(items, cart) {
    let itemArr = [];
    let giftItem = [];

    items.forEach((item) => {
      if (
        item.item_product_type == "Parure" ||
        item.item_product_type == "Literie"
      ) {
        jQuery.ajax({
          dataType: "json",
          url: item.item_url,
          success: function (parure) {
            item["parure"] = parure.product;
          },
          error: function (error) {
            console.log(error);
          }
        });
      }
      itemArr.push(item);
    });
    itemArr.forEach(function (item, index, object) {
      let isBroderie;
      let isBundleChild;
      let broderieInfos = {};
      let broderieValue,
        broderie_handle,
        broderie_variant_id,
        broderieText1,
        broderieText2,
        broderieColor1,
        broderieColor2,
        broderieFont,
        broderiePrice;

      Object.entries(item.item_properties).forEach(([key, prop], i) => {
        // if is gift
        if (typeof prop === "string" && prop.includes("gift")) {
          giftItem.push(item);
        }

        // if has broderie
        if (key && key == "_Token") {
          broderieValue = prop;
          isBroderie = true;
        } else if (key && key == "_Ref") {
          var props = prop.split("#");
          broderie_handle = props[0];
          broderie_variant_id = props[1];
        }
        if (key && key == "_TEXTE1") {
          broderieText1 = prop;
        } else if (key && key == "_TEXTE2") {
          broderieText2 = prop;
        } else if (key && key == "_COULEUR1") {
          broderieColor1 = prop;
        } else if (key && key == "_COULEUR2") {
          broderieColor2 = prop;
        } else if (key && key == "_FONT") {
          broderieFont = prop;
        } else if (key && key == "_Price") {
          broderiePrice = prop;
        }
      });
      //remove duplicated SKU
      let filteredItems = [];
      let keyConverted;
      Object.entries(item.item_properties).map(([key, prop], i) => {
        let propReplaced;
        if(typeof prop === "string" && !key.includes("_handle:") && !key.includes("_quantity:") && !key.includes("_SKU ")){
          //matches a x followed by a digit (x2, x10) and split the item
          propReplaced = prop.endsWith("x") ? prop.split("x") : prop.split(/x\d$/);
          propReplaced = propReplaced.map(propItem =>  propItem.trim().endsWith("/") ? propItem.split("/")[0].trim() : propItem)
          if(propReplaced.length >= 2){
            propReplaced.splice(propReplaced.length - 1, 1);
            propReplaced = propReplaced.join("x").trim();
          }else{
            propReplaced = prop;
          }
        }else{
          propReplaced = prop;
        }
        keyConverted = key.replace(" | 1", "").trim();
        if((!keyConverted.includes("|")))	{
          filteredItems.push([keyConverted, propReplaced]);
        }
      });
      filteredItems = arrangeOrderProductsCart(filteredItems, item);
      // if has parure|
      if((item.item_product_type.includes("Parure") ||
              item.item_product_type.includes("Bundle bain")) &&
              filteredItems.length >= 20 &&
              filteredItems[12][0] == "properties"
            ){
          let bundleInfosNew =[];
          let skuItems = [];
          skuItems = Object.keys(item.item_properties);
          skuItems = skuItems.filter(item => item.indexOf("_SKU") > -1);
          if(skuItems.length === 3){
            let bundle1 = filteredItems.slice(0, 4);
            let bundle2 = filteredItems.slice(4, 8);
            let bundle3 = filteredItems.slice(8, 12);
            bundleInfosNew = [
            getItemProps(bundle1, item.item_sku),
            getItemProps(bundle2, item.item_sku),
            getItemProps(bundle3, item.item_sku)
            ]
          }else {

            let bundle1 = filteredItems.slice(0, 4);
            let bundle2 = filteredItems.slice(4, 8);
            let bundle3 = filteredItems.slice(8, 12);
            let bundle4 = filteredItems.slice(12, 16);
            let bundle5 = filteredItems.slice(16, 20);
            bundleInfosNew = [
            getItemProps(bundle1, item.item_sku),
            getItemProps(bundle2, item.item_sku),
            getItemProps(bundle3, item.item_sku),
            getItemProps(bundle4, item.item_sku),
            getItemProps(bundle5, item.item_sku),
            ];
          }
          item["bundle"] = bundleInfosNew;
      }
      else if ((item.item_product_type.includes("Parure") ||
          item.item_product_type.includes("Bundle bain")) &&
          filteredItems.length >= 20 && (filteredItems[9][0] != "properties")
          ) {
        let bundle1 = filteredItems.slice(0, 4);
        let bundle2 = filteredItems.slice(4, 8);
        let bundle3 = filteredItems.slice(8, 12);
        let bundle4 = filteredItems.slice(12, 16);
        let bundle5 = filteredItems.slice(16, 20);
        let bundleInfosNew = [
          getItemProps(bundle1, item.item_sku),
          getItemProps(bundle2, item.item_sku),
          getItemProps(bundle3, item.item_sku),
          getItemProps(bundle4, item.item_sku),
          getItemProps(bundle5, item.item_sku),
        ];

        item["bundle"] = bundleInfosNew;
      }
      else if ((item.item_product_type.includes("Parure") ||
          item.item_product_type.includes("Bundle bain")) &&
          filteredItems.length >= 16 && (filteredItems[9][0] != "properties")
          ) {
        let bundle1 = filteredItems.slice(0, 4);
        let bundle2 = filteredItems.slice(4, 8);
        let bundle3 = filteredItems.slice(8, 12);
        let bundle4 = filteredItems.slice(12, 16);
        let bundleInfosNew = [
          getItemProps(bundle1, item.item_sku),
          getItemProps(bundle2, item.item_sku),
          getItemProps(bundle3, item.item_sku),
          getItemProps(bundle4, item.item_sku),
        ];

        item["bundle"] = bundleInfosNew;
      }
      else if ((item.item_product_type.includes("Parure") ||
          item.item_product_type.includes("Bundle bain")) &&
          filteredItems.length >= 12 && (filteredItems[9][0] != "properties")
          ) {
        let bundle1 = filteredItems.slice(0, 4);
        let bundle2 = filteredItems.slice(4, 8);
        let bundle3 = filteredItems.slice(8, 12);
        let bundleInfosNew = [
          getItemProps(bundle1, item.item_sku),
          getItemProps(bundle2, item.item_sku),
          getItemProps(bundle3, item.item_sku),
        ];

        item["bundle"] = bundleInfosNew;
      }
      else if((item.item_product_type.includes("Parure") ||
              item.item_product_type.includes("Bundle bain")) &&
              filteredItems.length >= 12 &&
              filteredItems[9][0] == "properties"
            ){
        let bundle1 = filteredItems.slice(0, 3);
        let bundle2 = filteredItems.slice(3, 6);
        let bundle3 = filteredItems.slice(6, 9);
        let bundleInfosNew = [
          getItemProps(bundle1, item.item_sku),
          getItemProps(bundle2, item.item_sku),
          getItemProps(bundle3, item.item_sku),
        ];
        item["bundle"] = bundleInfosNew;
      }
      else if ((item.item_product_type.includes("Parure") ||
              item.item_product_type.includes("Bundle bain")) &&
              filteredItems.length >= 9
              ) {
        let bundle1 = filteredItems.slice(0, 3);
        let bundle2 = filteredItems.slice(3, 6);
        let bundle3 = filteredItems.slice(6, 9);

        let bundleInfosNew = [
          getItemProps(bundle1, item.item_sku),
          getItemProps(bundle2, item.item_sku),
          getItemProps(bundle3, item.item_sku),
        ];

        item["bundle"] = bundleInfosNew;
      } else if(item.item_product_type.includes("Parure") && filteredItems.length >= 8) {
        let bundle1 = filteredItems.slice(0, 4);
        let bundle2 = filteredItems.slice(4, 8);
        let bundleInfosNew = [
          getItemProps(bundle1, item.item_sku),
          getItemProps(bundle2, item.item_sku),
        ];

        item["bundle"] = bundleInfosNew;
      } else if (item.item_product_type.includes("Bundle bain") && filteredItems.length >= 8) {
        let bundle1 = filteredItems.slice(0, 4);
        let bundle2 = filteredItems.slice(4, 8);
        let bundleInfosNew = [
          getItemProps(bundle1, item.item_sku),
          getItemProps(bundle2, item.item_sku),
        ];

        item["bundle"] = bundleInfosNew;
      }
      else if (item.item_product_type.includes("Table") &&
              (filteredItems.length == 8 ||
                filteredItems.length == 17 ||
                filteredItems.length == 19)
              ) {
        let bundle1 = filteredItems.slice(0, 4);
        let bundle2 = filteredItems.slice(4, 8);
        let bundleInfosNew = [
          getItemProps(bundle1, item.item_sku),
          getItemProps(bundle2, item.item_sku),
        ];

        item["bundle"] = bundleInfosNew;
      }
      else if(
        item.item_product_type.includes("Pyjama") ||
        item.item_product_type.includes("Homewear") &&
        filteredItems.length == 8
      ){
        let bundle1 = filteredItems.slice(0, 3);
        let bundle2 = filteredItems.slice(4, 7);
        let bundleInfosNew = [
          getItemProps(bundle1, item.item_sku),
          getItemProps(bundle2, item.item_sku),
        ];

        item["bundle"] = bundleInfosNew;
      }else if (
        item.item_product_type.includes("Pyjama") ||
        item.item_product_type.includes("Homewear") &&
        filteredItems.length == 17) {
        let bundle1 = filteredItems.slice(0, 4);
        let bundle2 = filteredItems.slice(4, 8);

        let bundleInfosNew = [
          getItemProps(bundle1, item.item_sku),
          getItemProps(bundle2, item.item_sku),
        ];

        item["bundle"] = bundleInfosNew;
      } else if (
        item.item_product_type.includes("Pyjama") ||
        item.item_product_type.includes("Homewear") &&
        filteredItems.length >= 6) {
        let bundle1 = filteredItems.slice(0, 3);
        let bundle2 = filteredItems.slice(3, 6);

        let bundleInfosNew = [
          getItemProps(bundle1, item.item_sku),
          getItemProps(bundle2, item.item_sku),
        ];

        item["bundle"] = bundleInfosNew;
      } else if (filteredItems.length === 20){
        let bundle1 = filteredItems.slice(0, 4);
        let bundle2 = filteredItems.slice(4, 8);
        let bundle3 = filteredItems.slice(8, 12);
        let bundle4 = filteredItems.slice(12, 16);
        let bundle5 = filteredItems.slice(16, 20);
        let bundleInfosNew = [
          getItemProps(bundle1, item.item_sku),
          getItemProps(bundle2, item.item_sku),
          getItemProps(bundle3, item.item_sku),
          getItemProps(bundle4, item.item_sku),
          getItemProps(bundle5, item.item_sku),
        ];

        item["bundle"] = bundleInfosNew;
      } else if (
        item.item_product_type.includes("Literie") ||
        filteredItems.length >= 18) {
        let bundle1 = filteredItems.slice(0, 4);
        let bundle2 = filteredItems.slice(4, 8);
        let bundle3 = filteredItems.slice(8, 12);
        let bundle4 = filteredItems.slice(12, 16);
        let bundleInfosNew = [
          getItemProps(bundle1, item.item_sku),
          getItemProps(bundle2, item.item_sku),
          getItemProps(bundle3, item.item_sku),
          getItemProps(bundle4, item.item_sku),
        ];

        item["bundle"] = bundleInfosNew;
      } else if (filteredItems.length == 6) {
        let bundle1 = filteredItems.slice(0, 3);
        let bundle2 = filteredItems.slice(3, 6);

        let bundleInfosNew = [
          getItemProps(bundle1, item.item_sku),
          getItemProps(bundle2, item.item_sku),
        ];
        item["bundle"] = bundleInfosNew;
      } else if (filteredItems.length == 8) {
        let bundle1 = filteredItems.slice(0, 4);
        let bundle2 = filteredItems.slice(4, 8);

        let bundleInfosNew = [
          getItemProps(bundle1, item.item_sku),
          getItemProps(bundle2, item.item_sku),
        ];
        item["bundle"] = bundleInfosNew;
      } else if (filteredItems.length == 16) {
        let bundle1 = filteredItems.slice(0, 4);
        let bundle2 = filteredItems.slice(4, 8);
        let bundle3 = filteredItems.slice(8, 12);
        let bundle4 = filteredItems.slice(12, 16);
        let bundleInfosNew = [
          getItemProps(bundle1, item.item_sku),
          getItemProps(bundle2, item.item_sku),
          getItemProps(bundle3, item.item_sku),
          getItemProps(bundle4, item.item_sku),
        ];

        item["bundle"] = bundleInfosNew;
      } else if (item.item_product_type != "broderie") {
        getBundleInfos(
          item.item_handle,
          item.item_sku,
          item.item_variant_title
        );
      }
      if (item.item_product_title.toLowerCase().includes("pyjama enfant")) {
        isBundleChild = true;
        item["isBundleChild"] = isBundleChild;
      }

      if (isBroderie) {
        let newPrice = getPrice(
          (parseInt(broderiePrice) + parseInt(item.item_price)) *
          item.item_quantity,
          cart
        ).replace(".00", "");

        broderieInfos["broderieValue"] = broderieValue;
        broderieInfos["broderieText1"] = broderieText1;
        broderieInfos["broderieText2"] = broderieText2;
        broderieInfos["broderieColor1"] = broderieColor1;
        broderieInfos["broderieColor2"] = broderieColor2;
        broderieInfos["broderieFont"] = broderieFont;
        broderieInfos["newPrice"] = newPrice;

        item["isBroderie"] = isBroderie;
        item["broderieInfos"] = broderieInfos;
      }
    });

    if (giftItem.length > 0) {
      $("#cart-gift__result").removeClass("hide");
      $("#cart-gift-container").addClass("hide");
    } else {
      $("[data-open-cart-gift]").prop("checked", false);
      $("#cart-gift__result").addClass("hide");
      $("#cart-gift-container").removeClass("hide");
    }

    // Cart item template
    let tempFn = doT.template(document.getElementById("cart-items").innerHTML);
    let resultText = tempFn({
      items: itemArr,
    });
    document.getElementById("cart-items__result").innerHTML = resultText;

    // Gift item template
    tempFn = doT.template(document.getElementById("cart-gift").innerHTML);
    resultText = tempFn({
      items: giftItem,
    });
    document.getElementById("cart-gift__result").innerHTML = resultText;

    if (
      $("[data-cross-sell-slider]").length > 0 &&
      $("[data-cross-sell-slider]").data("flickity")
    ) {
      $("[data-cross-sell-slider]").data("flickity").resize();
    }
  }

  function openCart() {
    /*
        jQuery.getJSON('/cart.js', function(cart) {
            constructCart(cart);
        } );
        */

    $(window).trigger("closeSearch");

    if ($("body").hasClass("template-cart")) return;

    $(settings.bodySelector).addClass(settings.nonScrollClass);
    $(settings.cartSelector).addClass(settings.openCartClass);
    $(settings.backgroundSelector).addClass(settings.activeBackgroundClass);
    $(settings.headerSelector).addClass(settings.headerNotLight);
    $("#gorgias-chat-container").addClass("hide-element");
  }

  function closeCart() {
    $("[data-cart-gift]").removeClass("side-cart-gift-open");
    $("[data-open-cart-gift]").prop("checked", false);
    $(settings.bodySelector).removeClass(settings.nonScrollClass);
    $(settings.cartSelector).removeClass(settings.openCartClass);
    $(settings.backgroundSelector).removeClass(settings.activeBackgroundClass);
    $(settings.headerSelector).removeClass(settings.headerNotLight);
    $("#gorgias-chat-container").removeClass("hide-element");
    if ($("body").hasClass("template-cart")) window.location.href = "/";
  }

  function toggleCart() {
    if ($(settings.cartSelector).hasClass(settings.openCartClass)) closeCart();
    else openCart();
  }

  return cart;
})();

var cart = new theme.cart();

$(function () {
  $("[data-open-cart-gift]").change(function () {
    if ($(this).is(":checked")) {
      $("[data-cart-gift]").addClass("side-cart-gift-open");
    }
  });

  $("[data-close-cart-gift]").on("click", function () {
    $("[data-cart-gift]").removeClass("side-cart-gift-open");
    $("[data-open-cart-gift]").prop("checked", false);
  });

  $("[data-add-to-cart-cross-sell]").click(function (e) {
    e.preventDefault();
    var container = $("[data-cross-sell-slider]").find(".is-selected");

    var price = container.find("[data-product-price]").html();
    var title = container.find(".cross-sell__product-title a").html();
    title = title.trim();

    var $form = $(this).closest("form");
    var data = getFormData($form);

    var variant = " - ";
    if (data["Color"] != undefined && data["Taille"] != undefined) {
      variant = data["Color"] + " / " + data["Taille"];
    } else if (data["Color"] != undefined) {
      variant = data["Color"];
    } else if (data["Taille"] != undefined) {
      variant = data["Taille"];
    }

    if (typeof ga != "undefined") {
      ga("send", {
        hitType: "event",
        eventCategory: "upsell",
        eventAction: "add",
        eventLabel: title + variant,
        eventPrice: price,
      });
    }
    addProduct(data, true);
  });

  $("[data-checkout-button-side-cart]").click(function (e) {
    if ($("[data-accept]").is(":checked") == false) {
      e.preventDefault();
    } else {
      window.location.href = "/checkout";
      // $('[data-side-cart-form]').submit();
    }
  });
});

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function () {
  var $newAddressForm = $("#AddressNewForm");

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector(
      "AddressCountryNew",
      "AddressProvinceNew",
      {
        hideElement: "AddressProvinceContainerNew",
      }
    );
  }

  // Initialize each edit form's country/province selector
  $(".address-country-option").each(function () {
    var formId = $(this).data("form-id");
    var countrySelector = "AddressCountry_" + formId;
    var provinceSelector = "AddressProvince_" + formId;
    var containerSelector = "AddressProvinceContainer_" + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector,
    });
  });

  // Toggle new/edit address forms
  $(".address-new-toggle").on("click", function () {
    $newAddressForm.toggleClass("hide");
  });

  $(".address-edit-toggle").on("click", function () {
    var formId = $(this).data("form-id");
    $("#EditAddress_" + formId).toggleClass("hide");
  });

  $(".address-delete").on("click", function () {
    var $el = $(this);
    var formId = $el.data("form-id");
    var confirmMessage = $el.data("confirm-message");
    if (
      confirm(confirmMessage || "Are you sure you wish to delete this address?")
    ) {
      Shopify.postLink("/account/addresses/" + formId, {
        parameters: { _method: "delete" },
      });
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function () {
  var config = {
    recoverPasswordForm: "#RecoverPassword",
    hideRecoverPasswordLink: "#HideRecoverPasswordLink",
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on("click", onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on("click", onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === "#recover") {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $("#RecoverPasswordForm").toggleClass("hide");
    $("#CustomerLoginForm").toggleClass("hide");
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $(".reset-password-success");

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $("#ResetSuccess").removeClass("hide");
  }
})();

$(document).ready(function () {
  var sections = new slate.Sections();
  sections.register("product", theme.Product);
  sections.register("bundle", theme.Bundle);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $(".in-page-link").on("click", function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = ".rte table";

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: "rte__table-wrapper",
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: "rte__video-wrapper",
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className =
      document.documentElement.className.replace(
        "supports-no-cookies",
        "supports-cookies"
      );
  }
});

/*================ Custom ================*/

theme.banner = new (function () {
  var settings = {};

  function banner(bannerSettings) {
    var defaultSettings = {
      headerSelector: "#shopify-section-header",
      bannerSelector: "[data-banner]",
      selectorData: "banner",
      prevNextButtons: false,
      pageDots: false,
      autoPlay: 3000,
    };

    $(document).ready(function () {
      resizeWindow();
    });

    window.addEventListener("resize", function () {
      resizeWindow();
    });

    $(window).scroll(function () {
      document.documentElement.style.setProperty(
        "--header-height-real",
        $(".header").height() + "px"
      );
    });

    settings = $.extend({}, defaultSettings, bannerSettings);

    $(settings.bannerSelector).each(function () {
      var el = $(this);

      $(this).imagesLoaded(function () {
        var elementSettings = $(el).data(settings.selectorData);
        var finalSettings = $.extend({}, settings, elementSettings);

        var $flick = $(el).flickity({
          autoPlay: finalSettings.autoPlay,
          lazyLoad: "true",
          pageDots: finalSettings.pageDots,
          prevNextButtons: finalSettings.prevNextButtons,
        });
        if (finalSettings.changeMobileButton) {
          $flick.on("change.flickity", function (event, index) {
            var cellElement = $flick.flickity("getCellElements")[index];
            var textButton = cellElement.dataset.textButton;
            var urlButton = cellElement.dataset.urlButton;

            $("[data-banner-mobile-button]").html(textButton);
            $("[data-banner-mobile-button]").attr("href", urlButton);
            // cellElement.find('[data-banner-mobile-button]').html(cellElement.attr('data-text-button'));
          });
        }
        $flick.on("dragStart.flickity", function (event, pointer) {
          document.ontouchmove = function (e) {
            e.preventDefault();
          };
        });
        $flick.on("dragEnd.flickity", function (event, pointer) {
          document.ontouchmove = function (e) {
            return true;
          };
        });
      });
    });
  }

  $("[data-promo-close]").on("click", function () {
    $("[data-promo-banner]").addClass("hide");
    Cookies.set("topbarVisibility", false);
    resizeWindow();
  });

  function resizeWindow() {
    var windowWidth = window.innerWidth,
      headerSection = $(settings.headerSelector);

    document.documentElement.style.setProperty(
      "--window-height",
      window.innerHeight + "px"
    );
    if (headerSection) {
      document.documentElement.style.setProperty(
        "--header-height",
        headerSection.height() + "px"
      );
      document.documentElement.style.setProperty(
        "--header-height-real",
        $(".header").height() + $(".header__submobile").height() + "px"
      );
      // console.log("header height real ", $(settings.headerSelector).height());
    }
  }

  return banner;
})();

var banner = new theme.banner();

/** header **/

theme.header = new (function () {
  var settings = {};

  function header(headerSettings) {
    // init default settings
    var defaultSettings = {
      bodySelector: "body",
      nonScrollClass: "non-scroll",
      headerId: "shopify-section-header",
      headerSelector: ".header",
      headerTransparent: "header--transparent",
      toggleSideNav: "[data-header-toggle]",
      sideNavSelector: "[data-header-side-nav]",
      openSideNavClass: "active",
      lightClass: "light",
      headerNotLight: "not-light",
    };

    // merge settings
    settings = $.extend({}, defaultSettings, headerSettings);

    //if ($(settings.headerSelector).hasClass('header--transparent')) {
    checkHeaderStatus();
    $(window).on("scroll", function () {
      checkHeaderStatus();
    });
    //}

    $(settings.toggleSideNav).on("click", function () {
      toggleSideNav();
    });

    resizeWindow();
    createUnderline();
    window.addEventListener("resize", function () {
      resizeWindow();
      createUnderline();
    });
  }

  function createUnderline() {
    $(".header__menu-item").each(function (i) {
      var width = $(this).width();
      $(this).attr("id", "header__menu-item-" + i);
      $("body").append(
        "<style>#header__menu-item-" +
        i +
        ":after{width: " +
        width +
        "px;left:" +
        $(this).offset().left +
        "px;}</style>"
      );
    });
  }

  function openSideNav() {
    $(settings.sideNavSelector).addClass(settings.openSideNavClass);
    $(settings.headerSelector).addClass(settings.headerNotLight);
    $(settings.bodySelector).addClass(settings.nonScrollClass);
  }

  function closeSideNav() {
    $(settings.sideNavSelector).removeClass(settings.openSideNavClass);
    $(settings.headerSelector).removeClass(settings.headerNotLight);
    $(settings.bodySelector).removeClass(settings.nonScrollClass);
  }

  function toggleSideNav() {
    if ($(settings.sideNavSelector).hasClass(settings.openSideNavClass))
      closeSideNav();
    else openSideNav();
  }

  function checkHeaderStatus() {
    var transparencyHeight =
      $(window).height() -
      $(".header").height() -
      $(".header__submobile").height();
    if ($("[data-transparency-height]").length)
      transparencyHeight =
        $("[data-transparency-height]").height() -
        $(".header").height() -
        $(".header__submobile").height();

    if ($(window).scrollTop() > transparencyHeight) {
      if ($(settings.headerSelector).hasClass("light")) {
        $(settings.headerSelector).removeClass("light");
        $(settings.headerSelector).addClass("little");
        $("#" + settings.headerId).addClass("sticky-header");
        if ($(settings.headerSelector).hasClass("header--transparent")) {
          $("#" + settings.headerId).removeClass("absolute-header");
        } else {
          var marginTop = $(settings.headerSelector).height();
          if ($(".header__submobile--link").length > 1) marginTop += 25;
          $("body").css("margin-top", marginTop + "px");
        }
        $(settings.headerSelector).trigger("headerChange");
      }
    } else {
      if ($(settings.headerSelector).hasClass("little")) {
        $(settings.headerSelector).addClass("light");
        $(settings.headerSelector).removeClass("little");
        $("#" + settings.headerId).removeClass("sticky-header");
        if ($(settings.headerSelector).hasClass("header--transparent")) {
          $("#" + settings.headerId).addClass("absolute-header");
        } else {
          $("body").css("margin-top", 0);
        }
        $(settings.headerSelector).trigger("headerChange");
      }
    }
  }

  function resizeWindow() {
    var windowWidth = window.innerWidth,
      headerSection = document.getElementById(settings.headerId);
    document.documentElement.style.setProperty(
      "--window-height",
      window.innerHeight + "px"
    );
    if (headerSection) {
      document.documentElement.style.setProperty(
        "--header-height",
        headerSection.clientHeight + "px"
      );
      document.documentElement.style.setProperty(
        "--header-height-real",
        $(".header").height() + $(".header__submobile").height() + "px"
      );
    }
  }

  return header;
})();

var header = new theme.header();

/** side guide **/

theme.guide = new (function () {
  var settings = {};

  function guide(guideSettings) {
    // init default settings
    var defaultSettings = {
      openGuideSelector: "[data-guide-open]",
      toggleGuideSelector: "[data-guide-toggle]",
      closeGuideSelector: "[data-guide-close]",
      guideSelector: "[data-side-guide]",
      guideItemSelector: "[data-guide-item]",
      guideItemsSelector: "[data-guide-items]",
      guideItemRemoveSelector: "[data-guide-item-remove]",
      guideTotalPriceSelector: "[data-guide-total-price]",
      guideFooterSelector: "[data-guide-footer]",
      updateGuideSelector: "[data-add-to-guide]",
      backgroundSelector: "[data-guide-background-overlay]",
      openGuideClass: "open",
      activeBackgroundClass: "active",
      emptyGuideText:
        '<div class="guide__empty-state heading z-h2">Votre panier est vide</div>',
      headerSelector: ".header",
      headerNotLight: "not-light",
    };
    // merge settings
    settings = $.extend({}, defaultSettings, guideSettings);

    // init guide
    $(document).on("guide.ready", function (event, guide) {
      //console.log('guide ready guide');
      constructGuide(guide, false);
    });

    // call classic function on click on trigger elemets
    $(settings.toggleGuideSelector).on("click", function () {
      toggleGuide();
      return false;
    });

    $("body").on("click", settings.closeGuideSelector, function () {
      closeGuide();
      return false;
    });

    $(settings.openGuideSelector).on("click", function () {
      // Check for guide index
      const attr = $(this).attr("data-guide-idx");
      if (!attr) {
        openGuide();
      } else {
        openGuide(attr);
      }
      return false;
    });

    $(document).on("guide.requestComplete", function (event, guide) {
      constructGuide(guide, true);
    });
  }

  function getPrice(price, guide) {
    var price = Number(price / 100).toFixed(2);
    if (guide.currency == "EUR") return price + "€";
    else return price + "$";
  }

  function constructGuide(guide, open) {
    // create elemets
    var contexts = [];
    var context = {};
    var c = null;
    var final_html = "";
    var source = "";
    var template = null;

    for (var i = 0, l = guide.items.length; i < l; i++) {
      c = guide.items[i];
      var context = {
        item_image: c.image,
        item_variant_title: c.variant_title,
        item_variant_id: c.variant_id,
        item_product_type: c.product_type,
        item_product_title: c.product_title,
        item_price: getPrice(c.price, guide),
        item_quantity: c.quantity,
        item_quantity_plus: c.quantity + 1,
        item_quantity_minus: c.quantity - 1,
        item_line_price: getPrice(c.line_price, guide),
        item_url: c.url,
      };
      source = $(settings.guideItemSelector).html();
      template = Handlebars.compile(source);
      html = template(context);
      final_html += html;
    }

    $(settings.guideTotalPriceSelector).html(
      getPrice(guide.total_price, guide)
    );

    if (guide.items.length > 0) {
      $(settings.guideItemsSelector).html(final_html);
    } else {
      $(settings.guideItemsSelector).html(settings.emptyGuideText);
    }

    if (open) openGuide();
  }

  function openGuide(n = null) {
    if ($("body").hasClass("template-guide")) return;

    if (!n) {
      $(settings.guideSelector).addClass(settings.openGuideClass);
      $(settings.backgroundSelector).addClass(settings.activeBackgroundClass);
      $(settings.headerSelector).addClass(settings.headerNotLight);
    } else {
      $(`${settings.guideSelector}:eq(${n})`).addClass(settings.openGuideClass);
      $(`${settings.backgroundSelector}:eq(${n})`).addClass(settings.activeBackgroundClass);
      $(`${settings.headerSelector}:eq(${n})`).addClass(settings.headerNotLight);
    }
  }

  function closeGuide() {
    $(settings.guideSelector).removeClass(settings.openGuideClass);
    $(settings.backgroundSelector).removeClass(settings.activeBackgroundClass);
    $(settings.headerSelector).removeClass(settings.headerNotLight);
    if ($("body").hasClass("template-guide")) window.location.href = "/";
  }

  function toggleGuide() {
    if ($(settings.guideSelector).hasClass(settings.openGuideClass))
      closeGuide();
    else openGuide();
  }

  return guide;
})();

var guide = new theme.guide();

// Flickity custom wrapper
var addNextReviews = function () {
  var nextName = null;
  var prevName = null;
  $(".reviews__carousel .flickity-prev-next-button.previous").append(
    '<span class="text previous-name">Previous name</span>'
  );
  $(".reviews__carousel .flickity-prev-next-button.next").prepend(
    '<span class="text next-name">Next name</span>'
  );

  $(".reviews__carousel .flickity-prev-next-button.previous").hover(
    function () {
      prevName = null;
      prevName = $(this)
        .parent()
        .find(".carousel-cell.is-selected")
        .prev()
        .attr("data-name");
      if (!prevName)
        prevName = $(this)
          .parent()
          .find(".carousel-cell")
          .last()
          .attr("data-name");
      if (prevName) $(".previous-name").html(prevName);
    }
  );
  $(".reviews__carousel .flickity-prev-next-button.previous").click(
    function () {
      prevName = null;
      prevName = $(this)
        .parent()
        .find(".carousel-cell.is-selected")
        .prev()
        .attr("data-name");
      if (!prevName)
        prevName = $(this)
          .parent()
          .find(".carousel-cell")
          .last()
          .attr("data-name");
      if (prevName) $(".previous-name").html(prevName);
    }
  );
  $(".reviews__carousel .flickity-prev-next-button.next").hover(function () {
    nextName = null;
    nextName = $(this)
      .parent()
      .find(".carousel-cell.is-selected")
      .next()
      .attr("data-name");
    if (!nextName)
      nextName = $(this)
        .parent()
        .find(".carousel-cell")
        .first()
        .attr("data-name");
    if (nextName) $(".next-name").html(nextName);
  });
  $(".reviews__carousel .flickity-prev-next-button.next").click(function () {
    nextName = null;
    nextName = $(this)
      .parent()
      .find(".carousel-cell.is-selected")
      .next()
      .attr("data-name");
    if (!nextName)
      nextName = $(this)
        .parent()
        .find(".carousel-cell")
        .first()
        .attr("data-name");
    if (nextName) $(".next-name").html(nextName);
  });
};

$(function () {
  $("[data-custom-flickity]").each(function () {
    var self = this;
    var $self = $(this);
    try {
      var parameters = JSON.parse($(this).attr("data-custom-flickity"));
    } catch (e) {
      console.log("Error with JSON Parse", e);
    }
    var $carousel = $(this);

    // Fix for lazyload + flickity -- Mac retina
    $(this)
      .find("img.lazyload")
      .each(function () {
        $(this).on("load", function () {
          //console.log('Resize carousel on load');
          $carousel.resize();
          $carousel
            .find(".flickity-viewport")
            .height($carousel.find(".carousel-cell").first().height() + "px");
        });
      });
    $carousel.on("dragStart.flickity", function (event, pointer) {
      document.ontouchmove = function (e) {
        e.preventDefault();
      };
    });
    $carousel.on("dragEnd.flickity", function (event, pointer) {
      document.ontouchmove = function (e) {
        return true;
      };
    });
    // Disable button at slide X
    if (parameters.stopAt) {
      $carousel.on("change.flickity", function (event, index) {
        // console.log('Slide changed to ', index);
        if (index >= parameters.stopAt) {
          $self.find(".flickity-prev-next-button.next").prop("disabled", true);
        } else {
          $self.find(".flickity-prev-next-button.next").prop("disabled", false);
        }
      });
    }
    $carousel.on("ready.flickity", function () {
      $("img.lazyload").on("load", function () {
        //console.log('Resize carousel on load');
        $carousel.resize();
      });
      // Add a class on carousel after loading, and resize
      if (parameters.addClassOnLoad) {
        setTimeout(function () {
          $carousel.addClass(parameters.addClassOnLoad);
          $carousel
            .find(".flickity-viewport")
            .height($carousel.find(".carousel-cell").first().height() + "px");
        }, 3000);
      }
      if (parameters.loadingResize) {
        $carousel
          .find(".flickity-viewport")
          .height($carousel.find(".carousel-cell").first().height() + "px");
      }
      if (parameters.addNextReviews) {
        addNextReviews();
      }
      if (parameters.slidableText) {
        $carousel.on("change.flickity", function (event, index) {
          $carousel
            .parents("section")
            .find(".carousel__slidable-text--activated")
            .removeClass("carousel__slidable-text--activated");
          $carousel
            .parents("section")
            .find('[data-text-index="' + index + '"]')
            .addClass("carousel__slidable-text--activated");
        });
      }
    });

    $carousel.flickity(parameters);
  });
});

$(".sidenav__menu-link--toggle").click(function () {
  $(this).next().slideToggle(100);
  if ($(this).hasClass("open")) $(this).removeClass("open");
  else $(this).addClass("open");
});

// Accordion dropdown
$(".accordion .accordion--question").on("click", function () {
  $(this).next().slideToggle(400);
  $(this).find(".accordion--icon").toggleClass("rotate");
});

$("[data-card-toggle]").on("click", function () {
  $(this).find("svg").toggleClass("rotate");
});

$("[data-scroll-to]").click(function () {
  var className = $(this).attr("data-scroll-to");
  var heightSum = $(".header").height() + $(".header__submobile").height();
  if ($(window).width() > 800) heightSum += 50;
  else heightSum -= 40;

  // console.log('Class name : ', className);
  $("html, body").animate(
    {
      scrollTop: $(className).offset().top - heightSum,
    },
    1500
  );
});

(function () {
  let touchingCarousel = false,
    touchStartCoords;

  document.body.addEventListener("touchstart", function (e) {
    if (e.target.closest(".flickity-slider")) {
      touchingCarousel = true;
    } else {
      touchingCarousel = false;
      return;
    }

    touchStartCoords = {
      x: e.touches[0].pageX,
      y: e.touches[0].pageY,
    };
  });

  document.body.addEventListener(
    "touchmove",
    function (e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      let moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y,
      };

      if (Math.abs(moveVector.x) > 7) e.preventDefault();
    },
    {
      passive: false,
    }
  );
})();

// YOTPO dynamic reviews retrieving
$(function () {
  if (!$(".yotpo-reviews-ajax-container").length) return;

  $.post(
    "https://staticw2.yotpo.com/batch/app_key/3KYs9J4D9I2tc7orpYUhjaZXxamccV6j0qsGdICO/domain_key/yotpononproductrelatedwidget/widget/testimonials",
    {
      methods: JSON.stringify([
        {
          method: "testimonials",
          params: {
            per_page: 1,
            type: "testimonials_custom_tab",
            index: 0,
            element_id: "1",
          },
        },
      ]),
    }
  )
    .done(function (json) {
      const response = JSON.parse(json);
      const matches = response[0]["result"].match(
        /total-reviews-search="(?<nb_reviews>\d+)"/
      );
      if (matches && $(".yotpo-ajax-total-reviews").length) {
        $(".yotpo-ajax-total-reviews").text(matches.groups.nb_reviews);
        $(".yotpo-reviews-ajax-container").fadeIn();
      }
    })
    .fail(function (jqxhr, textStatus, error) {
      console.error(error);
    });
});

$(function () {
  const priceElements = $('[data-display-price]');
  if (priceElements.length == 0) return;

  for (const priceElement of priceElements) {
    let prices = priceElement.getAttribute('data-display-price').split('||');
    const isParurePercale = priceElement.getAttribute('data-is-parure-percale')
    let totalPrice = 0;

    prices = prices.map(function (priceData) {
      return parseInt(priceData.replace('|', ''))
    });

    totalPrice = prices.reduce(function (oldValue, currentValue) {
      return oldValue + currentValue;
    });

    if(isParurePercale === "true") {
      const priceParurePercale = priceElement.getAttribute("data-min-price");
      priceElement.innerHTML = `à partir de <b>${Math.ceil(1 * (priceParurePercale / 100))},00€</b>`;
    }
    else if (priceElement.getAttribute('data-is-pyjama') === '1') {
      priceElement.innerHTML = `à partir de <b>${Math.ceil(0.92 * (totalPrice / 100))},00€</b>`;
    }
    else {
      priceElement.innerHTML = `à partir de <b>${Math.ceil(0.9 * (totalPrice / 100))},00€</b>`;
    }
  }
})


/**
 * Open the recommended product modal only if the abtest it's enabled
 * Verify if the recommended product contains a color equals to the reference product
 * This function contains all the events related, such change the size, add to the cart.
 * @param {String} selectedColor
 * @param {String} selectedSize
 * @author Williams Montes - Yojhan Atuesta
 * @returns Promise
 */
 function openSidePanelSize(selectedColor, selectedSize) {
  let loadedFirstImage = false;
  let findedVariant = false;
  const variantSelects = document.querySelectorAll('.cross-sell-modal .variant');
  const variantsRecommendedProduct = JSON.parse(
    document.querySelector('#recommended_product_data').innerText
  );
  const isColorOption = /([0-9][X|x])\w+/;
  if (selectedColor == '4 saisons') {
    selectedColor = variantsRecommendedProduct[0].option1;
  }
  for (const variant of variantsRecommendedProduct) {
    const colorNormalized = (variant.option1).replace("Juste", "").trim();
    const selectedColorNormalized = (selectedColor).replace("Juste", "").trim();
    switch (!isColorOption.test(colorNormalized)) {
      case true:
        if (colorNormalized != selectedColorNormalized) continue;
      case false:
        if (variant.option1 != selectedSize && selectedSize != '') continue;
    }


    /**
     * Set the selected variant option to be added on the cart and update the price.
     * @param {HTMLElement} _this The element that triggers the event.
     * @author Yojhan Atuesta
     */
    function setSelectedVariant(_this) {
      const productWrapper = document.querySelector('.cross-sell-modal .upsell-prod');
      const priceElement = productWrapper.querySelector('.product__price-span');
      const selectedVariantId = _this.getAttribute('data-option-variant-id');
      const selectedVariantPrice = _this.getAttribute('data-option-variant-price');

      for (let select of variantSelects) {
        if (select.classList.contains('unavailable')) continue;

        const internalVariantId = select.getAttribute('data-option-variant-id');
        if (internalVariantId == selectedVariantId) {
          select.classList.add('selected');
          productWrapper.setAttribute('data-variant-id', selectedVariantId);
          priceElement.innerHTML = selectedVariantPrice;
        } else {
          select.classList.remove('selected');
        }
      }
    }

    findedVariant = true;

    if (!loadedFirstImage) {
      document.querySelector('.cross-sell-modal .upsell-prod img').src = variant.image_url;

      $("body").addClass("non-scroll");
      $("[data-cart-background-overlay]").addClass("active");
      // Also use to close new up-sell side-panel, which leverages existing classes for functionality
      $("[data-side-panel]").addClass("open");
      $("[data-side-panel] [data-cart-footer]").removeClass("hide");
      $("#gorgias-chat-messenger-button").css('display', 'none');
      loadedFirstImage = true;
    }
    for (const variantSelect of variantSelects) {
      const variantSelectedArray = Array.from(variantSelects);
      if (variantSelect.getAttribute('data-option-value') == variant.option2) {
        variantSelect.setAttribute('data-option-variant-id', variant.id);
        variantSelect.setAttribute('data-option-variant-price', variant.price);

        if (!variant.available) {
          variantSelect.classList.add('unavailable');
        } else {
          variantSelect.classList.remove('unavailable');
        }
      }
      if (variantSelectedArray.length === 1) {
        const variantSelected = document.querySelectorAll('.cross-sell-modal .variant')[0];
        const variantContainer = document.querySelector(".variants-container");
        const choiseText = document.querySelector(".choise-text");
        const productPriceText = document.querySelector(".product__price-span");
        variantContainer.classList.add("hide--force");
        choiseText.classList.add("hide--force");
        productPriceText.style.margin = "10px 0";
        setSelectedVariant(variantSelected);
      }
    }
  }

  if (!findedVariant) {
    return Promise.reject();
  }

  $(".cross-sell-modal .variant").click(function () {
    setSelectedVariant(this)
  });

  return new Promise(function (resolve, reject) {
    $('[data-cross-sell-reject]').click(function (event) {
      reject();
      closeSidePanel();
    });


    $('[data-cross-sell-accept]').click(function (event) {
      const variantSelects = document.querySelectorAll('.cross-sell-modal .variant');
      let isVariantSelected = false;

      for (let select of variantSelects) {
        if (select.classList.contains('selected')) {
          isVariantSelected = true;
          break;
        }
      }

      if (!isVariantSelected) {
        const warningMessage = document.querySelector('.cross-sell-modal .warning-message');
        warningMessage.classList.remove('hidden');
        setTimeout(function () {
          warningMessage.classList.add('hidden');
        }, 3000);
      } else {
        resolve();
      }
    });
  });

}

let selectedVariantOption;
/**
 * @description Filter color options in crosell modal by selected option variant in Product Page
 * when DOM Content Loaded set selected option in PDP, then create event listeners when changes it,
 * manages a variable selectedVarianOption to save variant parameter, then compare this
 * to filter y array object of recommended variants
 * @author Michael Romero
 */
function filterRecommendedProductVariants() {
  const productContainer = document.querySelector('.product__content');
  const productVariantDetails = Array.from(
    productContainer.querySelectorAll('.variant-details')
  );
  if(productContainer) {
    productVariantDetails.forEach(function(productVariant) {
      const button = productVariant.querySelector('.button--primary');
      const inputElement = productVariant.querySelector('input')
      const letters =  /[a-z]+/gi;
      if(inputElement){
        const inputValue = inputElement.value.replace(letters, '');
        if(button.classList.contains('selected')) {
            selectedVariantOption = inputValue;
        };
        productVariant.addEventListener('click', function(e){
          selectedVariantOption = inputValue;
        })
      }
    })
  }
};

filterRecommendedProductVariants();

/**
 * Open the recommended product modal only if the abtest and type=color params are enabled
 * Take the first size as refer and let the user choice between colors.
 * This function contains all the events related, such change the size, add to the cart.
 * @param {String} selectedColor
 * @param {String} selectedSize
 * @author Williams Montes - Yojhan Atuesta
 * @returns Promise
 */
function openSidePanelColor(selectedColor, selectedSize) {
  let loadedFirstImage = false;
  let findedVariant = false;
  const variantColors = document.querySelectorAll('.colors-container')[0].childNodes;
  const variantSelects = document.querySelectorAll('.cross-sell-modal .variant');
  const variantsRecommendedProduct = JSON.parse(
    document.querySelector('#recommended_product_data').innerText
  );
  const filteredRecommendedVariants = variantsRecommendedProduct.filter(
    function(variant) {
      return variant.option2.toString().includes(selectedVariantOption)
    }
  );
  const colorsContainer = document.querySelector('.colors-container');
  colorsContainer.classList.remove("hide--force")
  for (const variant of filteredRecommendedVariants) {
    /**
     * Set the selected variant option to be added on the cart and update the price.
     * @param {HTMLElement} _this The element that triggers the event.
     * @author Yojhan Atuesta
     */
    function setSelectedVariant(_this) {
      const productWrapper = document.querySelector('.cross-sell-modal .upsell-prod');
      const priceElement = productWrapper.querySelector('.product__price-span');
      const selectedVariantId = _this.getAttribute('data-option-variant-id');

      for (let select of variantSelects) {
        if (select.classList.contains('unavailable')) continue;

        const internalVariantId = select.getAttribute('data-option-variant-id');
        if (internalVariantId == selectedVariantId) {
          select.classList.add('selected');
          productWrapper.setAttribute('data-variant-id', selectedVariantId);
          priceElement.innerHTML = variant.price;
        } else {
          select.classList.remove('selected');
        }
      }
    }

    findedVariant = true;
    //If the image are no seted and the image no contains an url, apply the default url.
    const imageUrlUpsell = document.querySelector('.cross-sell-modal .upsell-prod img')
    if (!loadedFirstImage) {
      imageUrlUpsell.src = imageUrlUpsell.src.length ? imageUrlUpsell.src : variant.image_url;

      $("body").addClass("non-scroll");
      $("[data-cart-background-overlay]").addClass("active");
      // Also use to close new up-sell side-panel, which leverages existing classes for functionality
      $("[data-side-panel]").addClass("open");
      $("[data-side-panel] [data-cart-footer]").removeClass("hide");
      $("#gorgias-chat-messenger-button").css('display', 'none');
      loadedFirstImage = true;
    }

    //verify if the variant is available, else put a class that containt a visual line
    for (variantColor of variantColors) {
      if (variantColor.children) {
        if (variantColor.children[0].getAttribute("data-option-value") == variant.option1) {
          const variantActual = variantColor;
          variantActual.setAttribute('data-option-variant-id', variant.id);
          variantActual.setAttribute('data-option-variant-price', variant.price);
          if (!variant.available) {
            variantActual.classList.add('unavailable');
          } else {
            variantActual.classList.remove('unavailable');
          }
        }
      }
    }
    const variantSelected = document.querySelectorAll('.cross-sell-modal .variant')[0];
    const choiseText = document.querySelectorAll(".choise-text")[0];
    const variantContainer = document.querySelector(".variants-container");
    choiseText.innerHTML = "Choisissez une couleur: "
    variantContainer.classList.add("hide--force");
    setTimeout(() => setSelectedVariant(variantSelected), 200)
  }

  if (!findedVariant) {
    return Promise.reject();
  }
  /**
   * Click event that manage the interaction to change colors in the modal.
   */
  $(".swatch-color__icon").click(function () {
    if(!this.parentNode.classList.contains("unavailable")){
      const itemSelected = filteredRecommendedVariants.find(item =>
        item.option1 == this.getAttribute('data-option-value'));
        document.querySelector('.cross-sell-modal .upsell-prod img').src = itemSelected.image_url;
        const selecteds = document.querySelectorAll(".selected-color");
        const parentNode = this.parentNode;
        for (select of selecteds) {
          select.classList.remove('selected-color');
        }
        const productWrapper = document.querySelector('.cross-sell-modal .upsell-prod');
        const priceElement = productWrapper.querySelector('.product__price-span');
        parentNode.classList.add("selected-color")
        const selectedVariantPrice = parentNode.getAttribute('data-option-variant-price');
        priceElement.innerHTML = selectedVariantPrice;
        productWrapper.setAttribute('data-variant-id', itemSelected.id);
    }
  });

  //Resolve the promise if the user has selected a color
  return new Promise(function (resolve, reject) {
    $('[data-cross-sell-reject]').click(function (event) {
      reject();
      closeSidePanel();
    });

    //verify if the user has selected a color
    $('[data-cross-sell-accept]').click(function (event) {
      const variantSelects = document.querySelectorAll('.colors-container')[0].childNodes;
      let isVariantSelected = false;

      for (let select of variantSelects) {
        if(select.tagName === "DIV" && select.classList.contains("selected-color")){
          isVariantSelected = true;
          break;
        }
      }

      if (!isVariantSelected) {
        const warningMessage = document.querySelector('.cross-sell-modal .warning-message');
        warningMessage.innerHTML = "Vous devez d'abord choisir votre couleur";
        warningMessage.classList.remove('hidden');
        setTimeout(function () {
          warningMessage.classList.add('hidden');
        }, 3000);
      } else {
        resolve();
      }
    });
  });

}

function closeSidePanel() {
  $("body").removeClass("non-scroll");
  $("[data-cart-background-overlay]").removeClass("active");

  // Also use to close new up-sell side-panel, which leverages existing classes for functionality
  $("[data-side-panel]").removeClass("open");
  $("[data-side-panel] [data-cart-footer]").addClass("hide");
  $("#gorgias-chat-messenger-button").css('display', 'block');
}

$('[data-cross-sell-close], .side-cart-overlay').click(function (event) {
  closeSidePanel();
});


/**
 * Search a value on a list of node items (selects with variant prices) with a string given.
 * @param {String} search
 * @returns
 */
 function searchOptionWithValues(search) {
  let searchTrim = search.trim();
  let selectWithOptionsPrice = document.querySelector("[data-product-select]").children;
  const isPackLiterie = document.getElementById('pack-literie');

  if (isPackLiterie) {
    if (searchTrim.includes('Moelleux')) {
      searchTrim = searchTrim.replace(/Moelleux \/ /g, "");
    }
    if (searchTrim.includes('Mi-ferme')) {
      searchTrim = searchTrim.replace(/Mi-ferme \/ /g, "");
    }
    if (searchTrim.includes('Ferme')) {
      searchTrim = searchTrim.replace(/Ferme \/ /g, "");
    }
  }

  let searchResult = "";
  for(option of selectWithOptionsPrice){
    if(option.innerHTML.trim() == searchTrim){
      searchResult = option;
    }
  }
  return searchResult;
}

function searchSkuRecursive(productItems, selectedName, i, selectedId){
  if(!Array.isArray(productItems)){
    return productItems;
  }else{
    if(i > productItems.length){
      return productItems
    }else{
      let tempSKU = productItems[i]?.find((item) => {
        if(item.color === "4 saisons" || item.color === "Mi-ferme" || item.color === "Moelleux"){
          if(selectedId.getAttribute("value").includes(" / ")){
            return item.size === selectedId.getAttribute("value").split(" / ")[1]
                   && item.color === selectedId.getAttribute("value").split(" / ")[0]
                   && item.available;
          }else{
            return item.size ===  selectedId.getAttribute("value") && item.available;
          }
        }else{
          if(selectedId.getAttribute("value").includes(" / ")){
            return item.color === selectedName && item.size === selectedId.getAttribute("value").split(" / ")[1] && item.available;
          }else{
            return item.color === selectedName && item.size ===  selectedId.getAttribute("value") && item.available;
          }
        }
      });
      if(!tempSKU){
        searchSkuRecursive(productItems, selectedName, i + 1, selectedId)
      }else{
        return tempSKU
      }
    }
  }
}

function searchSkuByString(productItems , find , options){
  if(productItems?.length > 0){
    const variants = options.split('|');
    const values = find.split('/')
    let isTheVariant = false;
    for(let i = 0; i < productItems.length; i++){
      for(let k = 0; k < variants.length; k++){
        if(productItems[i][variants[k]] === values[k].trim()){
          isTheVariant =true
        }else{
          isTheVariant = false
          break;
        }
      }
      if(!isTheVariant){
        continue
      }else{
        return productItems[i].available ? productItems[i] : null;
      }
    }
  }
}

(function (){
  document.addEventListener("DOMContentLoaded", ()=>{
    let optionUrl = window.location.href.indexOf("option");
    if(optionUrl === -1){
      setTimeout(() => {
        const isCollection = document.getElementsByClassName("product-bundle")[0];
        if(isCollection){
            let itemsVariants = document.getElementsByClassName("options-default-metafield")[0];
            if(!itemsVariants) return
            itemsVariants = JSON.parse(itemsVariants.innerHTML);
            const iterableVariants = Object.values(itemsVariants[0]);
            let sizeActual;
            let optionsByIndex;
            for(let i = 0; i < iterableVariants.length; i++){
              sizeActual = iterableVariants[i].split(",")[1].replace("Taille.", "").trim();
              optionsByIndex = document.querySelectorAll(`[index-loop-option='${i}']`);
              for(option of optionsByIndex){
                if(sizeActual === option.getAttribute("data-option")){
                  option.click();
                }
              }
            }
        }
      }, 100)
    }
  })
})()

/**
 * @description Set properties to an object passed throw the params
 * @param {*} properties
 * @param {*} itemsFilteredLength
 * @param {*} productItems
 * @param {*} isParureSize
 * @param {*} selectedName
 */
function setProperties(properties, itemsFilteredLength, productItems, isParureSize, selectedName){
  try {
    const isCompletePack = document.getElementsByClassName("complete-pack").length;
    const isMultiOptions = document.querySelector('[parure-multi-options]')
    let selectSizeId;
    for(let i = 0; i < itemsFilteredLength; i++){
      if(isParureSize){
        if(isCompletePack){
          let prevSize;
          if(productItems[i].length > 0){
            selectSizeId = document.querySelector(`[id*="${productItems[i][0].product_name}"]`);
          }else{
            continue;
          }
            if(!prevSize && selectSizeId){
              prevSize = selectSizeId.getAttribute("value")
            }
            let compareText = `${productItems[i][0].color} / ${selectSizeId?.getAttribute("value") && prevSize} x${productItems[i][0].quantity}`;
            if(compareText.includes("Mi-ferme / Mi-ferme")){
              compareText = compareText.replace("Mi-ferme / ", "").trim()
            }else if(compareText.includes("Moelleux / Moelleux")){
              compareText = compareText.replace("Moelleux / ", "").trim()
            }else if(compareText.includes("Moelleux / Mi-ferme")){
              compareText = compareText.replace(" / Moelleux", "").trim()
            }else if(compareText.includes("Mi-ferme / Moelleux")){
              compareText = compareText.replace("Mi-ferme /", "").trim()
            }else if(compareText.includes(" / Moelleux")){
              compareText = compareText.replace(" / Moelleux", "").trim()
            }else if(compareText.includes(" / Mi-ferme")){
              compareText = compareText.replace(" / Mi-ferme", "").trim()
            }
            properties[productItems[i][0].product_name] = compareText;
            let tempSKU = searchSkuRecursive(productItems, selectedName, i, selectSizeId);
            properties["_handle:" + productItems[i][0].product_name] = productItems[i][0].handler;
            if(productItems[i][0].quantity && Number(productItems[i][0].quantity) > 1){
              for(let k = 0; k < Number(productItems[i][0].quantity); k++){
                properties["_SKU " + productItems[i][0].product_name + ` | ${(k+1)}`] = tempSKU.sku;
              }
            }else{
              properties["_SKU " + productItems[i][0].product_name] = tempSKU.sku;
            }
        }else{
          const isBundlePyjama = Boolean(document.querySelector('[bundle-pyjama]'));
          if(!isBundlePyjama){
            selectSizeId = document.getElementById(`size-select-${productItems[i][0].product_name}`);
            properties[productItems[i][0].product_name] =
              `${productItems[i][0].color} / ${selectSizeId.getAttribute("value")} x${productItems[i][0].quantity}`;
            let tempSKU = searchSkuRecursive(productItems, selectedName, i, selectSizeId)
            properties["_handle:" + productItems[i][0].product_name] = productItems[i][0].handler;
            if(productItems[i][0].quantity && Number(productItems[i][0].quantity) > 1){
              for(let k = 0; k < Number(productItems[i][0].quantity); k++){
                properties["_SKU " + productItems[i][0].product_name + ` | ${(k+1)}`] = tempSKU.sku;
              }
            }else{
              properties["_SKU " + productItems[i][0].product_name] = tempSKU.sku;
            }
          } else {
            let optionType = '';
            let optionSize = '';
            selectSizeId = Array.from(document.getElementById(`size-select-${productItems[i][0].product_name}`)
                          .getElementsByClassName('variant selected'));
            let variationSelected = '';
            selectSizeId.forEach(selectedItem => {
              let optionSelected = selectedItem.getAttribute('option-name');
              if(productItems[i][0].type
                  && optionSelected == 'Type'
                ){
                  optionType =
                `${selectedItem.getAttribute("value")}`;
              }else{
                optionSize =
                `${selectedItem.getAttribute("value")}`;
              }
            });
              variationSelected =
              `${optionType ? optionType + ' / ' : ''}${productItems[i][0].color} / ${optionSize}`;
            properties[productItems[i][0].product_name] =
            `${variationSelected} x${productItems[i][0].quantity}`;
            const orderOptions = productItems[i][0].type ? 'type|color|size' : 'color|size';
            let tempSKU = searchSkuByString(productItems[i], variationSelected , orderOptions );
            properties["_handle:" + productItems[i][0].product_name] = productItems[i][0].handler;
            if(productItems[i][0].quantity && Number(productItems[i][0].quantity) > 1){
              for(let k = 0; k < Number(productItems[i][0].quantity); k++){
                properties["_SKU " + productItems[i][0].product_name + ` | ${(k+1)}`] = tempSKU.sku;
              }
            }else{
              properties["_SKU " + productItems[i][0].product_name] = tempSKU.sku;
            }
          }
        }
      }else{
        if(!productItems[i][0].available) throw new Error("variant don't available, sorry");
        if(productItems[i][0].variant_name){
          properties[productItems[i][0].product_name] = productItems[i][0].variant_name
        }else{
          if(productItems[i][0].color){
            if(isMultiOptions) {
              if('confort' in productItems[i][0]){
                properties[productItems[i][0].product_name] = `${productItems[i][0].color} / ${productItems[i][0].size} / ${productItems[i][0].confort} x${productItems[i][0].quantity}`;
              }
              else if('remplissage' in productItems[i][0]){
                properties[productItems[i][0].product_name] = `${productItems[i][0].color} / ${productItems[i][0].size} / ${productItems[i][0].remplissage} x${productItems[i][0].quantity}`;
              }
              else {
                properties[productItems[i][0].product_name] = `${productItems[i][0].size} / ${productItems[i][0].color} x${productItems[i][0].quantity}`;
              }
            }
            else {
              properties[productItems[i][0].product_name] = `${productItems[i][0].size} / ${productItems[i][0].color} x${productItems[i][0].quantity}`;
            }
          }else if(productItems[i][0].confort){
            properties[productItems[i][0].product_name] = `${productItems[i][0].confort} / ${productItems[i][0].size} x${productItems[i][0].quantity}`;
          }
          else{
            properties[productItems[i][0].product_name] = `${productItems[i][0].size} x${productItems[i][0].quantity}`;
          }
        }
        properties["_handle:" + productItems[i][0].product_name] = productItems[i][0].handler;
        if(productItems[i][0].quantity && Number(productItems[i][0].quantity) > 1){
          for(let k = 0; k < Number(productItems[i][0].quantity); k++){
            properties["_SKU " + productItems[i][0].product_name + ` | ${(k+1)}`] = productItems[i][0].sku;
          }
        }else{
          properties["_SKU " + productItems[i][0].product_name] = productItems[i][0].sku;
        }
      }
      properties["_quantity:" + productItems[i][0].product_name] = productItems[i][0].quantity;
    }
  } catch (error) {
    Object.keys(properties).forEach(key => delete properties[key]);
    console.log(error)
  }
}

function triggerWarnings(){
  const unavailableWarning = Array.from(document.getElementsByClassName('unavailable selected'));
  const textVariantUnavailable = document.querySelector('[data-variant-unavailable]');
  if(unavailableWarning?.length > 0){
    textVariantUnavailable.style.display = "block";
  }else{
    textVariantUnavailable.style.display = "none";
  }
}

function getProductsItems(){
  const productItems = [];
  const $dataCardJson = document.querySelectorAll('[data-card-json]');
  if($dataCardJson.length === 0) return productItems;

  $dataCardJson.forEach(product => productItems.push(JSON.parse(product.textContent))) ;

  return productItems;
}

function getBundle(){
  const $bundle = document.querySelector('[data-product-json]');
  const bundle = JSON.parse($bundle.textContent);
  return bundle;
}

function getOptionContainer(productItem){
  const $element = document.querySelector(`[id*="${productItem.title}"]`);
  const optionName = $element.closest('[data-option-container]').dataset.optionContainer;
  const $containerValue = $element.getElementsByClassName('selected');
  const optionValue = $containerValue.length === 0
  ? $element.closest('[data-option-container]')
              .querySelector('.custom-select__label > p')
              .innerText
  : $containerValue[0].dataset.option;
  return {optionName,optionValue};
}

function getGlobalOptions(){
  // implement logic here if you want generalize the code to get global options
  // like the color
  return {};
}

function getOptionsPositions(product){
  const output ={};
  for(let i = 0; i < product.options.length ; i++){
      output[product.options[i]] = i;
  }
  return output;
}

function getVariant(product, optionsSelected){
  const optionsPositions = getOptionsPositions(product);
  for(let i = 0; i < product.variants.length; i++){
    const variant = product.variants[i];
    let foundVariant = true;
    for(const [option, value] of Object.entries(optionsSelected)){
      if(value.indexOf(' / ') > -1){
        if(!(variant.title.indexOf(value) > -1)){
          foundVariant = false;
          break;
        }
      }else if(!(variant.options[optionsPositions[option]] === value)){
        foundVariant = false;
        break;
      }
    }
    if(foundVariant) return variant;
  }

  return {};
}

function setPropertiesObject(properties, productItem, quantity){
  try {
    const partialObject = {}
    const {optionName,optionValue } = getOptionContainer(productItem);
    const globalOptionsValues = getGlobalOptions();
    partialObject[optionName] = optionValue;

    if (productItem.handle === "les-protege-oreillers") {
      partialObject[optionName] = optionValue.split('/')[1].trim()
    }

    const variant = getVariant(productItem, Object.assign(partialObject,globalOptionsValues));

    if(!variant.available)
      throw new Error(`The item ${variant.title} unavailable`);

    shop.addVariant(variant);
    properties[productItem.title] = variant.title + ` x${quantity}`;
    properties['_handle:'+ productItem.title] = productItem.handle;
    if(quantity > 1){
      Array(quantity).fill(0).forEach((item, index) => {
        properties["_SKU " + productItem.title + ` | ${index+1}`] = variant.sku;
      })
    }else{
      properties['_SKU '+ productItem.title] = variant.sku;
    }
    properties['_quantity:'+ productItem.title] = quantity;
  } catch (error) {
    Object.keys(properties).forEach(key => delete properties[key]);
    console.log(error)
  }

}

function getAllOptions(bundle){
  const options = new Map();
  const $dataCards = document.querySelectorAll(`[data-card]`);
  $dataCards.forEach($dataCard => {
    const tempObj = {};
    let elementSelected = $dataCard.getElementsByClassName('selected')[0]?.dataset.option;
    if(!elementSelected)  elementSelected = $dataCard.querySelector('.custom-select__label > p').innerHTML;
    tempObj[$dataCard.dataset.optionContainer] = elementSelected;
    const $optionContainer = $dataCard.querySelector('[id*="size-select-"]');
    const prevContent = options.get($optionContainer.id) || {};
    options.set($optionContainer.id.replace('size-select-',''),Object.assign(prevContent,tempObj));

  });

  return options;
}

function getProductSelected(bundle){
  const optionsPositions = getOptionsPositions(bundle);
  const optionsSelected = getAllOptions();
  for(let i = 0 ; i < bundle.variants.length; i++){
    const variant = bundle.variants[i];
    let findVariant = true;
    optionsSelected.forEach((value, key) => {
      if((value['Taille']).indexOf(variant.options[optionsPositions[key]]) === -1){
        findVariant = false;
        return;
      }
    });
    if(findVariant) return variant;
  }

  return {};

}

function setCurrentPropertiesToAddToCart(properties){
  const productItems = getProductsItems();
  const bundle = getBundle();
  productItems.forEach(productItem =>{
    let quantity = 1;
    bundle.tags.forEach( tag => {
      if(tag.indexOf(productItem.handle) > -1){
        try {
          quantity = Number(tag.split("|").pop());
          return;
        } catch (error) {
          quantity = 1;
        }
      }
    })
    setPropertiesObject(properties, productItem, quantity);
  });
  const productSelected = getProductSelected(bundle);
  properties.id = productSelected.id;
  properties.quantity = 1;
}

/**
 * @description Add the selected variant to the cart with the properties of the bundle as SKU, handle and quantity.
 * @param {String} productId Product id of the bundle to be added to the cart.
 */
function addToCart(productId){
  let properties = {};
  const isMaxiCoussin = Boolean(document.querySelector('[bundle-maxi-coussin]'));
  const isPackLiterie = document.getElementById('pack-literie');
  const optionsContainer = Array(document.querySelector('[data-product-quantity]'))[0];
  const quantity = optionsContainer ? optionsContainer?.value : 1;
  if(!isPackLiterie && !isMaxiCoussin){
    const parentContainer = document.querySelector(".variants-container-parure");
    const isCompletePack = document.getElementsByClassName("complete-pack").length;
    const isBundlePyjama = Boolean(document.querySelector('[bundle-pyjama]'));
    let productItems = parentContainer.getAttribute("products-items");
    let selectedSizePlaceholder = !isBundlePyjama ?  "xxx / xxx / xxx" : "xxx / xxx";
    const isParureSize = parentContainer.getAttribute("parure-bain-size") || false;
    productItems = JSON.parse(productItems);
    productItems = productItems?.filter(el => el.length != 0);
    const selected = document.getElementsByClassName("swatch-color selected")[0];
    const selectedName = selected.getAttribute("data-product-name");
    const itemsLength = productItems.length;
    let sizeSelects;
    if(isBundlePyjama){
      sizeSelects = document.getElementsByClassName("variant selected");
      Array.from(sizeSelects).forEach((item, index) => {
        let selectedValue = item.getAttribute("value");
        if(selectedValue != 'Pantalon (unisexe)'
          && selectedValue != 'Short (femme)'
        ){
          selectedSizePlaceholder = selectedSizePlaceholder.replace("xxx", selectedValue);
        }
      });
    }else {
      sizeSelects = document.getElementsByClassName("size-select__select");
      Array.from(sizeSelects).forEach((item, index) => {
        selectedSizePlaceholder = selectedSizePlaceholder.replace("xxx", item.getAttribute("value"));
      });
    }
    let optionBySizes = searchOptionWithValues(isParureSize ? selectedSizePlaceholder : selectedName);
    for(let i = 0; i < itemsLength; i++){
      productItems[i] = productItems[i].filter((item) => {
        if(isCompletePack){
          if(item.color === "4 saisons" || item.color === "Mi-ferme" || item.color === "Moelleux"){
            return true;
          }
        }
        if(item.defaultColor) {
          return true
        }
        if(!item.color && item.size){
          return true
        }
        if(item.disable_color){
          return true
        }
        return item.color === selectedName;
      });
    }
    const itemsFilteredLength = productItems.length;
    properties = {
      id: optionBySizes.getAttribute("value"),
      quantity: quantity
    }
    setProperties(properties, itemsFilteredLength, productItems, isParureSize, selectedName);
  }else if (isPackLiterie) {
    setCurrentPropertiesToAddToCart(properties);
  } else if (isMaxiCoussin) {
    properties = JSON.parse(localStorage.bundleMaxiCoussinProps);
  }

  const unavailableWarnMsg = document.querySelector("[data-color-container]");
  const textVariantUnavailable = document.querySelector('[data-variant-unavailable]');
  if((!unavailableWarnMsg || unavailableWarnMsg.children[0].style.display == "none")
  && textVariantUnavailable?.style.display == "none"){
    addProduct(properties);
  }else if((!unavailableWarnMsg || unavailableWarnMsg.children[0].style.display == "none") && textVariantUnavailable == undefined){
    addProduct(properties);
  }
}

/**
 * @description Update the price of the product when a size is changed
 * @param {String} searchPlaceholder Placeholder of the size to be searched
 * @param {Number} i index of the loop
 * @param {HTMLElement} e Element triggered by the listener
 */
function updatePriceSelectSize(searchPlaceholder, i, e){
  const priceSpan = document.querySelector("[data-checkout-text]");
  const priceTitle = document.querySelector("[data-bundle-price]");
  let optionSearched = searchOptionWithValues(searchPlaceholder);
  let previousButtonText = priceSpan.innerHTML.split(" - ");
  if(optionSearched &&  optionSearched !== ""){
    const priceCalculation = `${Math.ceil(1 * (optionSearched.getAttribute("data-product-price") / 100))},00€`
    previousButtonText[1] = priceCalculation;
    const newButtonText = previousButtonText.join(" - ");
    priceSpan.innerHTML = newButtonText;
    priceTitle.innerHTML = priceCalculation;
    if(optionSearched.getAttribute("data-product-available") == "false"){
      const unavailableWarnMsg = document.querySelector("[data-color-container]");
      unavailableWarnMsg.children[0].style.display = "block";
    }
  }
}

/**
 * Manage the select event on the variant size
 */
(function() {
  document.addEventListener("DOMContentLoaded", () => {
  const selectSize = document.getElementsByClassName("size-select__select");
  let searchPlaceholder = "xxx/xxx/xxx";
  const priceSpan = document.querySelector("[data-checkout-text]");
  const priceTitle = document.querySelector("[data-bundle-price]");
  Array.from(selectSize).forEach((item, index) => {
    searchPlaceholder += "xxx" + index < Array.from(selectSize).length ? " " + "/" + " " : "";
  });
  const lengthSize = Array.from(selectSize).length;
  for(let i = 0; i < lengthSize; i++){
    searchPlaceholder = searchPlaceholder.replace("xxx", ` ${selectSize[i].getAttribute("value")} `);
  }
  let optionSearched = searchOptionWithValues(searchPlaceholder);
  let previousButtonText = priceSpan.innerHTML.split(" - ");
  if(optionSearched && optionSearched !== ""){
    const priceCalculation = `${Math.ceil(1 * (optionSearched.getAttribute("data-product-price") / 100))},00€`
    previousButtonText[1] = priceCalculation;
    const newButtonText = previousButtonText.join(" - ");
    priceSpan.innerHTML = newButtonText;
    priceTitle.innerHTML = priceCalculation;
    searchPlaceholder = searchPlaceholder.trim();
  }
  });
})();


/**
 * Manage the color swatch button verifing if the current color has a size relationed available.
 * @param {HTMLElement} e event triggered by a click on the click event.
 */
function clickColorSwatch(e){
  const unavailableItems = document.querySelector('[data-unavailable-items]');
  if(!unavailableItems){
    const unavailableWarnMsg = document.querySelector("[data-color-container]");
    if(unavailableWarnMsg){
      if(e.target.parentNode.classList.contains("swatch-color") &&
      e.target.parentNode.classList.contains("unavailable")){
        unavailableWarnMsg.children[0].style.display = "block";
      }else{
        unavailableWarnMsg.children[0].style.display = "none";
      }
    }
    const parentContainer = document.querySelector(".variants-container-parure");
    const disabledOptions = document.querySelectorAll("[disabled]");
    let itemsUnavailables = [];
    for (option of disabledOptions) {
      option.removeAttribute("disabled");
    }
    itemsUnavailables = [];
    let productItems = parentContainer.getAttribute("products-items");
    productItems = JSON.parse(productItems);
    productItems = productItems?.filter(el => el.length != 0);
    if (e.target.classList.contains("swatch-color__icon")) {
      const variantColorName = e.target.parentNode.getAttribute("data-product-name");
      for (let i = 0; i < productItems?.length; i++) {
        for (let k = 0; k < productItems[i].length; k++) {
          if (productItems[i][k].color === variantColorName && productItems[i][k].available == false) {
            itemsUnavailables.push(productItems[i][k]);
          }
        }
      }
      let selectSize;
      for (item of itemsUnavailables) {
        selectSize = document.querySelector(`[value-option-size="${item.size}-${item.product_name}"]`);
        selectSize && selectSize.setAttribute("disabled", "");
      }
    }
  }
}
function notifyDomUnavailableItemSelected (e) {
  try{
    const addItemsButton = document.querySelector('[data-add-to-cart]');
    const textRegularSpan = addItemsButton.querySelector('[data-checkout-addtocart]');
    const textDisabledSpan = addItemsButton.querySelector('[data-checkout-disabled]');
    const textSoldOutSpan = addItemsButton.querySelector('[data-checkout-soldout]');
    const validateItemsBundle = document.querySelector('[is-bundle-validate-items]');
    const isParureMultiOptions = document.querySelector('[parure-multi-options');
    if(textSoldOutSpan){
      textSoldOutSpan.removeAttribute('style')
    }
    if(validateItemsBundle || isParureMultiOptions) {
      addItemsButton.setAttribute('disabled','');
      addItemsButton.classList.add('button--reverse','button--disabled');
      textDisabledSpan.classList.add('hidden');
      textSoldOutSpan.classList.remove('hidden');
    }else {
      addItemsButton.setAttribute('disabled','');
      addItemsButton.classList.add('button--reverse','button--disabled');
      textRegularSpan.classList.add('hidden');
      textSoldOutSpan.classList.remove('hidden');
    }
  }catch(error){
    console.log(`Error: ${error}`)
  }

}

function notifyDomAvailableItemSelected(){
  try{
    const addItemsButton = document.querySelector('[data-add-to-cart]');
    const textRegularSpan = addItemsButton.querySelector('[data-checkout-addtocart]');
    const textSoldOutSpan = addItemsButton.querySelector('[data-checkout-soldout]');
    const textDisabledSpan = addItemsButton.querySelector('[data-checkout-disabled]');
    const validateItemsBundle = document.querySelector('[is-bundle-validate-items]');
    const isParureMultiOptions = document.querySelector('[parure-multi-options');
    if(textSoldOutSpan){
      textSoldOutSpan.removeAttribute('style')
    }
    if(validateItemsBundle || isParureMultiOptions) {
      addItemsButton.removeAttribute('disabled');
      addItemsButton.classList.remove('button--reverse','button--disabled');
      textDisabledSpan.classList.remove('hidden');
      textSoldOutSpan.classList.add('hidden');
    }
    else {
      addItemsButton.removeAttribute('disabled');
      addItemsButton.classList.remove('button--reverse','button--disabled');
      textRegularSpan.classList.remove('hidden');
      textSoldOutSpan.classList.add('hidden');
    }
  }catch(error){
    console.log(`Error: ${error}`)
  }
}
/**
 * Add color swatch listeners
 */
(function() {
  document.addEventListener("DOMContentLoaded", function(){
    const colorsContainer = document.querySelector(".variants-container-parure");
    clickColorSwatch({target: colorsContainer.children[0]});
    for(color of colorsContainer.children){
      color.addEventListener("click", function(e) {
        clickColorSwatch(e);
        const isSetBain = document.querySelector('[set-bain-complet]');
        const isPackEnfant = document.querySelector('[pack-literie-enfant]');
        if( isSetBain || isPackEnfant ){
          const elementTag = e.target.classList.contains('swatch-color') ? e.target : e.target.parentNode;
          if(e.target.classList.contains('swatch-color'))e.target.children[0].click();
          if(elementTag.classList.contains('unavailable')) {
            notifyDomUnavailableItemSelected(elementTag);
          }
          else {
            notifyDomAvailableItemSelected(elementTag)
          }
        }
      })
    }
  })
})();

/**
 * Manage the size swatch button verifing if the current size has a color relationed available.
 * @param {HTMLElement} e event triggered by a click on the change event.
 */
 function clickSizeSwatch(e){
  const parentContainer = document.querySelector(".variants-container-parure");
  const disabledOptions = document.querySelectorAll(".swatch-color");
  const isPackLiterieSynthetique = document.querySelector("[pack-literie-enfant]");
  const isSetBainComplet = document.querySelector('[set-bain-complet]') || null;
  const detectUnavailable = document.querySelector('[detect-cross-unavailable]') || null;
  let itemsUnavailables = [];
  const isBundlePetitDejeuner = Boolean(document.querySelector('[bundle-petit-dejeuner]'));
  const isBundleEnsemble = Boolean(document.querySelector('[bundle-ensemble]'));
  if(!isBundlePetitDejeuner && !isBundleEnsemble && !isSetBainComplet && !detectUnavailable && !isPackLiterieSynthetique){
    for (option of disabledOptions) {
        option.classList.remove("unavailable");
    }
  }
  itemsUnavailables = [];
  let productItems = parentContainer.getAttribute("products-items");
  productItems = JSON.parse(productItems);
  productItems = productItems?.filter(el => el.length != 0);
  if (e.target?.classList.contains("size-select__select")) {
    const variantSizeSelected = e.target.getAttribute("value");
    for (let i = 0; i < productItems?.length; i++) {
      for (let k = 0; k < productItems[i].length; k++) {
        if (productItems[i][k].size === variantSizeSelected && productItems[i][k].available == false) {
          itemsUnavailables.push(productItems[i][k]);
        }
      }
    }
    let selectSize;
    for (item of itemsUnavailables) {
      selectSize = document.querySelector(`[data-product-name="${item.color}"]`);
      //Please dont remove this comment, in the future will be used to show the no available colors of elements
      // selectSize.classList.add("unavailable")
    }
  }
}

/**
 * Add size swatch listeners
 */
 (function() {
  document.addEventListener("DOMContentLoaded", function(){
    const sizeSwatchs = document.querySelectorAll(".size-select__select");
    clickSizeSwatch({target: sizeSwatchs[0]});
    for(size of sizeSwatchs){
      size.addEventListener("change", function(e) {
        clickSizeSwatch(e);
      })
    }
  })
})();


/**
 * Find a default size and select it from the given selects (list of HTMLElements).
 */
(function(){
  let selectSize = document.getElementsByClassName("size-select__select");
  if (selectSize.length < 1) return
  const isMaxiCoussin = Boolean(document.querySelector('[bundle-maxi-coussin]'));
  if (isMaxiCoussin) return;

  document.addEventListener("DOMContentLoaded", function(){
    let selectedVariants = selectSize[0].getAttribute("selected-variant");
    selectedVariants = selectedVariants.split("|");
    if (selectedVariants?.length === 1) return;
    for(let i =0; i < selectSize.length; i++ ){
      for(option of selectSize[i].children){
        if(option.getAttribute("value")
        ===
        selectedVariants[i].split(",")[1].replace("Taille.", "").trim()){
          option.click()
        }
      }
    }
  })
  const callback = function(mutationsList) {
    for(const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === "value") {
            selectSize = document.getElementsByClassName("size-select__select");
            clickSizeSwatch(mutation);
            let searchPlaceholder = "xxx/xxx/xxx";
            Array.from(selectSize).forEach((item, index) => {
              searchPlaceholder += "xxx" + index < Array.from(selectSize).length ? " " + "/" + " " : "";
            });
            const lengthSize = Array.from(selectSize).length;
            for(let i = 0; i < lengthSize; i++){
              searchPlaceholder = searchPlaceholder.replace("xxx", ` ${selectSize[i].getAttribute("value")} `);
              if(!searchPlaceholder.includes("xxx")){
                updatePriceSelectSize(searchPlaceholder, i, mutation);
              }
            }
        }
    }
  };

  const config = { attributes: true, childList: true, subtree: true };
  const targetNode = document.getElementsByClassName('custom-select__options');
  const observer = new MutationObserver(callback);

  for(tar of targetNode){
    observer.observe(tar, config);
  }
})();

/**
 * If the template is "Complete pack" find a default color and select it from the given colors (list of HTMLElements).
 */
(function(){
  function findCommonOptions(products){
    const options = [];
    for(let j = 0; j < products[0].length ;j++ ){
      let foundName = true;
      const option = products[0][j];
      for(let i = 1; i < products.length; i++){
        let foundNameCurrentArray = false;
        for(let k = 0; k < products[i].length; k++){
          if(option.name === products[i][k].name){
            foundNameCurrentArray = true;
            break;
          }
        }
        if(!foundNameCurrentArray){
          foundName = false;
          break;
        }
      }
      if(foundName) options.push(option.name);
    }
    return options;
  }
  function getProducts($container){
    if(!$container.getAttribute("product-1-options")) return;
    option_1 = JSON.parse($container.getAttribute("product-1-options"));
    option_2 = JSON.parse($container.getAttribute("product-2-options"));
    return [option_1,option_2];
  }

  function mergeOptions(product){
    const output = [];
    const permute = (arr,value,iteration = 0) =>{
      for(let i = 0; i < arr.values.length; i++){
        let partialValue = iteration === 0 ? arr.values[i] : value + ' / ' + arr.values[i];
        if(iteration === product.length - 1){
          output.push(partialValue);
        }else{
          permute(product[iteration + 1], partialValue, iteration + 1);
        }
      }
      return;
    }

    permute(product[0]);
    return output;
  }

  function getOptions(commonOptions, products){
    const options = [];
    products.forEach( product => {
      options.push(mergeOptions(product));
    });
    return options;
  }

  function getUniqueOptions(options){
    const uniqueOptions = [];

    for(let j = 0; j < options[0].length ;j++ ){
      let foundName = true;
      const optionArr = options[0][j].split('/');
      const option = optionArr.filter((option)=>/\d+x\d+/g.test(option))[0].trim()
      const optionName = optionArr.filter((option)=>/^(?!\d+x\d).*$/g.test(option))[0].trim()

      for(let i = 1; i < options.length; i++){
        let foundNameCurrentArray = false;

        for(let k = 0; k < options[i].length; k++){
          const optionSelectedArr = options[i][k].split('/');
          const optionSelected = optionSelectedArr.filter((option)=>/\d+x\d+/g.test(option))[0].trim()

          if(option == optionSelected){
            foundNameCurrentArray = true;
            break;
          }
        }

        if(!foundNameCurrentArray){
          foundName = false;
          break;
        }
      }
      if(foundName) uniqueOptions.push(`${optionName} / ${option}`);
    }
    return removeDuplicates(uniqueOptions);
  }
  /** Remove duplicates from array
   * @param {Array} arr - array to remove duplicates
   * @author rgranados
   */
  function removeDuplicates(arr) {
    return arr.filter((item, index) => arr.indexOf(item) === index);
  }
  function getHiddenOptions($customSelect){
    const optionsToHide = [];
    const $hiddenOptionScript = document.querySelector('[data-hidden-options]');
    const strHiddenOptions = JSON.parse($hiddenOptionScript.textContent);
    strHiddenOptions
      .split('|')
      .forEach( hiddenOptions => {
        hiddenOptions
          .split(',')
          .forEach( option =>{
            const [optionName, valueToHide] = option.split('.');
            if($customSelect.id.indexOf(optionName) > -1){
              optionsToHide.push(valueToHide);
            }
          } )
      });
    return optionsToHide;
  }
  function setDomWithProperties($customSelect,commonOptions, products){
    const options = getOptions(commonOptions,products);
    let uniqueOptions = getUniqueOptions(options);
    const hiddenOptions = getHiddenOptions($customSelect);
    if(hiddenOptions?.length > 0){
      uniqueOptions = uniqueOptions.filter( option => {
        for(let i = 0; i < hiddenOptions.length; i++){
          const optionToHide = hiddenOptions[i];
          if(option.indexOf(optionToHide) > -1) return false;
        }
        return true;
      });

    }
    let liItem = document.createElement("li");
    let valueSize = "";
    uniqueOptions.forEach((tailleDraw) =>{
      let li = liItem.cloneNode(true);
      valueSize = `${tailleDraw}-${$customSelect.getAttribute("id").replace("size-select-", "").trim()}`;
      li.setAttribute("value-option-size", valueSize);
      li.setAttribute("value", tailleDraw);
      li.setAttribute("data-option",tailleDraw);
      // li.setAttribute("data-card-option-trigger",'');
      li.classList.add("custom-select__options-option");
      li.innerHTML = tailleDraw;
      $customSelect.appendChild(li);
    })
  }

  function setOptionsInDom(){
    const $customSelects = Array.from(document.querySelectorAll(".custom-select__options"));
    const taille = [];
    $customSelects.forEach($customSelect => {
      const products = getProducts($customSelect) || [];
      if(products.length === 0) return;
      const commonOptions = findCommonOptions(products);
      setDomWithProperties($customSelect,commonOptions,products);
    });

  }
  const isCompletePack = document.querySelectorAll(".complete-pack").length > 0;
  const isPackLiterie = document.getElementById('pack-literie');
  if(isPackLiterie) setOptionsInDom();
  if(isCompletePack){
    const customSelects = document.querySelectorAll(".custom-select__options");
    let option_ref;
    let option_1;
    let option_2;
    for(customSel of customSelects){
      option_ref = String(customSel.getAttribute("product-ref"));
      option_ref = option_ref.split(",");
      option_1 = JSON.parse(customSel.getAttribute("product-1-options"));
      option_2 = JSON.parse(customSel.getAttribute("product-2-options"));
      if(option_1 && option_1[1]?.values){
        let tailles = [];
        let newTailles = [];
        for(let i = 0 ;i < option_1[1].values.length; i++){
          if(option_2[1].values.includes(option_1[1].values[i]) && option_ref.includes(option_1[1].values[i])){
              tailles.push(option_1[1].values[i]);
          }
        }
        if(option_1[0].name === "Confort"){
          for(let i = 0; i < option_1[0].values.length; i++){
            tailles.forEach((t) => {
              newTailles.push(`${option_1[0].values[i]} / ${t}`);
            })
          }
        }else if(option_2[0].name === "Confort"){
          for(let i = 0; i < option_2[0].values.length; i++){
            tailles.forEach((t) => {
              newTailles.push(`${option_2[0].values[i]} / ${t}`);
            })
          }
        }else{
          newTailles = tailles;
        }

        let liItem = document.createElement("li");
        let valueSize = "";
        newTailles.forEach((tailleDraw) =>{
          let li = liItem.cloneNode(true);
          valueSize = `${tailleDraw}-${customSel.getAttribute("id").replace("size-select-", "").trim()}`;
          li.setAttribute("value-option-size", valueSize);
          li.setAttribute("value", tailleDraw);
          li.setAttribute("data-option",tailleDraw);
          li.classList.add("custom-select__options-option");
          li.innerHTML = tailleDraw;
          customSel.appendChild(li);
        })
      }
    }
  }
})();


/**
 * Custom select listeners
 */
 (function(){
  const select = document.querySelectorAll('.custom-select__label');
  const options = document.querySelectorAll(".custom-select__options-option");
  const unavailableWarnMsg = document.querySelector("[data-color-container]");
  let customSelects;

  for(sel of select){
      sel.addEventListener('click', function(){
        customSelects = document.querySelectorAll(".custom-select__options:not(.hidden)");
        this.nextElementSibling.classList.toggle('hidden');
          for(customSel of customSelects){
            customSel.classList.add("hidden");
          }
      });
  }
  const isPackLiterie = document.getElementById('pack-literie');
  for(opt of options){
      opt.addEventListener('click', function(){
        const options = document.querySelectorAll(".custom-select__options-option");
        for(option of options){
          option.classList.remove("selected");
        }
        this.classList.add("selected");
          this.parentNode.setAttribute("value", this.getAttribute("value"));
          this.parentNode.classList.add('hidden');
          let text = this.getAttribute("value");
          if(this.getAttribute("value").includes("Mi-ferme") || this.getAttribute("value").includes("Moelleux")){
           this.parentNode.previousElementSibling.parentNode.style.minWidth = "fit-content";
           this.parentNode.previousElementSibling.parentNode.previousElementSibling.style.width = "auto";
           if(!isPackLiterie){
             this.parentNode.previousElementSibling.parentNode.children[0].classList.add("extended");
           }else{
            this.parentNode.previousElementSibling.parentNode.children[0].style.width = 'fit-content';
           }
          }
          this.parentNode.previousElementSibling.children[0].innerHTML = text;
          if(this.getAttribute("disabled") === ""){
            unavailableWarnMsg.children[0].style.display = "block";
          }else{
            unavailableWarnMsg.children[0].style.display = "none";
          }

          if(isPackLiterie){
            shop.cleanVariants();
            setCurrentPropertiesToAddToCart({});
            const variants = shop.toArray();
            parseUrl(variants);
          }
      });
  }
})();

/**
 * Find default variant on metafields and click it on the item (color and only complete-pack template)
 */
(function(){
  if(document.getElementsByClassName("complete-pack").length || document.getElementsByClassName("product-bundle bain").length){
    document.addEventListener("DOMContentLoaded", function(){
      let selectedVariant = document.querySelector("[selected-variant]");
      const colors = document.getElementsByClassName("variants-container-parure")[0].children;
      selectedVariant = selectedVariant.getAttribute("selected-variant");
      selectedVariant = selectedVariant.split("|");
      selectedVariant = selectedVariant[0].split(",")[0].replace("Color.", "").trim();
			let colorsSelected = document.getElementsByClassName("selected");
      setTimeout(() => {
        for(color of colors){
          if(color.getAttribute("data-name") && color.getAttribute("data-name") === selectedVariant){
            if(!colorsSelected.length > 0){
              color.children[0] && color.children[0].click();
            }
          }
        }
      }, 400)
    });
  }
})();

/**
 * update url taking account the current variants, it take the products tha are
 * in the tag in the current product
 */
(function() {

  let colorSelected = null;

  const getData = ()=>{
    const products = document.querySelectorAll("[data-card-json]");
    const data = [];
    for(let i=0 ; i < products.length ; i++){
      data.push(JSON.parse(products[i].textContent));
    }
    return data;
  }

  function getDataCurrentProduct(){
    const currentProduct = document.querySelector("[data-product-json]");
    return JSON.parse(currentProduct.textContent) || [];
  }

  const productsJson = getData();
  const currentProduct = getDataCurrentProduct();

  const hasOption = (options, value)=>{
    for(option of options){
      if(option.toUpperCase() == value)return true;
    }
    return false;
  }

  const getObjectOptions = (options)=>{
    let objOptions = {};
    options.forEach((option, index) => {
      if(option) objOptions[option.toUpperCase()]=index;
    });
    return objOptions;
  }

  const callback = function(mutationsList) {
    for(const mutation of mutationsList) {
      const isBundlePyjama = Boolean(document.querySelector('[bundle-pyjama]'));
        if (mutation.type === 'attributes' && mutation.attributeName === "class") {
          let properties = {};
          const parentContainer = document.querySelector(".variants-container-parure");
          let productItems = parentContainer.getAttribute("products-items");
          let selectedSizePlaceholder = "xxx / xxx";
          const isParureSize = parentContainer.getAttribute("parure-bain-size") || false;
          productItems = JSON.parse(productItems);
          productItems = productItems?.filter(el => el.length != 0);
          const selected = document.getElementsByClassName("swatch-color selected")[0];
          const selectedName = selected.getAttribute("data-product-name");
          const itemsLength = productItems.length;
          let sizeSelects;

          sizeSelects = document.getElementsByClassName("variant selected");
          Array.from(sizeSelects).forEach((item, index) => {
            let selectedValue = item.getAttribute("value");
            if(selectedValue != 'Pantalon (unisexe)'
              && selectedValue != 'Short (femme)'
            ){
              selectedSizePlaceholder = selectedSizePlaceholder.replace("xxx", selectedValue);
            }
          });
          const optionsWithValues = searchOptionWithValues(selectedSizePlaceholder);
          const priceSpan = document.querySelector("[data-checkout-text]");
          const priceTitle = document.querySelector("[data-bundle-price]");
          let previousButtonText = priceSpan.innerHTML.split(" - ");
          if(optionsWithValues){
            const priceCalculation = `${Math.ceil(1 * (optionsWithValues.getAttribute("data-product-price") / 100))},00€`
            previousButtonText[1] = priceCalculation;
            const newButtonText = previousButtonText.join(" - ");
            priceSpan.innerHTML = newButtonText;
            priceTitle.innerHTML = priceCalculation;
          }
        }
        const unavailableWarning = Array.from(document.getElementsByClassName('unavailable selected'));
        const textVariantUnavailable = document.querySelector('[data-variant-unavailable]');
        if(unavailableWarning?.length > 0){
          textVariantUnavailable.style.display = "block";
        }else{
          textVariantUnavailable.style.display = "none";
        }
    }
  };

  const config = { attributes: true, childList: true, subtree: true };
  const targetNode = document.getElementsByClassName('variants-container');
  const observer = new MutationObserver(callback);

  for(tar of targetNode){
    observer.observe(tar, config);
  }




  function findVariants(){
    //put global-option property to all elements who are global options
    const globalOptionsElements = Array.from(document.querySelectorAll('[global-option]'));
    const globalOptions = {};
    const variants = [];

    globalOptionsElements.forEach(element => {
      const property = element.dataset.optionContainer;
      const value = element.getElementsByClassName("selected")[0].dataset.name;
      globalOptions[property] = value;
    });

    productsJson.forEach( product => {
      const optionsObjectPositions = {};
      product.options.forEach((option, index) => {
        if(option){
          optionsObjectPositions[option] = index;
        }
      });
      const currentOptions = Object.assign({}, globalOptions);
      const  optionContainer = document.getElementById(`size-select-${product.title}`);
      const optionContainerChildren = Array.from(optionContainer.querySelectorAll('[data-option-container]'));
      optionContainerChildren.forEach(element => {
        const property = element.dataset.optionContainer;
        const value = element.getElementsByClassName("selected")[0].dataset.option;
        currentOptions[property] = value;
      })

      product.variants.forEach(variant => {
        let addVariant = false;
        for(const [key, value] of Object.entries(currentOptions)){
          if(variant.options[optionsObjectPositions[key]] == value ){
            addVariant = true;
          }else {
            addVariant = false;
            break;
          }
        }

        if(addVariant) variants.push(variant);
      });

    });
    return variants;
  }

  const findVariantsParure = ()=>{
    const ATRR_1 = "value"
    const ATRR_2 = "id"
    const products = [];
    const variants = [];
    const OPTION_1 = "COLOR"
    const OPTION_2 = "TAILLE"
    const OPTION_3 = "CONFORT"
    const dataCards = document.querySelectorAll("[data-card]");
    const exceptions = JSON.parse(
      document.getElementsByClassName('variants-container-parure')[0]
      .getAttribute("products-exception")
    );
    let exception;
    if(exceptions){
      for(let i = 0; i < exceptions.length; i++){
        if(exceptions[i].secondaryColor == colorSelected){
          exception = exceptions[i];
          break;
        }
      }
    }

    for(dataCard of dataCards){
      const urlTagValue = dataCard.getElementsByTagName('ul')[0].getAttribute(ATRR_1);
      const urlTagId = dataCard.getElementsByTagName('ul')[0].getAttribute(ATRR_2);
      products.push({urlTagValue, urlTagId});
    }
    for(productJson of productsJson){
      for(product of products){
        const objOptions = getObjectOptions(productJson.options);
        for(variant of productJson.variants){
          if(product.urlTagId.indexOf(productJson.title) > -1){
            if(hasOption(productJson.options,OPTION_1)){
              if(exception
                && product.urlTagId.indexOf(exception.productName) > -1
                && variant.title.indexOf(exception.primaryColor) > -1
                && product.urlTagValue.indexOf(variant.options[objOptions[OPTION_2]]) > -1
                ){
                  variants.push(variant);
                  break;
              }
              else {
                if(variant.options[objOptions['COLOR']].trim().toLowerCase() === colorSelected.trim().toLowerCase()
                && product.urlTagValue.indexOf(variant.options[objOptions[OPTION_2]]) > -1
                ){
                  variants.push(variant);
                  break;
                }
              }
            } else if(hasOption(productJson.options,OPTION_3)){
              if(product.urlTagValue.indexOf(variant.options[objOptions[OPTION_2]]) > -1
                && product.urlTagValue.indexOf(variant.options[objOptions[OPTION_3]]) > -1
              ){
                variants.push(variant);
                break;
              }
            }
          else {
            if(( product.urlTagValue.indexOf(variant.options[objOptions[OPTION_2]]) > -1 )){
              variants.push(variant);
              break;
            }
            }
          }
        }
      }
    }
    return variants;

  }


  const parseUrlParams = ()=>{
    let products = [];
    const globalOptionsElements = Array.from(document.querySelectorAll('[global-option]'));
    if(globalOptionsElements?.length > 0){
      products = findVariants();
    }else{
      products = findVariantsParure();
    }

    let newurl;
    let seachParams , pathname;
    let textAbTest = "";
    let  firstChar = "?";
    pathname = window.location.pathname;
    if (window.location.search.indexOf("view=") > -1) {
      let positionView = window.location.search.indexOf("view=");
      textAbTest = "?" + window.location.search.slice(positionView);
      seachParams = window.location.search.replace(textAbTest,'')
    } else if(window.location.search == ''
      && window.location.pathname.indexOf("view=") > -1
    ){
      let positionView = window.location.pathname.indexOf("view=");
      textAbTest = "&" + window.location.pathname.slice(positionView);
      pathname = window.location.pathname.replace(textAbTest,'')
    }
    newurl =window.location.protocol +
    "//" + window.location.host
    + pathname;

    for (let i = 0; i < products.length; i++) {
    let product = products[i];
      if (product) {
        newurl += firstChar + "option" + i + "=" + product.id;
        firstChar = "&";
      }
    }
    const urlParams = new URLSearchParams(window.location.search);
    let urlModalParam = '';

    if (urlParams.get('modal') && !window.isAbTest) {
      window.isAbTest = true;
    }

    if(urlParams.get("type")){
      window.hasTypeAbTest = true;
    }

    if(window.isAbTest) {
      urlModalParam = '&modal=cross';
    }

    if(window.hasTypeAbTest) {
      urlModalParam = + '&type=color';
    }

    newurl = newurl + urlModalParam + textAbTest;
    window.history.replaceState({ path: newurl }, "", newurl);

  }


  const updateUrl = ()=>{
    parseUrlParams();

  }


  document.addEventListener("DOMContentLoaded", function(){
    const isPackLiterie = document.getElementById('pack-literie');
    const globalOptionsElements = Array.from(document.querySelectorAll('[global-option]'));
    if(globalOptionsElements?.length > 0){
      const elementsTrigger = Array.from(document.querySelectorAll("[data-card-option-trigger]"));
      const colorContainers = document.getElementsByClassName("swatch-color__icon");
      const globalContainer = document.querySelector("[data-global-container]");
      elementsTrigger.forEach( elementTriggerEvent => {
        elementTriggerEvent.addEventListener("click", function(e){
          const parentContainer = Array.from(e.target.closest('[class*=variants-container]').children);
          parentContainer.forEach( child => {
            child.classList.remove("selected");
            if(child == e.target ||
              child.children[0] == e.target){
              child.classList.add("selected");
            }
          });
          updateUrl();
        });
      });
    }else {
      const dataCards = document.querySelectorAll("[data-card]");
      const colorContainers = document.getElementsByClassName("swatch-color__icon");
      const globalContainer = document.querySelector("[data-global-container]");
      if(globalContainer && !isPackLiterie){
        colorSelected = document.querySelector("[data-global-container]").dataset.colorSelected;
      }
      if(Boolean(globalContainer) && !isPackLiterie){
        for(colorTag of colorContainers){
          colorTag.addEventListener("click", function(e){
            colorSelected = e.target.parentNode.dataset.name;
            updateUrl();
          });
        }
        for(dataCard of dataCards){
          const urlTag = dataCard.getElementsByTagName('ul')[0];
          urlTag.addEventListener("click", function(e){
            updateUrl();
          });
        }
      }
    }

  })

  function findAvailableItems(obj){
    let typeContainer;
    let typeValue;
    let colorContainer;
    let color;
    if(obj.hasOwnProperty('color')){
      color = obj.color;
      typeContainer = document.querySelector('[data-option-container="Type"]');
      typeValue = typeContainer.getElementsByClassName('selected')[0].getAttribute("value");
    }else if(obj.hasOwnProperty('type')){
      typeValue = obj.type;
      colorContainer = document.getElementsByClassName('variants-container-parure')[0];
      color = colorContainer.getElementsByClassName('selected')[0].dataset.option;
    }
    productsJson.forEach((product,index)=>{
      let optionsObject = {};
      product.options.forEach((option, pos) => {
        optionsObject[option] = pos;
      });
      const dataContainer = document.getElementById(`size-select-${product.title}`);
      const dataCards = Array.from(dataContainer.querySelectorAll('[data-option-container]'));
      for(let i = 0; i < dataCards.length; i++){
        const optionName = dataCards[i].dataset.optionContainer;
        if(optionName == 'Type') continue;
        const dataOptions = Array.from(dataCards[i].querySelectorAll('[data-option]'));
        for(let k = 0; k < dataOptions.length; k++){
          const optionValue = dataOptions[k].dataset.option;
          for(let j = 0 ; j < product.variants.length; j++){
            let variant = product.variants[j];
            let foundVariant = false;
            for(let l = 0; l < variant.options.length; l++){
              if( l == optionsObject.Color ||
                variant.options[optionsObject.Color] != color ||
                (variant.options[optionsObject?.Type] != typeValue
                  && variant.options[optionsObject?.Type] != undefined)
              ) continue;
              if(variant.options[optionsObject.Color] == color
                && variant.options[optionsObject[optionName]] == optionValue
                ){
                  foundVariant = true;
              }else{
                foundVariant = false;
                break;
              }
            }
            if(foundVariant){
              if(variant.available){
                dataOptions[k].classList.remove("unavailable");
              } else{
                dataOptions[k].classList.add("unavailable");
              }
              break;
            }
          }
        }
      }
    });
  }

  function getObjectIndex(productItem){
    const objOutput = {};
    for(let i = 0; i < productItem.options.length; i++){
      let key = productItem.options[i];
      objOutput[key] = i;
    }
    return objOutput;
  }

  function getVariantsByOption(optionName,value){
    let productsFiltered = [];
    productsJson.forEach( item => {
      let optionPositions = getObjectIndex(item);
      productsFiltered = item.variants.filter( variant => {
        return variant.options[optionPositions[optionName]] == value;
      });
    });
    return productsFiltered;
  }

  function getProductsItems(id){
    let variantsArray = [];
    productsJson.forEach( item => {
      if(id.indexOf(item.title) > -1){
        variantsArray.push({
          productName: item.title,
          optionsName: item.options,
          optionsPositions : getObjectIndex(item),
          variants: item.variants,
        });
      }
    });
    return variantsArray;
  }

  function  notifyWarning(option, id ,color){
    option.classList.add('unavailable');
    option.addEventListener('click',function(e){
      validateWarning(color);
      containerWarnings = document.querySelector('[data-unavailable-items]');
      dataUnavailableItems = JSON.parse(containerWarnings.dataset.unavailableItems || '{}');
      if(!dataUnavailableItems.hasOwnProperty(id)) dataUnavailableItems[id] = id;
        containerWarnings.dataset.unavailableItems = JSON.stringify(dataUnavailableItems);
        const alertUnavailable = document.querySelector('[data-variant-unavailable]');
        alertUnavailable.style.display='block';
    });
  }

  function createStringToSearch(labels,optionValue, index){
    let str = '';
    for(let i = 0; i < labels.length; i++){
      if(index == i & i== 0 ){
        str = optionValue;
      }else if(index == i){
        str =  str + ' / ' + optionValue;
      }else if(index != i && i == 0) {
        str = labels[i];
      }else{
        str =  str + ' / ' + labels[i];
      }
    }

    return str;
  }


  function bundleExists(optionValue, index){
    try {
      let selectedLabelsContainer = Array.from(document.getElementsByClassName('custom-select__label'));
      let labels = [];

      selectedLabelsContainer.forEach( labelTag => {
        let label = labelTag.getElementsByTagName('p')[0].innerText;
        labels.push(label.trim());
      });
      // let stringToSearch = createStringToSearch(labels,optionValue, index);
      for(let i = 0; i <currentProduct.variants.length; i++){
        let stringVariant = currentProduct.variants[i].options[index].trim();
        if(stringVariant == optionValue)
          return true;
      }
      return false;
    } catch (error) {
      console.log(error);
      return false;
    }
  }

  function validateCurrentCombination(color){
    let output = false;
    try {
      let prevColor = color;
      let isBundleSize = Boolean(document.querySelector('[perure-bundle-size-expections]'));
      const colorsContainer = document.querySelector(".variants-container-parure");
      let productException = JSON.parse(colorsContainer.getAttribute("products-exception")) || [];
      let containerWarnings = document.querySelector('[data-unavailable-items]');
      let dataUnavailableItems = JSON.parse('{}');
      containerWarnings.dataset.unavailableItems = JSON.stringify(dataUnavailableItems);
      const optionsContainer = Array.from(document.querySelectorAll(`[id*="size-select-"]`));
      for(let index = 0; index < optionsContainer.length; index ++){
        let container = optionsContainer[index];
        let optionValidated = false;
        const id = container.getAttribute('id');
        const productsToParse = getProductsItems(id);
        const currentOption = container.getAttribute('value');
        for(let productIndex = 0; productIndex < productsToParse.length; productIndex++) {
          let currentProduct = productsToParse[productIndex];
          const variants = currentProduct.variants;
          let options = currentProduct.optionsPositions;
          if(isBundleSize){
            let foundAlternativeColor = false;
            productException.forEach( exception => {
              if(exception.productName.trim() == currentProduct.productName.trim()
                && exception.secondaryColor == prevColor){
                color = exception.primaryColor;
                foundAlternativeColor = true;
              }
            });
            if(!foundAlternativeColor) color = prevColor;
          }
          for(let i = 0; i < variants.length ; i++){
            let option1 = options.hasOwnProperty('Color') ? color : variants[i].option1;
            if((variants[i].option1 == option1 && variants[i].options[options.Taille] == currentOption)
              || (variants[i].option1 + ' / ' +  variants[i].options[options.Taille] == currentOption)){
                optionValidated = true;
                if(variants[i].available){
                  output = true;
                  containerWarnings = document.querySelector('[data-unavailable-items]');
                  dataUnavailableItems = JSON.parse(containerWarnings.dataset.unavailableItems);
                  if(dataUnavailableItems.hasOwnProperty(id)) delete dataUnavailableItems[id];
                  containerWarnings.dataset.unavailableItems = JSON.stringify(dataUnavailableItems);
                  const alertUnavailable = document.querySelector('[data-variant-unavailable]');
                  if(Object.keys(dataUnavailableItems).length > 0){
                    alertUnavailable.style.display='block';
                  }else{
                    alertUnavailable.style.display='none';
                  }
                }else {
                  containerWarnings = document.querySelector('[data-unavailable-items]');
                  dataUnavailableItems = JSON.parse(containerWarnings.dataset.unavailableItems || '{}');
                  if(!dataUnavailableItems.hasOwnProperty(id)) dataUnavailableItems[id] = id;
                    containerWarnings.dataset.unavailableItems = JSON.stringify(dataUnavailableItems);
                    const alertUnavailable = document.querySelector('[data-variant-unavailable]');
                    alertUnavailable.style.display='block';
                  return false;
                }
            }
          }
        };
        if(!optionValidated){
          containerWarnings = document.querySelector('[data-unavailable-items]');
          dataUnavailableItems = JSON.parse(containerWarnings.dataset.unavailableItems || '{}');
          if(!dataUnavailableItems.hasOwnProperty(id)) dataUnavailableItems[id] = id;
            containerWarnings.dataset.unavailableItems = JSON.stringify(dataUnavailableItems);
            const alertUnavailable = document.querySelector('[data-variant-unavailable]');
            alertUnavailable.style.display='block';
          return false;
        }
      };
    } catch (error) {
      return false;
    }
    return true;
  }

  function validateWarning(color){
    let _alertUnavailable = document.querySelector('[data-variant-unavailable]');
    if(!validateCurrentCombination(color)){
      _alertUnavailable.style.display='block';
    }else{
      _alertUnavailable.style.display='none'
    }
  }
  /**
   * this function allow set available options in products parure
   * @param {property} property
   *
   */
  function findAvailableItemsParure({color}) {
      let prevColor = color;
      let isBundleSize = Boolean(document.querySelector('[perure-bundle-size-expections]'));
      const colorsContainer = document.querySelector(".variants-container-parure");
      let productException = JSON.parse(colorsContainer.getAttribute("products-exception")) || [];
      let containerWarnings = document.querySelector('[data-unavailable-items]');
      let dataUnavailableItems = JSON.parse('{}');
      containerWarnings.dataset.unavailableItems = JSON.stringify(dataUnavailableItems);
      validateWarning(prevColor);
      const optionsContainer = Array.from(document.querySelectorAll(`[id*="size-select-"]`));
      optionsContainer.forEach( (container,index) => {
        const id = container.getAttribute('id');
        const productsToParse = getProductsItems(id);
        const optionsProduct = Array.from(container.querySelectorAll('[data-option]'));
        let optionToClick = null;
        for(let optionIndex = 0; optionIndex < optionsProduct.length; optionIndex++){
          let option = optionsProduct[optionIndex];
          let optionValidated = false;
          const optionValue = option.dataset.option;
          if(!bundleExists(optionValue,index)){
            optionValidated = true;
            // notifyWarning(option,id,event);
            option.style.display = 'none';
            continue;
          }else{
            option.style.display = 'block';
          }
          const optionSelected = container.previousElementSibling
                                .getElementsByTagName('p')[0].innerText;
          if(optionSelected == optionValue ) optionToClick = option;
          let optionUnavailable = false;
          productsToParse.forEach( currentProduct => {
            const variants = currentProduct.variants;
            let options = currentProduct.optionsPositions;
            if(isBundleSize){
              let foundAlternativeColor = false;
              productException.forEach( exception => {
                if(exception.productName.trim() == currentProduct.productName.trim()
                  && exception.secondaryColor == prevColor){
                  color = exception.primaryColor;
                  foundAlternativeColor = true;
                }
              });
              if(!foundAlternativeColor) color = prevColor;
            }
            for(let i = 0; i < variants.length ; i++){
              let option1 = options.hasOwnProperty('Color') ? color : variants[i].option1;
              if((variants[i].option1 == option1 && variants[i].options[options.Taille] == optionValue)
                || (variants[i].option1 + ' / ' +  variants[i].options[options.Taille] == optionValue)){
                optionValidated = true;
                if(variants[i].available && !optionUnavailable ){
                  option.classList.remove('unavailable');
                  option.addEventListener('click',function(e){
                    validateWarning(prevColor);
                    containerWarnings = document.querySelector('[data-unavailable-items]');
                    dataUnavailableItems = JSON.parse(containerWarnings.dataset.unavailableItems);
                    if(dataUnavailableItems.hasOwnProperty(id)) delete dataUnavailableItems[id];
                    containerWarnings.dataset.unavailableItems = JSON.stringify(dataUnavailableItems);
                    const alertUnavailable = document.querySelector('[data-variant-unavailable]');
                    if(Object.keys(dataUnavailableItems).length > 0){
                      alertUnavailable.style.display='block';
                    }else{
                      alertUnavailable.style.display='none';
                    }
                  });
                  break;
                 } else {
                  optionUnavailable = true;
                  notifyWarning(option,id, color);
                  break;
                 }
              }
            }
          });
          if(!optionValidated){
            notifyWarning(option,id ,color);
           }
        };
      });
  }

  document.addEventListener("DOMContentLoaded", function(){
    const parentContainer = document.querySelector(".variants-container-parure");
    let productException = JSON.parse(parentContainer.getAttribute("products-exception"));
    const colorContainer = document.getElementsByClassName('variants-container-parure')[0];
    const colorsArray = Array.from(colorContainer?.getElementsByClassName('swatch-color__icon'));
    const isParure = Boolean(document.querySelector('[parure-bundle-size]'));
    const isBundlePyjama = Boolean(document.querySelector('[bundle-pyjama]'));

    if(colorsArray?.length > 0 && isParure){
      colorsArray.forEach( color =>{
        color.addEventListener('click', function(e){
          findAvailableItemsParure({'color':e.target.dataset.option});
        })
      });
    }else if(isBundlePyjama){
      for(let i = 0; i < colorsArray.length; i++){
        colorsArray[i].addEventListener('click', function(e){
          const color = e.target.parentNode.dataset.option;
          findAvailableItems({'color':color});
        });
      }
      const typeContainer = document.querySelector('[data-option-container="Type"]');
      const typeValue = Array.from(typeContainer.querySelectorAll('[data-option]'));
      typeValue.forEach(typeOption => {
        typeOption.addEventListener('click', function(e){
          const tp = e.target.dataset.option;
          findAvailableItems({'type':tp});
        });
      });
    }
  });
})();

(function(){
  const broderieProduct = document.getElementById("broderiev2-container");
  const broderieContainer = document.getElementsByClassName("product__info flex")[0];
  if(!broderieContainer) return;
  broderieProduct.dataset.hasBroderie
  ? broderieContainer.style.display = "block"
  : broderieContainer.style.display = "none";
})()

function searchSku(productItems, selectedName, selectSizeId , i){
  let selectedSize = selectSizeId?.getAttribute("value");
  for(let k = 0; k < productItems[i].length; k++){
    if(productItems[i][k].color == selectedName
      && productItems[i][k].size == selectedSize
      ){
        return productItems[i][k].available ? productItems[i][k]: null;
    }
  }
}


function setPropertiesWithExceptions(properties, productItems, selectedName, exception){
  try {
    let color;
    let selectSizeId;
    for(let i = 0; i < productItems.length; i++){
      if(productItems[i].length > 0 ){
        selectSizeId = document.querySelector(`[id*="${productItems[i][0].product_name}"]`);
          if(exception[0] && productItems[i][0].product_name == exception[0].productName){
            color = exception[0].primaryColor;
          } else {
            color = selectedName;
          }
          properties[productItems[i][0].product_name] = color + " / " + selectSizeId?.getAttribute("value");
          let tempSKU = searchSku(productItems, color, selectSizeId ,i);
          properties["_handle:" + productItems[i][0].product_name] = productItems[i][0].handler;
          properties["_SKU " + productItems[i][0].product_name] = tempSKU.sku;
          properties["_quantity:" + productItems[i][0].product_name] = productItems[i][0].quantity;
        }
      }
  } catch (error) {
    Object.keys(properties).forEach(key => delete properties[key]);
    console.log(error);
  }
}
/**
 * this function add to cart for parure unify products, this prodcuts have exceptions in they colors
 */
function addToCartWithException(){
  let properties = {};
  const parentContainer = document.querySelector(".variants-container-parure");
  let productItems = parentContainer.getAttribute("products-items");
  const isParureSize = parentContainer.getAttribute("parure-bain-size") || false;
  let productException = JSON.parse(parentContainer.getAttribute("products-exception"));
  let selectedSizePlaceholder = "xxx / xxx / xxx";
  productItems = JSON.parse(productItems);
  productItems = productItems?.filter(el => el.length != 0);
  const selected = document.getElementsByClassName("swatch-color selected")[0];
  const selectedName = selected.getAttribute("data-product-name");
  const itemsLength = productItems.length;
  const sizeSelects = document.getElementsByClassName("size-select__select");
  Array.from(sizeSelects).forEach((item, index) => {
    selectedSizePlaceholder = selectedSizePlaceholder.replace("xxx", item.getAttribute("value"));
  });
  let optionBySizes = searchOptionWithValues(selectedSizePlaceholder);
  const exception = productException.filter(exc => exc.secondaryColor === selectedName);
  for(let i = 0; i < itemsLength; i++){
    productItems[i] = productItems[i].filter((item) => {
      if(
        exception.length > 0
        && exception[0].primaryColor == item.color
        && exception[0].productName == item.product_name
        && exception[0].secondaryColor == selectedName
        ){
        return true;
      }
      return item.color === selectedName
    });
  }
  const itemsFilteredLength = productItems.length;
  properties = {
    id: optionBySizes.getAttribute("value"),
    quantity: 1
  }
  setPropertiesWithExceptions(properties, productItems, selectedName, exception);
  // setProperties(properties, itemsFilteredLength, productItems, false, selectedName)
  const unavailableWarnMsg = document.querySelector("[data-color-container]");
  if(!unavailableWarnMsg || unavailableWarnMsg.children[0].style.display == "none"){
    addProduct(properties);
  }
}

/**
 * this function update the price on the buttom add to cart when is a bundle
 * a have quantity selector
 */

(function (){

  document.addEventListener("DOMContentLoaded", function(e){
    const isBundleWithQuantity = document.querySelector('[bundle-with-quantity]') || null;
    if(isBundleWithQuantity){
      const infoProductContainer = document.querySelector('[data-product-json]');
      const infoProduct = JSON.parse(infoProductContainer.textContent);
      const selectorQuantity = document.querySelector('[data-product-quantity]');
      const colorsContainer = document.getElementsByClassName('variants-container-parure')[0];
      const colorSelected = colorsContainer.getElementsByClassName('selected')[0].dataset.name;
      selectorQuantity.addEventListener('change', function(event){
        const currentVariant = infoProduct.variants.find( variant => variant.option1 == colorSelected );
        let currentPrice = Math.ceil(currentVariant.price / 100 * event.target.value) + ',00€';
        const checkoutText = document.querySelector('[data-checkout-text]');
        const priceText = document.querySelector('[data-bundle-price]');
        let previousButtonText = checkoutText.innerHTML.split(" - ");
        let newButtonText = previousButtonText[0] + ' - ' + currentPrice;
        checkoutText.innerHTML = newButtonText;
        priceText.innerHTML = currentPrice;
      });
    }
  });

})()

const parseUrl = (products = [])=>{
  let newurl;
  let seachParams , pathname;
  let textAbTest = "";
  let  firstChar = "?";
  pathname = window.location.pathname;
  if (window.location.search.indexOf("view=") > -1) {
    let positionView = window.location.search.indexOf("view=");
    textAbTest = "&" + window.location.search.slice(positionView);
    seachParams = window.location.search.replace(textAbTest,'')
  } else if(window.location.search == ''
    && window.location.pathname.indexOf("view=") > -1
  ){
    let positionView = window.location.pathname.indexOf("view=");
    textAbTest = "&" + window.location.pathname.slice(positionView);
    pathname = window.location.pathname.replace(textAbTest,'')
  }
  newurl =window.location.protocol +
  "//" + window.location.host
  + pathname;

  for (let i = 0; i < products.length; i++) {
  let product = products[i];
    if (product) {
      newurl += firstChar + "option" + i + "=" + product.id;
      firstChar = "&";
    }
  }
  const urlParams = new URLSearchParams(window.location.search);
  let urlModalParam = '';

  if (urlParams.get('modal') && !window.isAbTest) {
    window.isAbTest = true;
  }

  if(urlParams.get("type")){
    window.hasTypeAbTest = true;
  }

  if(window.isAbTest) {
    urlModalParam = '&modal=cross';
  }

  if(window.hasTypeAbTest) {
    urlModalParam = + '&type=color';
  }

  newurl = newurl + urlModalParam + textAbTest;
  window.history.replaceState({ path: newurl }, "", newurl);

}

class Store{
  constructor(){
    this.db = new Db();
    this.cart = new Cart();
  }
  getDb(){
    return this.db;
  }
  addItemsToCart(variantOptions){
    const bundle = this.db.getEspecificBundle(variantOptions.DomSelections);
    this.bundle = new Bundle(bundle.id,this.db);
    this.cart.add(this.bundle, variantOptions);
  }

}

class Bundle{
  constructor(id,db){
    this.id = id;
    this.addProducts(db);
  }
  addProducts(db){
    this.products = db.data.map( product => new Product(product));
  }

  getVariants(props){
    return this.products.map( product => product.getVariant(props))
  }
}

class Product{
  constructor(data){
    this.info = data;
    this._getOptionsPositions(data);
    this.variants = data.variants.map( variant => new Variant(variant));
  }
  getVariant(props){
    return this.variants.find( variant => {
      let foundVariant = true;
      for(const [key, value] of Object.entries(props)){
        if(!variant.data.options[this.optionsPosition[key]]) continue
        if(!(variant.data.options[this.optionsPosition[key]] === value )){
          foundVariant = false;
          break;
        }
      }
      return foundVariant;
    }) || null;
  }
  _getOptionsPositions(product){
    const output ={};
    for(let i = 0; i < product.options.length ; i++){
      output[product.options[i]] = i;
    }
    this.optionsPosition = output;
  }
}

class Variant{
  constructor(variant){
    this.data = variant;
  }
}

class Db {
  selectors ={
    cardJson: '[data-card-json]',
    bundleJson: '[data-product-json]'
  }
  constructor(){
    let $cardJson = Array.from(document.querySelectorAll(this.selectors.cardJson));
    this.data = $cardJson.map( product => JSON.parse(product.textContent));
    if(!this.data) this.data = [];
    this.getBundle();
  }
  getBundle(){
    const $mainProduct = document.querySelector(this.selectors.bundleJson);
    this.bundles = JSON.parse($mainProduct.textContent);
  }

  getEspecificBundle(props){
    this._getOptionsPositions(this.bundles);
    return this.bundles.variants.find( bundle => {
      let foundVariant = true;
      for(const [key, value] of Object.entries(props)){
        if(!bundle.options[this.optionsPosition[key]]) continue
        if(!(bundle.options[this.optionsPosition[key]] === value )){
          foundVariant = false;
          break;
        }
      }
      return foundVariant;
    });
  }

  _getOptionsPositions(bundle){
    const output ={};
    for(let i = 0; i < bundle.options.length ; i++){
      output[bundle.options[i]] = i;
    }
    this.optionsPosition = output;
  }
}

class Cart{
  add(bundle, variantOptions){
    this.data = {};
    const variants = bundle.products.map(product => ({product:product.info,variant:product.getVariant(variantOptions.currentOptions)}))
    this._setItemsProps(variants, variantOptions.quantities);
    this.data['id'] = bundle.id;
    this.data['quantity'] = variantOptions.quantities.bundleQuantity;
    addProduct(this.data);
  }
  _setItemsProps(items,{productsQuantity:quantity}){
    const productsToException = ['Serviettes de table x2'];
    try{
      items.forEach(info => {
        if(!info.variant.data.available) throw new Error('Item ' + info.variant.data.title + ' unavailable');
        const productName = info.product.title;
        this.data[productName] = info.variant.data.title;
        this.data['_handle:' + productName ] = info.product.handle;
        this.data['_SKU ' + productName ] = info.variant.data.sku;
        this.data['_quantity:' + productName ] = quantity[info.product.handle];
      })
    }catch(err){
      Object.keys(this.data).forEach(key => delete this.data[key]);
      console.log(err);
    }
  }
}

(function(){

  const dictionary = new Map();
  dictionary.set('6/8 personnes',{Taille:'170x300', quantity:4});
  dictionary.set('4/6 personnes',{Taille:'170x250', quantity:3});

  function findDomOptions(){
    const output = {}
    const DomSelections = {};
    const $variantsContainer = Array.from(document.querySelectorAll('[class*="variants-container"]'));
    const  $dataProductQuantity = document.querySelector('[data-product-quantity]');
    const quantityBundle = $dataProductQuantity.value;
    $variantsContainer.forEach( variantContainer => {
      const $parentContainer = variantContainer.closest('[data-option-container]');
      const option = $parentContainer.dataset.optionContainer;
      const valueSelected = Array.from(variantContainer.querySelectorAll('[data-single-option-trigger]'))
        .filter($elementSelected => $elementSelected.classList.contains('selected'));
      DomSelections[option] = valueSelected[0].dataset.optionValue;
    });
    const currentOptions = {Color:DomSelections['Color'],Taille:dictionary.get(DomSelections["Nombre d'invités"]).Taille}
    const quantities = {
      productsQuantity:{
        'la-nappe':1,
        'serviettes-de-table': dictionary.get(DomSelections["Nombre d'invités"]).quantity
      },
      bundleQuantity:Number(quantityBundle)
    }
    return {DomSelections:DomSelections,currentOptions:currentOptions,quantities:quantities}
  }
  document.addEventListener('DOMContentLoaded', function(e){
    const $container = document.querySelector('[data-bundle-type="bundle-special"]');
    if($container){
      const $buttonSubmit = document.querySelector('[data-add-to-cart]');
      $buttonSubmit.addEventListener('click', function(e){
        const store = new Store();
        const variantOptions = findDomOptions();
        store.addItemsToCart(variantOptions);
      })
    }

  });

  /** Used for bundle Maxi Coussin images slider */
  document.addEventListener('DOMContentLoaded', function(e){
    const isMaxiCoussin = Boolean(document.querySelector('[bundle-maxi-coussin]'));
    if (!isMaxiCoussin) return;

    const colorSwatches = document.querySelectorAll('.swatch-color');
    let bundleMaxiCoussin = new theme.Bundle();
    bundleMaxiCoussin.initImages();

    colorSwatches.forEach((colorSwatch) => {
      colorSwatch.addEventListener('click', (e) => {
        if(e.target.classList.contains("swatch-color__icon")){
          colorSwatches.forEach((colorSwatch) => {
            if(colorSwatch.classList.contains("selected")){
              colorSwatch.classList.remove("selected");
            }
          });

          bundleMaxiCoussin.destroyImageSlider();
          bundleMaxiCoussin.destroyPopupSlider();
          bundleMaxiCoussin.buildImageSlider(e.target.parentNode.getAttribute("data-product-name"));
          bundleMaxiCoussin.buildPopupSlider(e.target.parentNode.getAttribute("data-product-name"));
          e.target.parentNode.classList.add("selected");
          $("[data-variant-text]").text(e.target.parentNode.getAttribute("data-product-name"));
        }
      });
    });
  });
})();

function updateItemsOfBundle() {
  const validateItemsBundle = document.querySelector('[is-bundle-validate-items]');
  const isParureMultiOptions = document.querySelector('[parure-multi-options');
  const variantSelector = document.getElementsByClassName(`swatch-color`)
  if(validateItemsBundle || isParureMultiOptions){
    for(const swatch of variantSelector) {
      swatch.classList.remove("unavailable");
    }
  }
  notifyDomAvailableItemSelected();
}
